import {
    AnalyzeSentimentsSampleSwaggers,
    AnswerQuestionsSampleSwaggers,
    ConversationSummarizationSampleSwaggers,
    DetectLanguageSampleSwaggers,
    HealthcareEntitiesFHIRBundleSwaggers,
    HealthcareEntitiesSampleSwaggers,
    KeyPhrasesSampleSwaggers,
    LinkedEntitiesSampleSwaggers,
    NamedEntityRecognitionSampleSwaggers,
    PIISampleSwaggers,
    SummarizationSampleSwaggers
} from 'src/languageStudio/core/services/signedOutExperience/mockedDemoSwaggers';

export const PIIDemoSamplesJsonOutput: PIISampleSwaggers = {
    'Legal (NDA)': {
        PHIOn: {
            documents: [
                {
                    id: 'id__1843',
                    redactedText:
                        'On the date of *****************, as an employee of ******************, I, ***********, residing in ***************************************, with social security number: 123-45-****, hereby declare to fully support and promote the top priorities delegated to me at ******************, and vow to never disclose any information including but not limited to trade secrets, finances, delivery schedules, and recipes.\n\n        If I, ***********, accidentally or with intent breach the conditions set forth in this contract, understand fully that I shall receive a written termination to the following email address *************************** as well as a fine of up to $10,000.',
                    entities: [
                        { text: '6789', category: 'Address', offset: 177, length: 4, confidenceScore: 0.41 },
                        { text: 'Mateo Gomez', category: 'Person', offset: 75, length: 11, confidenceScore: 0.93 },
                        { text: 'Mateo Gomez', category: 'Person', offset: 429, length: 11, confidenceScore: 0.97 },
                        { text: 'Contoso Restaurant', category: 'Organization', offset: 52, length: 18, confidenceScore: 0.9 },
                        { text: 'Contoso Restaurant', category: 'Organization', offset: 265, length: 18, confidenceScore: 0.6 },
                        { text: 'mateo@contosorestaurant.com', category: 'Email', offset: 611, length: 27, confidenceScore: 0.8 },
                        {
                            offset: 15,
                            length: 17,
                            subcategory: 'Date',
                            confidenceScore: 0.8,
                            category: 'DateTime',
                            text: 'August 17th, 2019'
                        },
                        {
                            length: 39,
                            offset: 100,
                            category: 'Address',
                            confidenceScore: 0.99,
                            text: '1234 Hollywood Boulevard Los Angeles CA'
                        }
                    ],
                    warnings: []
                }
            ],
            errors: []
        },
        PHIOff: {
            errors: [],
            documents: [
                {
                    warnings: [],
                    id: 'id__1671',
                    redactedText:
                        'On the date of *****************, as an ******** of ******************, I, ***********, residing in ***************************************, with social security number: 123-45-****, hereby declare to fully support and promote the top priorities delegated to me at ******************, and vow to never disclose any information including but not limited to trade secrets, finances, delivery schedules, and recipes.\n\n        If I, ***********, accidentally or with intent breach the conditions set forth in this contract, understand fully that I shall receive a written termination to the following email address *************************** as well as a fine of up to $10,000.',
                    entities: [
                        { text: 'employee', category: 'PersonType', offset: 40, length: 8, confidenceScore: 0.95 },
                        { text: 'Mateo Gomez', category: 'Person', offset: 75, length: 11, confidenceScore: 0.93 },
                        { text: 'Contoso Restaurant', category: 'Organization', offset: 52, length: 18, confidenceScore: 0.9 },
                        { text: '6789', category: 'Address', offset: 177, length: 4, confidenceScore: 0.41 },
                        { text: 'Mateo Gomez', category: 'Person', offset: 429, length: 11, confidenceScore: 0.97 },
                        { text: 'Contoso Restaurant', category: 'Organization', offset: 265, length: 18, confidenceScore: 0.6 },
                        { text: 'mateo@contosorestaurant.com', category: 'Email', offset: 611, length: 27, confidenceScore: 0.8 },
                        {
                            offset: 15,
                            length: 17,
                            subcategory: 'Date',
                            category: 'DateTime',
                            confidenceScore: 0.8,
                            text: 'August 17th, 2019'
                        },
                        {
                            length: 39,
                            offset: 100,
                            category: 'Address',
                            confidenceScore: 0.99,
                            text: '1234 Hollywood Boulevard Los Angeles CA'
                        }
                    ]
                }
            ]
        }
    },
    'Email (Review)': {
        PHIOn: {
            documents: [
                {
                    redactedText:
                        'Dear Sir/Madam,\n\n        My name is *********** and I visited Contoso Restaurant with my spouse for our anniversary on *********************. Prior to my visit, I had heard great things about your food and service from my neighbors, as I actually live right down the street from you at ************************. After a lovely stroll along the Santa Monica Pier, we decided to go for dinner at a place we heard so many good things about. When we got to the restaurant *************, we had to wait for 15 minutes just to get on the waiting list. After an hour of waiting to be seated, we ordered two Surf and turf platters. To our absolute surprise, the food was very cold and dry. The whole experience was just quite awful, and I feel like we are owed a refund and an apology for that day. I would appreciate it if you could call me on my number ************.\n        ',
                    id: 'id__2804',
                    entities: [
                        { text: 'Mateo Gomez', category: 'Person', offset: 36, length: 11, confidenceScore: 0.99 },
                        {
                            text: 'Thursday of last week',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 119,
                            length: 21,
                            confidenceScore: 0.8
                        },
                        { text: '1234 Hollywood Boulevard', category: 'Address', offset: 286, length: 24, confidenceScore: 0.98 },
                        { text: 'last Thursday', category: 'DateTime', subcategory: 'Date', offset: 468, length: 13, confidenceScore: 0.8 },
                        { text: '949-555-0110', category: 'PhoneNumber', offset: 847, length: 12, confidenceScore: 0.8 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        },
        PHIOff: {
            documents: [
                {
                    redactedText:
                        'Dear Sir/Madam,\n\n        My name is *********** and I visited Contoso Restaurant with my ****** for our anniversary on *********************. Prior to my visit, I had heard great things about your food and service from my *********, as I actually live right down the street from you at ************************. After a lovely stroll along the Santa Monica Pier, we decided to go for dinner at a place we heard so many good things about. When we got to the restaurant *************, we had to wait for ********** just to get on the waiting list. ************* of waiting to be seated, we ordered two Surf and turf platters. To our absolute surprise, the food was very cold and dry. The whole experience was just quite awful, and I feel like we are owed a refund and an apology for that day. I would appreciate it if you could call me on my number ************.\n        ',
                    id: 'id__2309',
                    entities: [
                        { text: 'Mateo Gomez', category: 'Person', offset: 36, length: 11, confidenceScore: 0.99 },
                        { text: 'spouse', category: 'PersonType', offset: 89, length: 6, confidenceScore: 0.97 },
                        {
                            text: 'Thursday of last week',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 119,
                            length: 21,
                            confidenceScore: 0.8
                        },
                        { text: 'neighbors', category: 'PersonType', offset: 222, length: 9, confidenceScore: 0.92 },
                        { text: '1234 Hollywood Boulevard', category: 'Address', offset: 286, length: 24, confidenceScore: 0.98 },
                        { text: 'last Thursday', category: 'DateTime', subcategory: 'Date', offset: 468, length: 13, confidenceScore: 0.8 },
                        {
                            text: '15 minutes',
                            category: 'DateTime',
                            subcategory: 'Duration',
                            offset: 502,
                            length: 10,
                            confidenceScore: 0.8
                        },
                        {
                            text: 'After an hour',
                            category: 'DateTime',
                            subcategory: 'Duration',
                            offset: 546,
                            length: 13,
                            confidenceScore: 0.8
                        },
                        { text: '949-555-0110', category: 'PhoneNumber', offset: 847, length: 12, confidenceScore: 0.8 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        }
    },
    Banking: {
        PHIOn: {
            documents: [
                {
                    redactedText:
                        'Hello, my name is ***********. I lost my Credit card on ***********, and I would like to request its cancellation. The last purchase I made was of a Chicken parmigiana dish at Contoso Restaurant, located near the Hollywood Museum, for $40. Below is my personal information for validation:\n        Profession: Accountant\n        Social Security number is 123-45-6789\n        Date of birth: ********\n        Phone number: ************\n        Personal address: ***************************************\n        Linked email account: ***************************\n        Swift code: ***********',
                    id: 'id__3609',
                    entities: [
                        { text: 'Mateo Gomez', category: 'Person', offset: 18, length: 11, confidenceScore: 0.99 },
                        { text: 'August 17th', category: 'DateTime', subcategory: 'Date', offset: 56, length: 11, confidenceScore: 0.8 },
                        { text: '9-9-1989', category: 'DateTime', subcategory: 'Date', offset: 389, length: 8, confidenceScore: 0.8 },
                        { text: '949-555-0110', category: 'PhoneNumber', offset: 420, length: 12, confidenceScore: 0.8 },
                        {
                            text: '1234 Hollywood Boulevard Los Angeles CA',
                            category: 'Address',
                            offset: 459,
                            length: 39,
                            confidenceScore: 0.98
                        },
                        { text: 'mateo', category: 'Person', offset: 529, length: 5, confidenceScore: 0.57 },
                        { text: 'mateo@contosorestaurant.com', category: 'Email', offset: 529, length: 27, confidenceScore: 0.8 },
                        { text: 'CHASUS33XXX', category: 'SWIFTCode', offset: 577, length: 11, confidenceScore: 0.75 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        },
        PHIOff: {
            documents: [
                {
                    redactedText:
                        'Hello, my name is ***********. I lost my Credit card on ***********, and I would like to request its cancellation. The last purchase I made was of a Chicken parmigiana dish at Contoso Restaurant, located near the Hollywood Museum, for $40. Below is my personal information for validation:\n        Profession: **********\n        Social Security number is 123-45-6789\n        Date of birth: ********\n        Phone number: ************\n        Personal address: ***************************************\n        Linked email account: ***************************\n        Swift code: ***********',
                    id: 'id__3433',
                    entities: [
                        { text: 'Mateo Gomez', category: 'Person', offset: 18, length: 11, confidenceScore: 0.99 },
                        { text: 'August 17th', category: 'DateTime', subcategory: 'Date', offset: 56, length: 11, confidenceScore: 0.8 },
                        { text: 'Accountant', category: 'PersonType', offset: 309, length: 10, confidenceScore: 0.81 },
                        { text: '9-9-1989', category: 'DateTime', subcategory: 'Date', offset: 389, length: 8, confidenceScore: 0.8 },
                        { text: '949-555-0110', category: 'PhoneNumber', offset: 420, length: 12, confidenceScore: 0.8 },
                        {
                            text: '1234 Hollywood Boulevard Los Angeles CA',
                            category: 'Address',
                            offset: 459,
                            length: 39,
                            confidenceScore: 0.98
                        },
                        { text: 'mateo', category: 'Person', offset: 529, length: 5, confidenceScore: 0.57 },
                        { text: 'mateo@contosorestaurant.com', category: 'Email', offset: 529, length: 27, confidenceScore: 0.8 },
                        { text: 'CHASUS33XXX', category: 'SWIFTCode', offset: 577, length: 11, confidenceScore: 0.75 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        }
    },
    Travel: {
        PHIOn: {
            documents: [
                {
                    redactedText:
                        'My wife and I decided to visit Los Angeles for the first time on *****************. We were staying at Contoso Hotel, located on *******************, so we decided to check out nearby places to visit. We bought two tickets for the Hollywood Museum to see all the popular props, costumes, and movie scenes that we grew up watching as kids. The place was quite large, so it was convenient that we wore our sneakers that day. After hours of walking and taking pictures, we decided to go for lunch at a nearby restaurant named Contoso Restaurant. While the Chicken parmigiana was quite good, the Surf and turf platter was a bit disappointing. It was a lovely trip overall and I especially appreciated being able to see the iconic Hollywood Sign while walking around the city.',
                    id: 'id__4749',
                    entities: [
                        {
                            text: 'August 17th, 2019',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 65,
                            length: 17,
                            confidenceScore: 0.8
                        },
                        { text: 'Hollywood Boulevard', category: 'Address', offset: 129, length: 19, confidenceScore: 0.9 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        },
        PHIOff: {
            documents: [
                {
                    redactedText:
                        'My **** and I decided to visit Los Angeles for the first time on *****************. We were staying at Contoso Hotel, located on *******************, so we decided to check out nearby places to visit. We bought two tickets for the Hollywood Museum to see all the popular props, costumes, and movie scenes that we grew up watching as kids. The place was quite large, so it was convenient that we wore our sneakers that day. After hours of walking and taking pictures, we decided to go for lunch at a nearby restaurant named Contoso Restaurant. While the Chicken parmigiana was quite good, the Surf and turf platter was a bit disappointing. It was a lovely trip overall and I especially appreciated being able to see the iconic Hollywood Sign while walking around the city.',
                    id: 'id__4577',
                    entities: [
                        { text: 'wife', category: 'PersonType', offset: 3, length: 4, confidenceScore: 0.95 },
                        {
                            text: 'August 17th, 2019',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 65,
                            length: 17,
                            confidenceScore: 0.8
                        },
                        { text: 'Hollywood Boulevard', category: 'Address', offset: 129, length: 19, confidenceScore: 0.9 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        }
    },
    'Medical Report': {
        PHIOff: {
            documents: [
                {
                    redactedText:
                        '***********, *********** man, suffered a car accident driving near his home on ******************* on *****************, and was admitted to *************** Hospital in Los Angeles California at *******. The ******* showed signs of chest trauma indicating possible rib fracture and had difficulty breathing. A chest CT scan and AP X-ray were performed to determine the damage to ribs and lungs. Results showed a pseudoaneurysm of the thoracic aorta with minor fracture to the first and third right ribs. ******* was kept in the ICU where treatment was initiated. A Stent was surgically placed to stabilize the hemorrhage until the blood oxygen level reached 95 percent. The ******* was discharged on *******************, under the supervision of his ********* ****************, passport number: **********',
                    id: 'id__4111',
                    entities: [
                        { text: 'Mateo Gomez', category: 'Person', offset: 0, length: 11, confidenceScore: 0.99 },
                        { text: '28-year-old', category: 'Quantity', subcategory: 'Age', offset: 13, length: 11, confidenceScore: 0.8 },
                        { text: 'Hollywood Boulevard', category: 'Address', offset: 79, length: 19, confidenceScore: 0.93 },
                        {
                            text: 'August 17th, 2022',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 102,
                            length: 17,
                            confidenceScore: 0.8
                        },
                        { text: 'Contoso General', category: 'Organization', offset: 141, length: 15, confidenceScore: 0.49 },
                        { text: '7:45 PM', category: 'DateTime', subcategory: 'Time', offset: 195, length: 7, confidenceScore: 0.8 },
                        { text: 'patient', category: 'PersonType', offset: 208, length: 7, confidenceScore: 0.96 },
                        { text: 'Patient', category: 'PersonType', offset: 504, length: 7, confidenceScore: 0.89 },
                        { text: 'patient', category: 'PersonType', offset: 674, length: 7, confidenceScore: 0.93 },
                        {
                            text: 'September 1st, 2022',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 700,
                            length: 19,
                            confidenceScore: 0.8
                        },
                        { text: 'caretaker', category: 'PersonType', offset: 750, length: 9, confidenceScore: 0.9 },
                        { text: 'Nickolaus Schulz', category: 'Person', offset: 760, length: 16, confidenceScore: 0.99 },
                        { text: 'B12345678.', category: 'EUPassportNumber', offset: 795, length: 10, confidenceScore: 0.99 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        },
        PHIOn: {
            documents: [
                {
                    redactedText:
                        '***********, *********** man, suffered a car accident driving near his home on ******************* on *****************, and was admitted to *************** Hospital in Los Angeles California at 7:45 PM. The patient showed signs of chest trauma indicating possible rib fracture and had difficulty breathing. A chest CT scan and AP X-ray were performed to determine the damage to ribs and lungs. Results showed a pseudoaneurysm of the thoracic aorta with minor fracture to the first and third right ribs. Patient was kept in the ICU where treatment was initiated. A Stent was surgically placed to stabilize the hemorrhage until the blood oxygen level reached 95 percent. The patient was discharged on *******************, under the supervision of his caretaker ****************, passport number: B12345678.',
                    id: 'id__3939',
                    entities: [
                        { text: 'Mateo Gomez', category: 'Person', offset: 0, length: 11, confidenceScore: 0.99 },
                        { text: '28-year-old', category: 'Quantity', subcategory: 'Age', offset: 13, length: 11, confidenceScore: 0.8 },
                        { text: 'Hollywood Boulevard', category: 'Address', offset: 79, length: 19, confidenceScore: 0.93 },
                        {
                            text: 'August 17th, 2022',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 102,
                            length: 17,
                            confidenceScore: 0.8
                        },
                        { text: 'Contoso General', category: 'Organization', offset: 141, length: 15, confidenceScore: 0.49 },
                        {
                            text: 'September 1st, 2022',
                            category: 'DateTime',
                            subcategory: 'Date',
                            offset: 700,
                            length: 19,
                            confidenceScore: 0.8
                        },
                        { text: 'Nickolaus Schulz', category: 'Person', offset: 760, length: 16, confidenceScore: 0.99 }
                    ],
                    warnings: []
                }
            ],
            errors: []
        }
    }
};

export const KeyPhrasesDemoSamplesJsonOutput: KeyPhrasesSampleSwaggers = {
    'Legal (NDA)': {
        documents: [
            {
                id: 'id__5503',
                keyPhrases: [
                    '1234 Hollywood Boulevard Los Angeles CA',
                    'social security number',
                    'following email address',
                    'August 17th',
                    'Contoso Restaurant',
                    'Mateo Gomez',
                    'top priorities',
                    'trade secrets',
                    'delivery schedules',
                    'written termination',
                    'date',
                    'employee',
                    'information',
                    'finances',
                    'recipes',
                    'intent',
                    'conditions',
                    'contract',
                    'fine'
                ],
                warnings: []
            }
        ],
        errors: []
    },
    'Email (Review)': {
        documents: [
            {
                id: 'id__5724',
                keyPhrases: [
                    'Santa Monica Pier',
                    'many good things',
                    'great things',
                    'Mateo Gomez',
                    'last week',
                    '1234 Hollywood Boulevard',
                    'lovely stroll',
                    'waiting list',
                    'two Surf',
                    'turf platters',
                    'absolute surprise',
                    'Contoso Restaurant',
                    'Madam',
                    'name',
                    'spouse',
                    'anniversary',
                    'Thursday',
                    'visit',
                    'food',
                    'service',
                    'neighbors',
                    'street',
                    'dinner',
                    'place',
                    '15 minutes',
                    'hour',
                    'experience',
                    'refund',
                    'apology',
                    'number'
                ],
                warnings: []
            }
        ],
        errors: []
    },
    Banking: {
        documents: [
            {
                id: 'id__5869',
                keyPhrases: [
                    '1234 Hollywood Boulevard Los Angeles CA',
                    'Chicken parmigiana dish',
                    'Linked email account',
                    'Social Security number',
                    'Hollywood Museum',
                    'Phone number',
                    'Credit card',
                    'August 17th',
                    'last purchase',
                    'Contoso Restaurant',
                    'personal information',
                    'Personal address',
                    'Swift code',
                    'Mateo Gomez',
                    'name',
                    'cancellation',
                    'validation',
                    'Profession',
                    'Accountant',
                    'Date',
                    'birth',
                    'contosorestaurant',
                    'CHASUS33XXX'
                ],
                warnings: []
            }
        ],
        errors: []
    },
    Travel: {
        documents: [
            {
                id: 'id__6014',
                keyPhrases: [
                    'iconic Hollywood Sign',
                    'Hollywood Boulevard',
                    'Hollywood Museum',
                    'Los Angeles',
                    'first time',
                    'August 17th',
                    'Contoso Hotel',
                    'nearby places',
                    'two tickets',
                    'popular props',
                    'movie scenes',
                    'nearby restaurant',
                    'Chicken parmigiana',
                    'turf platter',
                    'lovely trip',
                    'wife',
                    'costumes',
                    'kids',
                    'sneakers',
                    'hours',
                    'pictures',
                    'lunch',
                    'Surf',
                    'city'
                ],
                warnings: []
            }
        ],
        errors: []
    },
    'Medical Report': {
        documents: [
            {
                id: 'id__6159',
                keyPhrases: [
                    'Contoso General Hospital',
                    'Los Angeles California',
                    'blood oxygen level',
                    'possible rib fracture',
                    'chest CT scan',
                    'third right ribs',
                    'chest trauma',
                    'minor fracture',
                    'Mateo Gomez',
                    '28-year-old man',
                    'car accident',
                    'Hollywood Boulevard',
                    'August 17th',
                    'AP X-ray',
                    'thoracic aorta',
                    'A Stent',
                    'September 1st',
                    'Nickolaus Schulz',
                    'passport number',
                    'home',
                    '7:45 PM',
                    'patient',
                    'signs',
                    'difficulty',
                    'damage',
                    'lungs',
                    'Results',
                    'pseudoaneurysm',
                    'first',
                    'treatment',
                    'hemorrhage',
                    '95 percent',
                    'supervision',
                    'caretaker'
                ],
                warnings: []
            }
        ],
        errors: []
    }
};

export const NamedEntityRecognitionDemoSamplesJsonOutput: NamedEntityRecognitionSampleSwaggers = {
    'Legal (NDA)': {
        documents: [
            {
                id: 'id__8407',
                entities: [
                    { text: 'August 17th, 2019', category: 'DateTime', subcategory: 'Date', offset: 15, length: 17, confidenceScore: 0.8 },
                    { text: 'employee', category: 'PersonType', offset: 40, length: 8, confidenceScore: 0.95 },
                    { text: 'Contoso Restaurant', category: 'Organization', offset: 52, length: 18, confidenceScore: 0.85 },
                    { text: 'Mateo Gomez', category: 'Person', offset: 75, length: 11, confidenceScore: 0.99 },
                    { text: '1234 Hollywood Boulevard', category: 'Address', offset: 100, length: 24, confidenceScore: 0.98 },
                    { text: '1234', category: 'Quantity', subcategory: 'Number', offset: 100, length: 4, confidenceScore: 0.8 },
                    { text: 'Los', category: 'Location', subcategory: 'GPE', offset: 125, length: 3, confidenceScore: 0.5 },
                    { text: 'Angeles CA', category: 'Address', offset: 129, length: 10, confidenceScore: 0.55 },
                    { text: '123', category: 'Quantity', subcategory: 'Number', offset: 170, length: 3, confidenceScore: 0.8 },
                    { text: '45', category: 'Quantity', subcategory: 'Number', offset: 174, length: 2, confidenceScore: 0.8 },
                    { text: '6789', category: 'Quantity', subcategory: 'Number', offset: 177, length: 4, confidenceScore: 0.8 },
                    { text: 'support', category: 'Skill', offset: 207, length: 7, confidenceScore: 0.85 },
                    { text: 'Contoso Restaurant', category: 'Organization', offset: 265, length: 18, confidenceScore: 0.66 },
                    { text: 'secrets', category: 'Skill', offset: 362, length: 7, confidenceScore: 0.55 },
                    { text: 'finances', category: 'Skill', offset: 371, length: 8, confidenceScore: 0.91 },
                    { text: 'delivery', category: 'Skill', offset: 381, length: 8, confidenceScore: 0.61 },
                    { text: 'Mateo Gomez', category: 'Person', offset: 429, length: 11, confidenceScore: 1.0 },
                    { text: 'mateo@contosorestaurant.com', category: 'Email', offset: 611, length: 27, confidenceScore: 0.8 },
                    { text: '$10,000', category: 'Quantity', subcategory: 'Currency', offset: 666, length: 7, confidenceScore: 0.8 }
                ]
            }
        ],
        errors: []
    },
    'Email (Review)': {
        documents: [
            {
                id: 'id__8573',
                entities: [
                    { text: 'Madam', category: 'PersonType', offset: 9, length: 5, confidenceScore: 0.57 },
                    { text: 'Mateo Gomez', category: 'Person', offset: 36, length: 11, confidenceScore: 1.0 },
                    { text: 'Contoso Restaurant', category: 'Location', offset: 62, length: 18, confidenceScore: 0.56 },
                    { text: 'spouse', category: 'PersonType', offset: 89, length: 6, confidenceScore: 0.95 },
                    { text: 'anniversary', category: 'Event', offset: 104, length: 11, confidenceScore: 0.8 },
                    {
                        text: 'Thursday of last week',
                        category: 'DateTime',
                        subcategory: 'Date',
                        offset: 119,
                        length: 21,
                        confidenceScore: 0.8
                    },
                    { text: 'neighbors', category: 'PersonType', offset: 222, length: 9, confidenceScore: 0.98 },
                    { text: '1234 Hollywood Boulevard', category: 'Address', offset: 286, length: 24, confidenceScore: 0.99 },
                    { text: '1234', category: 'Quantity', subcategory: 'Number', offset: 286, length: 4, confidenceScore: 0.8 },
                    { text: 'Santa Monica Pier', category: 'Location', offset: 344, length: 17, confidenceScore: 0.89 },
                    { text: 'restaurant', category: 'Location', subcategory: 'Structural', offset: 457, length: 10, confidenceScore: 0.94 },
                    { text: 'last Thursday', category: 'DateTime', subcategory: 'Date', offset: 468, length: 13, confidenceScore: 0.8 },
                    { text: '15 minutes', category: 'DateTime', subcategory: 'Duration', offset: 502, length: 10, confidenceScore: 0.8 },
                    { text: 'After an hour', category: 'DateTime', subcategory: 'Duration', offset: 546, length: 13, confidenceScore: 0.8 },
                    { text: 'two', category: 'Quantity', subcategory: 'Number', offset: 596, length: 3, confidenceScore: 0.8 },
                    { text: 'Surf and turf platters', category: 'Product', offset: 600, length: 22, confidenceScore: 0.66 },
                    { text: 'food', category: 'Product', offset: 654, length: 4, confidenceScore: 0.56 },
                    { text: '949-555-0110', category: 'PhoneNumber', offset: 847, length: 12, confidenceScore: 0.8 }
                ]
            }
        ],
        errors: []
    },
    Banking: {
        documents: [
            {
                id: 'id__8727',
                entities: [
                    { text: 'Mateo Gomez', category: 'Person', offset: 18, length: 11, confidenceScore: 1.0 },
                    { text: 'card', category: 'Product', offset: 48, length: 4, confidenceScore: 0.57 },
                    { text: 'August 17th', category: 'DateTime', subcategory: 'Date', offset: 56, length: 11, confidenceScore: 0.8 },
                    { text: 'Chicken parmigiana dish', category: 'Product', offset: 149, length: 23, confidenceScore: 0.9 },
                    { text: 'Contoso Restaurant', category: 'Location', offset: 176, length: 18, confidenceScore: 0.64 },
                    { text: 'Hollywood Museum', category: 'Location', offset: 213, length: 16, confidenceScore: 0.86 },
                    { text: '$40', category: 'Quantity', subcategory: 'Currency', offset: 235, length: 3, confidenceScore: 0.8 },
                    { text: 'validation', category: 'Skill', offset: 277, length: 10, confidenceScore: 0.59 },
                    { text: 'Accountant', category: 'PersonType', offset: 309, length: 10, confidenceScore: 1.0 },
                    { text: '123', category: 'Quantity', subcategory: 'Number', offset: 354, length: 3, confidenceScore: 0.8 },
                    { text: '45', category: 'Quantity', subcategory: 'Number', offset: 358, length: 2, confidenceScore: 0.8 },
                    { text: '6789', category: 'Quantity', subcategory: 'Number', offset: 361, length: 4, confidenceScore: 0.8 },
                    { text: '9-9-1989', category: 'DateTime', subcategory: 'Date', offset: 389, length: 8, confidenceScore: 0.8 },
                    { text: '949-555-0110', category: 'PhoneNumber', offset: 420, length: 12, confidenceScore: 0.8 },
                    { text: '1234 Hollywood Boulevard', category: 'Address', offset: 459, length: 24, confidenceScore: 0.99 },
                    { text: '1234', category: 'Quantity', subcategory: 'Number', offset: 459, length: 4, confidenceScore: 0.8 },
                    { text: 'Los Angeles', category: 'Location', subcategory: 'GPE', offset: 484, length: 11, confidenceScore: 0.6 },
                    { text: 'CA', category: 'Location', subcategory: 'GPE', offset: 496, length: 2, confidenceScore: 0.38 },
                    { text: 'mateo@contosorestaurant.com', category: 'Email', offset: 529, length: 27, confidenceScore: 0.8 }
                ]
            }
        ],
        errors: []
    },
    Travel: {
        documents: [
            {
                id: 'id__8881',
                entities: [
                    { text: 'wife', category: 'PersonType', offset: 3, length: 4, confidenceScore: 0.99 },
                    { text: 'Los Angeles', category: 'Location', subcategory: 'GPE', offset: 31, length: 11, confidenceScore: 1.0 },
                    { text: 'first', category: 'Quantity', subcategory: 'Ordinal', offset: 51, length: 5, confidenceScore: 0.8 },
                    { text: 'August 17th, 2019', category: 'DateTime', subcategory: 'Date', offset: 65, length: 17, confidenceScore: 0.8 },
                    { text: 'Contoso Hotel', category: 'Location', offset: 103, length: 13, confidenceScore: 0.85 },
                    { text: 'Hollywood Boulevard', category: 'Address', offset: 129, length: 19, confidenceScore: 0.75 },
                    { text: 'two', category: 'Quantity', subcategory: 'Number', offset: 211, length: 3, confidenceScore: 0.8 },
                    { text: 'tickets', category: 'Product', offset: 215, length: 7, confidenceScore: 0.88 },
                    { text: 'Hollywood Museum', category: 'Location', offset: 231, length: 16, confidenceScore: 0.65 },
                    { text: 'props', category: 'Product', offset: 271, length: 5, confidenceScore: 0.58 },
                    { text: 'costumes', category: 'Product', offset: 278, length: 8, confidenceScore: 0.86 },
                    { text: 'sneakers', category: 'Product', offset: 404, length: 8, confidenceScore: 0.99 },
                    { text: 'restaurant', category: 'Location', subcategory: 'Structural', offset: 506, length: 10, confidenceScore: 0.81 },
                    { text: 'Contoso Restaurant', category: 'Organization', offset: 523, length: 18, confidenceScore: 0.53 },
                    { text: 'Chicken parmigiana', category: 'Product', offset: 553, length: 18, confidenceScore: 0.96 },
                    { text: 'Surf and turf platter', category: 'Product', offset: 592, length: 21, confidenceScore: 0.77 },
                    { text: 'bit', category: 'Quantity', subcategory: 'Dimension', offset: 620, length: 3, confidenceScore: 0.8 },
                    { text: 'trip', category: 'Event', offset: 655, length: 4, confidenceScore: 0.51 },
                    { text: 'Hollywood', category: 'Location', subcategory: 'GPE', offset: 726, length: 9, confidenceScore: 0.52 },
                    { text: 'city', category: 'Location', offset: 766, length: 4, confidenceScore: 0.54 }
                ]
            }
        ],
        errors: []
    },
    'Medical Report': {
        documents: [
            {
                id: 'id__9035',
                entities: [
                    { text: 'Mateo Gomez', category: 'Person', offset: 0, length: 11, confidenceScore: 1.0 },
                    { text: '28-year-old', category: 'Quantity', subcategory: 'Age', offset: 13, length: 11, confidenceScore: 0.8 },
                    { text: 'car accident', category: 'Event', offset: 41, length: 12, confidenceScore: 0.58 },
                    { text: 'home', category: 'Location', subcategory: 'Structural', offset: 71, length: 4, confidenceScore: 0.8 },
                    { text: 'Hollywood Boulevard', category: 'Address', offset: 79, length: 19, confidenceScore: 0.85 },
                    { text: 'August 17th, 2022', category: 'DateTime', subcategory: 'Date', offset: 102, length: 17, confidenceScore: 0.8 },
                    { text: 'Contoso General Hospital', category: 'Organization', offset: 141, length: 24, confidenceScore: 0.57 },
                    { text: 'Los Angeles', category: 'Location', subcategory: 'GPE', offset: 169, length: 11, confidenceScore: 0.97 },
                    { text: 'California', category: 'Location', subcategory: 'GPE', offset: 181, length: 10, confidenceScore: 0.54 },
                    { text: '7:45 PM', category: 'DateTime', subcategory: 'Time', offset: 195, length: 7, confidenceScore: 0.8 },
                    { text: 'patient', category: 'PersonType', offset: 208, length: 7, confidenceScore: 0.99 },
                    { text: 'first', category: 'Quantity', subcategory: 'Ordinal', offset: 476, length: 5, confidenceScore: 0.8 },
                    { text: 'third', category: 'Quantity', subcategory: 'Ordinal', offset: 486, length: 5, confidenceScore: 0.8 },
                    { text: 'Patient', category: 'PersonType', offset: 504, length: 7, confidenceScore: 0.97 },
                    { text: 'ICU', category: 'Location', subcategory: 'Structural', offset: 528, length: 3, confidenceScore: 0.99 },
                    { text: 'Stent', category: 'Product', offset: 565, length: 5, confidenceScore: 0.83 },
                    { text: '95 percent', category: 'Quantity', subcategory: 'Percentage', offset: 658, length: 10, confidenceScore: 0.8 },
                    { text: 'patient', category: 'PersonType', offset: 674, length: 7, confidenceScore: 0.94 },
                    {
                        text: 'September 1st, 2022',
                        category: 'DateTime',
                        subcategory: 'Date',
                        offset: 700,
                        length: 19,
                        confidenceScore: 0.8
                    },
                    { text: 'supervision', category: 'Skill', offset: 731, length: 11, confidenceScore: 0.65 },
                    { text: 'caretaker', category: 'PersonType', offset: 750, length: 9, confidenceScore: 0.94 },
                    { text: 'Nickolaus Schulz', category: 'Person', offset: 760, length: 16, confidenceScore: 1.0 }
                ]
            }
        ],
        errors: []
    }
};

export const LinkedEntitiesDemoSamplesJsonOutput: LinkedEntitiesSampleSwaggers = {
    'Legal (NDA)': {
        documents: [
            {
                id: 'id__7725',
                entities: [
                    {
                        bingId: '337074b7-46c7-4019-82b6-2be7a2b629aa',
                        name: 'Restaurant',
                        matches: [
                            { text: 'Restaurant', offset: 60, length: 10, confidenceScore: 0.16 },
                            { text: 'Restaurant', offset: 273, length: 10, confidenceScore: 0.16 }
                        ],
                        language: 'en',
                        id: 'Restaurant',
                        url: 'https://en.wikipedia.org/wiki/Restaurant',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '51252072-f828-f165-10a3-0969fafe5a34',
                        name: 'Hollywood Boulevard',
                        matches: [{ text: 'Hollywood Boulevard', offset: 105, length: 19, confidenceScore: 0.22 }],
                        language: 'en',
                        id: 'Hollywood Boulevard',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Boulevard',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '9958ca5c-ea31-4e71-8a17-bd1e7839c723',
                        name: 'Los Angeles',
                        matches: [{ text: 'Los Angeles CA', offset: 125, length: 14, confidenceScore: 0.62 }],
                        language: 'en',
                        id: 'Los Angeles',
                        url: 'https://en.wikipedia.org/wiki/Los_Angeles',
                        dataSource: 'Wikipedia'
                    }
                ],
                warnings: []
            }
        ],
        errors: []
    },
    'Email (Review)': {
        documents: [
            {
                id: 'id__7573',
                entities: [
                    {
                        bingId: '067ddd90-749a-32a1-5da4-f53a18663927',
                        name: 'Dear Sir',
                        matches: [{ text: 'Dear Sir', offset: 0, length: 8, confidenceScore: 0.68 }],
                        language: 'en',
                        id: 'Dear Sir',
                        url: 'https://en.wikipedia.org/wiki/Dear_Sir',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'bbfec893-bd3f-cc2d-2523-c2c5c02822e9',
                        name: 'Procuring (prostitution)',
                        matches: [{ text: 'Madam', offset: 9, length: 5, confidenceScore: 0.08 }],
                        language: 'en',
                        id: 'Procuring (prostitution)',
                        url: 'https://en.wikipedia.org/wiki/Procuring_(prostitution)',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '337074b7-46c7-4019-82b6-2be7a2b629aa',
                        name: 'Restaurant',
                        matches: [{ text: 'Restaurant', offset: 70, length: 10, confidenceScore: 0.03 }],
                        language: 'en',
                        id: 'Restaurant',
                        url: 'https://en.wikipedia.org/wiki/Restaurant',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '66c56476-ceae-f1d0-ff22-e8032cb74f24',
                        name: 'Thursday',
                        matches: [{ text: 'Thursday', offset: 119, length: 8, confidenceScore: 0.1 }],
                        language: 'en',
                        id: 'Thursday',
                        url: 'https://en.wikipedia.org/wiki/Thursday',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '51252072-f828-f165-10a3-0969fafe5a34',
                        name: 'Hollywood Boulevard',
                        matches: [{ text: 'Hollywood Boulevard', offset: 291, length: 19, confidenceScore: 0.2 }],
                        language: 'en',
                        id: 'Hollywood Boulevard',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Boulevard',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '3e921dda-6bd5-7444-cb82-9ad8fad755eb',
                        name: 'Santa Monica Pier',
                        matches: [{ text: 'Santa Monica Pier', offset: 344, length: 17, confidenceScore: 0.76 }],
                        language: 'en',
                        id: 'Santa Monica Pier',
                        url: 'https://en.wikipedia.org/wiki/Santa_Monica_Pier',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '56067257-351d-fde6-7074-38dbaa233ff1',
                        name: 'Surf and turf',
                        matches: [{ text: 'Surf and turf', offset: 600, length: 13, confidenceScore: 0.76 }],
                        language: 'en',
                        id: 'Surf and turf',
                        url: 'https://en.wikipedia.org/wiki/Surf_and_turf',
                        dataSource: 'Wikipedia'
                    }
                ],
                warnings: []
            }
        ],
        errors: []
    },
    Banking: {
        documents: [
            {
                id: 'id__7421',
                entities: [
                    {
                        bingId: '62844402-639c-980e-3e99-9ac94cb06eb4',
                        name: 'Credit card',
                        matches: [{ text: 'Credit card', offset: 41, length: 11, confidenceScore: 0.45 }],
                        language: 'en',
                        id: 'Credit card',
                        url: 'https://en.wikipedia.org/wiki/Credit_card',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '2def2562-2d04-4cd3-a30f-d5c4a43bbf4e',
                        name: 'Chicken parmigiana',
                        matches: [{ text: 'Chicken parmigiana', offset: 149, length: 18, confidenceScore: 0.82 }],
                        language: 'en',
                        id: 'Chicken parmigiana',
                        url: 'https://en.wikipedia.org/wiki/Chicken_parmigiana',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '337074b7-46c7-4019-82b6-2be7a2b629aa',
                        name: 'Restaurant',
                        matches: [{ text: 'Restaurant', offset: 184, length: 10, confidenceScore: 0.22 }],
                        language: 'en',
                        id: 'Restaurant',
                        url: 'https://en.wikipedia.org/wiki/Restaurant',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'b9779753-adbe-88c2-8147-8d71f7abd144',
                        name: 'Hollywood Museum',
                        matches: [{ text: 'Hollywood Museum', offset: 213, length: 16, confidenceScore: 0.78 }],
                        language: 'en',
                        id: 'Hollywood Museum',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Museum',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'dc68fadd-b0f5-582d-6f36-2a35809a192f',
                        name: 'Religious profession',
                        matches: [{ text: 'Profession', offset: 297, length: 10, confidenceScore: 0.07 }],
                        language: 'en',
                        id: 'Religious profession',
                        url: 'https://en.wikipedia.org/wiki/Religious_profession',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '4f0122de-b479-274d-63ec-38f8341d1414',
                        name: 'Accountant',
                        matches: [{ text: 'Accountant', offset: 309, length: 10, confidenceScore: 0.07 }],
                        language: 'en',
                        id: 'Accountant',
                        url: 'https://en.wikipedia.org/wiki/Accountant',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'b5643e63-fcc0-a08e-27ff-add8b1821c17',
                        name: 'Social Security number',
                        matches: [{ text: 'Social Security number', offset: 328, length: 22, confidenceScore: 0.75 }],
                        language: 'en',
                        id: 'Social Security number',
                        url: 'https://en.wikipedia.org/wiki/Social_Security_number',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'ea24fae2-283d-f17b-9900-c7b91d4dd9c6',
                        name: 'Birthday',
                        matches: [{ text: 'Date of birth', offset: 374, length: 13, confidenceScore: 0.05 }],
                        language: 'en',
                        id: 'Birthday',
                        url: 'https://en.wikipedia.org/wiki/Birthday',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'af0b438f-cd0c-9dee-50d1-b9e97580342c',
                        name: 'Telephone number',
                        matches: [{ text: 'Phone number', offset: 406, length: 12, confidenceScore: 0.73 }],
                        language: 'en',
                        id: 'Telephone number',
                        url: 'https://en.wikipedia.org/wiki/Telephone_number',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '51252072-f828-f165-10a3-0969fafe5a34',
                        name: 'Hollywood Boulevard',
                        matches: [{ text: 'Hollywood Boulevard', offset: 464, length: 19, confidenceScore: 0.19 }],
                        language: 'en',
                        id: 'Hollywood Boulevard',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Boulevard',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '9958ca5c-ea31-4e71-8a17-bd1e7839c723',
                        name: 'Los Angeles',
                        matches: [{ text: 'Los Angeles CA', offset: 484, length: 14, confidenceScore: 0.42 }],
                        language: 'en',
                        id: 'Los Angeles',
                        url: 'https://en.wikipedia.org/wiki/Los_Angeles',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '9e0bd53b-79a4-3c47-0d5e-35a686ad4470',
                        name: 'ISO 9362',
                        matches: [{ text: 'Swift code', offset: 565, length: 10, confidenceScore: 0.72 }],
                        language: 'en',
                        id: 'ISO 9362',
                        url: 'https://en.wikipedia.org/wiki/ISO_9362',
                        dataSource: 'Wikipedia'
                    }
                ],
                warnings: []
            }
        ],
        errors: []
    },
    Travel: {
        documents: [
            {
                id: 'id__7269',
                entities: [
                    {
                        bingId: '9958ca5c-ea31-4e71-8a17-bd1e7839c723',
                        name: 'Los Angeles',
                        matches: [{ text: 'Los Angeles', offset: 31, length: 11, confidenceScore: 0.1 }],
                        language: 'en',
                        id: 'Los Angeles',
                        url: 'https://en.wikipedia.org/wiki/Los_Angeles',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '04997f43-c747-bdd9-e5fe-3fa762f7de51',
                        name: 'Hotel',
                        matches: [{ text: 'Hotel', offset: 111, length: 5, confidenceScore: 0.26 }],
                        language: 'en',
                        id: 'Hotel',
                        url: 'https://en.wikipedia.org/wiki/Hotel',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '51252072-f828-f165-10a3-0969fafe5a34',
                        name: 'Hollywood Boulevard',
                        matches: [{ text: 'Hollywood Boulevard', offset: 129, length: 19, confidenceScore: 0.25 }],
                        language: 'en',
                        id: 'Hollywood Boulevard',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Boulevard',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'b9779753-adbe-88c2-8147-8d71f7abd144',
                        name: 'Hollywood Museum',
                        matches: [{ text: 'Hollywood Museum', offset: 231, length: 16, confidenceScore: 0.82 }],
                        language: 'en',
                        id: 'Hollywood Museum',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Museum',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '337074b7-46c7-4019-82b6-2be7a2b629aa',
                        name: 'Restaurant',
                        matches: [{ text: 'Restaurant', offset: 531, length: 10, confidenceScore: 0.19 }],
                        language: 'en',
                        id: 'Restaurant',
                        url: 'https://en.wikipedia.org/wiki/Restaurant',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '2def2562-2d04-4cd3-a30f-d5c4a43bbf4e',
                        name: 'Chicken parmigiana',
                        matches: [{ text: 'Chicken parmigiana', offset: 553, length: 18, confidenceScore: 0.75 }],
                        language: 'en',
                        id: 'Chicken parmigiana',
                        url: 'https://en.wikipedia.org/wiki/Chicken_parmigiana',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '56067257-351d-fde6-7074-38dbaa233ff1',
                        name: 'Surf and turf',
                        matches: [{ text: 'Surf and turf', offset: 592, length: 13, confidenceScore: 0.76 }],
                        language: 'en',
                        id: 'Surf and turf',
                        url: 'https://en.wikipedia.org/wiki/Surf_and_turf',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'a0aff6d8-3408-54f6-b847-1ee8d44aea40',
                        name: 'Hollywood Sign',
                        matches: [{ text: 'Hollywood Sign', offset: 726, length: 14, confidenceScore: 0.83 }],
                        language: 'en',
                        id: 'Hollywood Sign',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Sign',
                        dataSource: 'Wikipedia'
                    }
                ],
                warnings: []
            }
        ],
        errors: []
    },
    'Medical Report': {
        errors: [],
        documents: [
            {
                id: 'id__7117',
                entities: [
                    {
                        bingId: '51252072-f828-f165-10a3-0969fafe5a34',
                        name: 'Hollywood Boulevard',
                        matches: [{ text: 'Hollywood Boulevard', offset: 79, length: 19, confidenceScore: 0.22 }],
                        language: 'en',
                        id: 'Hollywood Boulevard',
                        url: 'https://en.wikipedia.org/wiki/Hollywood_Boulevard',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'f87cbf33-5672-45cd-8a60-d76937b29fc0',
                        name: 'General Hospital',
                        matches: [{ text: 'General Hospital', offset: 149, length: 16, confidenceScore: 0.13 }],
                        language: 'en',
                        id: 'General Hospital',
                        url: 'https://en.wikipedia.org/wiki/General_Hospital',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '9958ca5c-ea31-4e71-8a17-bd1e7839c723',
                        name: 'Los Angeles',
                        matches: [{ text: 'Los Angeles California', offset: 169, length: 22, confidenceScore: 0.49 }],
                        language: 'en',
                        id: 'Los Angeles',
                        url: 'https://en.wikipedia.org/wiki/Los_Angeles',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'ba694681-c578-fd9c-0b41-f13a631b38a1',
                        name: 'Autopsy',
                        matches: [{ text: 'PM', offset: 200, length: 2, confidenceScore: 0.07 }],
                        language: 'en',
                        id: 'Autopsy',
                        url: 'https://en.wikipedia.org/wiki/Autopsy',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '617d2331-d490-9504-5e69-9590e2986888',
                        name: 'CT scan',
                        matches: [{ text: 'CT scan', offset: 316, length: 7, confidenceScore: 0.87 }],
                        language: 'en',
                        id: 'CT scan',
                        url: 'https://en.wikipedia.org/wiki/CT_scan',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'b2843a2b-80fd-2fa0-10d0-97b51563ffcb',
                        name: 'Associated Press',
                        matches: [{ text: 'AP', offset: 328, length: 2, confidenceScore: 0.13 }],
                        language: 'en',
                        id: 'Associated Press',
                        url: 'https://en.wikipedia.org/wiki/Associated_Press',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '58002b48-93fa-1e6a-2c3a-05fb0a910a15',
                        name: 'X-ray',
                        matches: [{ text: 'X-ray', offset: 331, length: 5, confidenceScore: 0.01 }],
                        language: 'en',
                        id: 'X-ray',
                        url: 'https://en.wikipedia.org/wiki/X-ray',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '7da11c50-1461-0afd-8bb5-ecedcd8668a6',
                        name: 'Patient',
                        matches: [{ text: 'Patient', offset: 504, length: 7, confidenceScore: 0.2 }],
                        language: 'en',
                        id: 'Patient',
                        url: 'https://en.wikipedia.org/wiki/Patient',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: '3da958ae-74eb-5587-7f0f-b679838a2b82',
                        name: 'Intensive care unit',
                        matches: [{ text: 'ICU', offset: 528, length: 3, confidenceScore: 0.14 }],
                        language: 'en',
                        id: 'Intensive care unit',
                        url: 'https://en.wikipedia.org/wiki/Intensive_care_unit',
                        dataSource: 'Wikipedia'
                    },
                    {
                        bingId: 'ec55d608-904b-c25d-e3bf-32385e71f9de',
                        name: 'Stent',
                        matches: [{ text: 'Stent', offset: 565, length: 5, confidenceScore: 0.23 }],
                        language: 'en',
                        id: 'Stent',
                        url: 'https://en.wikipedia.org/wiki/Stent',
                        dataSource: 'Wikipedia'
                    }
                ],
                warnings: []
            }
        ]
    }
};

export const HealthcareEntitiesDemoSamplesFHIRBundle: HealthcareEntitiesFHIRBundleSwaggers = {
    'Short Prescription': {
        resourceType: 'Bundle',
        id: 'ad26298b-187f-44fb-a5a1-9111125b6e17',
        meta: {
            profile: ['http://hl7.org/fhir/4.0.1/StructureDefinition/Bundle']
        },
        identifier: {
            system: 'urn:ietf:rfc:3986',
            value: 'urn:uuid:ad26298b-187f-44fb-a5a1-9111125b6e17'
        },
        type: 'document',
        entry: [
            {
                fullUrl: 'Composition/bca36eff-31a4-42d5-a971-568132a2bf14',
                resource: {
                    resourceType: 'Composition',
                    id: 'bca36eff-31a4-42d5-a971-568132a2bf14',
                    status: 'final',
                    type: {
                        coding: [
                            {
                                system: 'http://loinc.org',
                                code: '11526-1',
                                display: 'Pathology study'
                            }
                        ],
                        text: 'Pathology study'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    date: '2023-01-02',
                    author: [
                        {
                            reference: 'Practitioner/8521fc74-2178-488a-a962-318e5e6277ea',
                            type: 'Practitioner',
                            display: 'Unknown'
                        }
                    ],
                    title: 'Pathology study',
                    section: [
                        {
                            title: 'General',
                            code: {
                                coding: [
                                    {
                                        system: '',
                                        display: 'Unrecognized Section'
                                    }
                                ],
                                text: 'General'
                            },
                            text: {
                                status: 'additional',
                                div:
                                    '<div>\r\n\t\t\t\t\t\t\t<h1>General</h1>\r\n\t\t\t\t\t\t\t<p>Patient needs to take 100 mg of ibuprofen, and 3 mg of potassium. Also needs to take 10 mg of Zocor.\nPatient needs to take 50 mg of ibuprofen, and 2 mg of Coumadin.</p>\r\n\t\t\t\t\t</div>'
                            },
                            entry: [
                                {
                                    reference: 'List/ff83d8a2-cffc-4f54-85c9-3277cd973731',
                                    type: 'List',
                                    display: 'General'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'Practitioner/8521fc74-2178-488a-a962-318e5e6277ea',
                resource: {
                    resourceType: 'Practitioner',
                    id: '8521fc74-2178-488a-a962-318e5e6277ea',
                    name: [
                        {
                            text: 'Unknown',
                            family: 'Unknown'
                        }
                    ]
                }
            },
            {
                fullUrl: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                resource: {
                    resourceType: 'Patient',
                    id: '8b32b54e-4205-4d38-9249-2ce8605869b7',
                    gender: 'unknown'
                }
            },
            {
                fullUrl: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                resource: {
                    resourceType: 'Encounter',
                    id: '8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-encounter']
                    },
                    status: 'finished',
                    class: {
                        system: 'http://terminology.hl7.org/CodeSystem/v3-ActCode',
                        display: 'unknown'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    period: {
                        start: '2023-01-02',
                        end: '2023-01-02'
                    }
                }
            },
            {
                fullUrl: 'MedicationStatement/804a73e9-9af7-4668-b132-9f7160c3b85c',
                resource: {
                    resourceType: 'MedicationStatement',
                    id: '804a73e9-9af7-4668-b132-9f7160c3b85c',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 32
                                },
                                {
                                    url: 'length',
                                    valueInteger: 9
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'active',
                    medicationCodeableConcept: {
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0020740',
                                display: 'ibuprofen'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000019879'
                            },
                            {
                                system: 'http://www.whocc.no/atc',
                                code: 'M01AE01'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '0046165'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000006519'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '2270-2077'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/drugbank',
                                code: 'DB01050'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/gs',
                                code: '1611'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh97005926'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LP16165-0'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '40458'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mmsl',
                                code: 'd00015'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D007052'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthspl',
                                code: 'WK2XYI10QM'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C561'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctrp',
                                code: 'C561'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_dcp',
                                code: '00803'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_dtp',
                                code: 'NSC0256857'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                code: 'WK2XYI10QM'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000613511'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nddf',
                                code: '002377'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pdq',
                                code: 'CDR0000040475'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'x02MO'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                code: '5640'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'E-7772'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'C-603C0'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '387207008'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/usp',
                                code: 'm39860'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/uspmg',
                                code: 'MTHU000060'
                            },
                            {
                                system: 'http://hl7.org/fhir/ndfrt',
                                code: '4017840'
                            }
                        ],
                        text: 'ibuprofen'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    context: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    dosage: [
                        {
                            text: '100 mg',
                            doseAndRate: [
                                {
                                    doseQuantity: {
                                        value: 100,
                                        unit: 'mg'
                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'MedicationStatement/9cc9addb-4c21-40a4-9550-95505fe2d233',
                resource: {
                    resourceType: 'MedicationStatement',
                    id: '9cc9addb-4c21-40a4-9550-95505fe2d233',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 55
                                },
                                {
                                    url: 'length',
                                    valueInteger: 9
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'active',
                    medicationCodeableConcept: {
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0032821',
                                display: 'potassium'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000002435'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1006930'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000010004'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/cpm',
                                code: '32051'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '2390-5099'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/drugbank',
                                code: 'DB14500'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/gs',
                                code: '2493'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch',
                                code: 'U003782'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85105593'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LP15098-4'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '41250'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mmsl',
                                code: '5321'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D011188'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mth',
                                code: 'U000145'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthspl',
                                code: 'RWP5GA015D'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C765'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_dcp',
                                code: '31091'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                code: 'RWP5GA015D'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000044344'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nddf',
                                code: '000763'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/psy',
                                code: '39750'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'X80D4'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                code: '8588'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'F-10530'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'C-13500'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '88480006'
                            },
                            {
                                system: 'http://hl7.org/fhir/ndfrt',
                                code: '4017695'
                            }
                        ],
                        text: 'potassium'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    context: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    dosage: [
                        {
                            text: '3 mg',
                            doseAndRate: [
                                {
                                    doseQuantity: {
                                        value: 3,
                                        unit: 'mg'
                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'MedicationStatement/af022abd-93be-4a30-88dc-449d6864ed29',
                resource: {
                    resourceType: 'MedicationStatement',
                    id: 'af022abd-93be-4a30-88dc-449d6864ed29',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 94
                                },
                                {
                                    url: 'length',
                                    valueInteger: 5
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'active',
                    medicationCodeableConcept: {
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0678181',
                                display: 'Zocor'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000042766'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '5001-0024'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mmsl',
                                code: '1546'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D019821'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C29454'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pdq',
                                code: 'CDR0000455226'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'x03d7'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                code: '196503'
                            }
                        ],
                        text: 'Zocor'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    context: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    dosage: [
                        {
                            text: '10 mg',
                            doseAndRate: [
                                {
                                    doseQuantity: {
                                        value: 10,
                                        unit: 'mg'
                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'MedicationStatement/d60c8736-a101-4d82-b8cf-c646669fd4ab',
                resource: {
                    resourceType: 'MedicationStatement',
                    id: 'd60c8736-a101-4d82-b8cf-c646669fd4ab',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 132
                                },
                                {
                                    url: 'length',
                                    valueInteger: 9
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'active',
                    medicationCodeableConcept: {
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0020740',
                                display: 'ibuprofen'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000019879'
                            },
                            {
                                system: 'http://www.whocc.no/atc',
                                code: 'M01AE01'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '0046165'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000006519'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '2270-2077'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/drugbank',
                                code: 'DB01050'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/gs',
                                code: '1611'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh97005926'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LP16165-0'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '40458'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mmsl',
                                code: 'd00015'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D007052'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthspl',
                                code: 'WK2XYI10QM'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C561'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctrp',
                                code: 'C561'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_dcp',
                                code: '00803'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_dtp',
                                code: 'NSC0256857'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                code: 'WK2XYI10QM'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000613511'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nddf',
                                code: '002377'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pdq',
                                code: 'CDR0000040475'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'x02MO'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                code: '5640'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'E-7772'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'C-603C0'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '387207008'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/usp',
                                code: 'm39860'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/uspmg',
                                code: 'MTHU000060'
                            },
                            {
                                system: 'http://hl7.org/fhir/ndfrt',
                                code: '4017840'
                            }
                        ],
                        text: 'ibuprofen'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    context: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    dosage: [
                        {
                            text: '50 mg',
                            doseAndRate: [
                                {
                                    doseQuantity: {
                                        value: 50,
                                        unit: 'mg'
                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'MedicationStatement/38988296-b611-48e4-a2f0-d793a455a557',
                resource: {
                    resourceType: 'MedicationStatement',
                    id: '38988296-b611-48e4-a2f0-d793a455a557',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 155
                                },
                                {
                                    url: 'length',
                                    valueInteger: 8
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'active',
                    medicationCodeableConcept: {
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0699129',
                                display: 'Coumadin'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000044372'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '0397-0420'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mmsl',
                                code: '146'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D014859'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C1658'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_dtp',
                                code: 'NSC0059813'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pdq',
                                code: 'CDR0000039740'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'x02iF'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                code: '202421'
                            }
                        ],
                        text: 'Coumadin'
                    },
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    context: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    dosage: [
                        {
                            text: '2 mg',
                            doseAndRate: [
                                {
                                    doseQuantity: {
                                        value: 2,
                                        unit: 'mg'
                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'List/ff83d8a2-cffc-4f54-85c9-3277cd973731',
                resource: {
                    resourceType: 'List',
                    id: 'ff83d8a2-cffc-4f54-85c9-3277cd973731',
                    status: 'current',
                    mode: 'snapshot',
                    title: 'General',
                    subject: {
                        reference: 'Patient/8b32b54e-4205-4d38-9249-2ce8605869b7',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/8f28d69a-e1cb-4df5-ae6d-e3251aaf95f5',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    entry: [
                        {
                            item: {
                                reference: 'MedicationStatement/804a73e9-9af7-4668-b132-9f7160c3b85c',
                                type: 'MedicationStatement',
                                display: 'ibuprofen'
                            }
                        },
                        {
                            item: {
                                reference: 'MedicationStatement/9cc9addb-4c21-40a4-9550-95505fe2d233',
                                type: 'MedicationStatement',
                                display: 'potassium'
                            }
                        },
                        {
                            item: {
                                reference: 'MedicationStatement/af022abd-93be-4a30-88dc-449d6864ed29',
                                type: 'MedicationStatement',
                                display: 'Zocor'
                            }
                        },
                        {
                            item: {
                                reference: 'MedicationStatement/d60c8736-a101-4d82-b8cf-c646669fd4ab',
                                type: 'MedicationStatement',
                                display: 'ibuprofen'
                            }
                        },
                        {
                            item: {
                                reference: 'MedicationStatement/38988296-b611-48e4-a2f0-d793a455a557',
                                type: 'MedicationStatement',
                                display: 'Coumadin'
                            }
                        }
                    ]
                }
            }
        ]
    },
    'Patient Report': {
        resourceType: 'Bundle',
        id: '8c1dcf9d-ec25-456f-9cd6-80a061eeca5e',
        meta: {
            profile: ['http://hl7.org/fhir/4.0.1/StructureDefinition/Bundle']
        },
        identifier: {
            system: 'urn:ietf:rfc:3986',
            value: 'urn:uuid:8c1dcf9d-ec25-456f-9cd6-80a061eeca5e'
        },
        type: 'document',
        entry: [
            {
                fullUrl: 'Composition/5eda4171-4c33-4154-b9cd-c22c73f5c283',
                resource: {
                    resourceType: 'Composition',
                    id: '5eda4171-4c33-4154-b9cd-c22c73f5c283',
                    status: 'final',
                    type: {
                        coding: [
                            {
                                system: 'http://loinc.org',
                                code: '18842-5',
                                display: 'Discharge summary'
                            }
                        ],
                        text: 'Discharge summary'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    date: '2001-05-22',
                    author: [
                        {
                            reference: 'Practitioner/a145f3d7-bd26-4096-ba1b-59c0ba9f707f',
                            type: 'Practitioner',
                            display: 'Unknown'
                        }
                    ],
                    title: 'Discharge summary',
                    section: [
                        {
                            title: 'HISTORY OF PRESENT ILLNESS',
                            code: {
                                codig: [
                                    {
                                        system: 'http://loinc.org',
                                        code: '10164-2',
                                        display: 'History of present illness'
                                    }
                                ],
                                text: 'HISTORY OF PRESENT ILLNESS'
                            },
                            text: {
                                status: 'additional',
                                div:
                                    '<div>\r\n\t\t\t\t\t\t\t<h1>HISTORY OF PRESENT ILLNESS</h1>\r\n\t\t\t\t\t\t\t<p>The patient is a 54-year-old gentleman with a history of progressive angina over the past several months.\nThe patient had a cardiac catheterization in July of this year revealing total occlusion of the RCA and 50% left main disease ,\nwith a strong family history of coronary artery disease with a brother dying at the age of 52 from a myocardial infarction and\nanother brother who is status post coronary artery bypass grafting. The patient had a stress echocardiogram done on July , 2001 ,\nwhich showed no wall motion abnormalities , but this was a difficult study due to body habitus. The patient went for six minutes with\nminimal ST depressions in the anterior lateral leads , thought due to fatigue and wrist pain , his anginal equivalent. Due to the patient\'s\nincreased symptoms and family history and history left main disease with total occasional of his RCA was referred for revascularization with open heart surgery.";</p>\r\n\t\t\t\t\t</div>'
                            },
                            entry: [
                                {
                                    reference: 'List/b0400cef-00b0-4501-a2b1-29708ec622f6',
                                    type: 'List',
                                    display: 'HISTORY OF PRESENT ILLNESS'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'Practitioner/a145f3d7-bd26-4096-ba1b-59c0ba9f707f',
                resource: {
                    resourceType: 'Practitioner',
                    id: 'a145f3d7-bd26-4096-ba1b-59c0ba9f707f',
                    name: [
                        {
                            text: 'Unknown',
                            family: 'Unknown'
                        }
                    ]
                }
            },
            {
                fullUrl: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                resource: {
                    resourceType: 'Patient',
                    id: 'e268cef8-82fd-4dae-8cc1-3526ca138515',
                    identifier: [
                        {
                            use: 'usual',
                            type: {
                                text: 'RECORD'
                            },
                            value:
                                '#333582770390100 | MH | 85986313 | | 054351 | 2/14/2001 12:00:00 AM | CORONARY ARTERY DISEASE | Signed | DIS'
                        }
                    ],
                    gender: 'male',
                    birthDate: '1947-06'
                }
            },
            {
                fullUrl: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                resource: {
                    resourceType: 'Encounter',
                    id: '9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-encounter']
                    },
                    status: 'finished',
                    class: {
                        system: 'http://terminology.hl7.org/CodeSystem/v3-ActCode',
                        display: 'unknown'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    period: {
                        start: '2001-05-22',
                        end: '2001-05-22'
                    }
                }
            },
            {
                fullUrl: 'Observation/84adc6a6-dc83-4833-9e95-d640d113f9d1',
                resource: {
                    resourceType: 'Observation',
                    id: '84adc6a6-dc83-4833-9e95-d640d113f9d1',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 390
                                },
                                {
                                    url: 'length',
                                    valueInteger: 23
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'final',
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0018795',
                                display: 'Cardiac Catheterization Procedures'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1002003'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccs',
                                code: '7.5.2'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000005872'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/costar',
                                code: '154'
                            },
                            {
                                system: 'http://www.ama-assn.org/go/cpt',
                                code: '1013071'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '1393-7244'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-am',
                                code: '667'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-amae',
                                code: '667'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch',
                                code: 'U005615'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85020181'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LP6170-7'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10007815'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '22704'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D006328'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mth',
                                code: 'U001971'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                code: '37.21'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C38044'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                code: 'C38044'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: '7939.'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcdae',
                                code: '7939.'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'P-7200'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'P1-31600'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '41976001'
                            }
                        ],
                        text: 'cardiac catheterization'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    effectiveTiming: {
                        repeat: {
                            duration: 1,
                            durationUnit: 'a'
                        },
                        code: {
                            tex: 'July of this year'
                        }
                    },
                    interpretation: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation',
                                    code: 'POS',
                                    display: 'Positive'
                                }
                            ],
                            text: 'Positive'
                        }
                    ]
                }
            },
            {
                fullUrl: 'Observation/29b8a849-3423-4e67-b9dc-789a398921ed',
                resource: {
                    resourceType: 'Observation',
                    id: '29b8a849-3423-4e67-b9dc-789a398921ed',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 713
                                },
                                {
                                    url: 'length',
                                    valueInteger: 21
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'final',
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0920208',
                                display: 'Echocardiography, Stress'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000052531'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh91004821'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LA28649-4'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10050241'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D025401'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C80407'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                code: 'C80407'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '816996009'
                            }
                        ],
                        text: 'stress echocardiogram'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    effectiveDateTime: '2001',
                    interpretation: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation',
                                    code: 'POS',
                                    display: 'Positive'
                                }
                            ],
                            text: 'Positive'
                        }
                    ]
                }
            },
            {
                fullUrl: 'Condition/21c78548-c31e-4d43-aa7c-cd2afff428ac',
                resource: {
                    resourceType: 'Condition',
                    id: '21c78548-c31e-4d43-aa7c-cd2afff428ac',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 335
                                },
                                {
                                    url: 'length',
                                    valueInteger: 6
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    clinicalStatus: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 323
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 11
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-clinical',
                                code: 'active',
                                display: 'Active'
                            }
                        ],
                        text: 'progressive'
                    },
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0002962',
                                display: 'Angina Pectoris'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000005330'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/bi',
                                code: 'BI00047'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1017852'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccs',
                                code: '7.2.4.1'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000001165'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/costar',
                                code: '054'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '1393-3407'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/cst',
                                code: 'ANGINA PECTORIS'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/dxp',
                                code: 'U000113'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                code: 'HP:0001681'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10',
                                code: 'I20.9'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-am',
                                code: 'I20.9'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                code: 'I20.9'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-9-cm',
                                code: '413'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/icpc',
                                code: 'K74'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/icpc2eeng',
                                code: 'K74'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                code: 'MTHU006338'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc-2p',
                                code: 'K74001'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch',
                                code: 'U000244'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85005022'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LA14275-4'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10002383'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '33215'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                code: '142'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D000787'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mth',
                                code: '053'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                code: '413.9'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/mthicpc2eae',
                                code: 'K74'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C51221'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctcae',
                                code: 'E10110'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                code: '1710'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nichd',
                                code: 'C51221'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/noc',
                                code: '040504'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/omim',
                                code: 'MTHU009903'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/oms',
                                code: '29.13'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pcds',
                                code: 'PRB_02040.07'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/psy',
                                code: '02530'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/qmr',
                                code: 'Q0300326'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'G33..'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcdae',
                                code: 'Ua1eH'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'F-71500'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'D3-12000'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '194828000'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/who',
                                code: '0422'
                            }
                        ],
                        text: 'angina'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    onsetString: 'past several months'
                }
            },
            {
                fullUrl: 'Condition/2a7e5d75-8b04-49ae-b179-20a2a84c35c8',
                resource: {
                    resourceType: 'Condition',
                    id: '2a7e5d75-8b04-49ae-b179-20a2a84c35c8',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 490
                                },
                                {
                                    url: 'length',
                                    valueInteger: 7
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0012634',
                                display: 'Disease'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '0007490'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000004014'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '0944-4756'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                code: 'MTHU000256'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc-2p',
                                code: 'A99001'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch',
                                code: 'U001423'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85038411'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LP21006-9'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '39448'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D004194'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C2991'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc-gloss',
                                code: 'C2991'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctdc',
                                code: 'C2991'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctrp',
                                code: 'C2991'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                code: 'VAR'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000651193'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nichd',
                                code: 'C2991'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                code: 'C2991'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/psy',
                                code: '14520'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'X0003'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'D-Y000'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'DF-00000'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '64572001'
                            }
                        ],
                        text: 'disease'
                    },
                    bodySite: [
                        {
                            extension: [
                                {
                                    extension: [
                                        {
                                            url: 'offset',
                                            valueInteger: 480
                                        },
                                        {
                                            url: 'length',
                                            valueInteger: 9
                                        }
                                    ],
                                    url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                                }
                            ],
                            coding: [
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls',
                                    code: 'C1261082',
                                    display: 'Left coronary artery structure'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/chv',
                                    code: '0000056387'
                                },
                                {
                                    system: 'http://www.ama-assn.org/go/cpt',
                                    code: 'LM'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/csp',
                                    code: '1398-9631'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/fma',
                                    code: '50040'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/hcpcs',
                                    code: 'LM'
                                },
                                {
                                    system: 'http://loinc.org',
                                    code: 'LP199529-1'
                                },
                                {
                                    system: 'http://ncimeta.nci.nih.gov',
                                    code: 'C12872'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                    code: 'C12872'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                    code: 'X74eC'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: 'T-43100'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: 'T-43100'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: '50018008'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/uwda',
                                    code: '50040'
                                }
                            ],
                            text: 'left main'
                        }
                    ],
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    evidence: [
                        {
                            detail: [
                                {
                                    reference: 'Observation/84adc6a6-dc83-4833-9e95-d640d113f9d1',
                                    type: 'Observation',
                                    display: 'cardiac catheterization'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/84639dd6-292a-400c-b90d-f050f287bbd6',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: '84639dd6-292a-400c-b90d-f050f287bbd6',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 532
                                },
                                {
                                    url: 'length',
                                    valueInteger: 23
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 514
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 6
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0015576',
                                display: 'Family'
                            }
                        ],
                        text: 'family'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C1956346',
                                        display: 'Coronary Artery Disease'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/aod',
                                        code: '0000005327'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/bi',
                                        code: 'BI00010'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                        code: '0037465'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/csp',
                                        code: '1393-3397'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cst',
                                        code: 'CORONARY ART DIS'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/dxp',
                                        code: 'U000871'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                        code: 'HP:0001677'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                        code: 'I25.1'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                        code: 'MTHU019520'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc-2p',
                                        code: 'K76003'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'LP90122-0'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                        code: '10011078'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '35988'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                        code: '1276'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D003324'
                                    },
                                    {
                                        system: 'http://ncimeta.nci.nih.gov',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cellosaurus',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                        code: 'CDR0000439400'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/omim',
                                        code: 'MTHU002067'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                        code: 'XE2uV'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'D3-13000'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '414024009'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/who',
                                        code: '0426'
                                    }
                                ],
                                text: 'coronary artery disease'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/07c5fd6f-b41b-4018-8c32-a20221eedc56',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: '07c5fd6f-b41b-4018-8c32-a20221eedc56',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 532
                                },
                                {
                                    url: 'length',
                                    valueInteger: 23
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 563
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0337527',
                                display: 'Brothers'
                            }
                        ],
                        text: 'brother'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C1956346',
                                        display: 'Coronary Artery Disease'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/aod',
                                        code: '0000005327'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/bi',
                                        code: 'BI00010'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                        code: '0037465'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/csp',
                                        code: '1393-3397'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cst',
                                        code: 'CORONARY ART DIS'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/dxp',
                                        code: 'U000871'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                        code: 'HP:0001677'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                        code: 'I25.1'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                        code: 'MTHU019520'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc-2p',
                                        code: 'K76003'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'LP90122-0'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                        code: '10011078'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '35988'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                        code: '1276'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D003324'
                                    },
                                    {
                                        system: 'http://ncimeta.nci.nih.gov',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cellosaurus',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                        code: 'CDR0000439400'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/omim',
                                        code: 'MTHU002067'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                        code: 'XE2uV'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'D3-13000'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '414024009'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/who',
                                        code: '0426'
                                    }
                                ],
                                text: 'coronary artery disease'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/b61107e1-6158-4d28-8806-6e8920846f73',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: 'b61107e1-6158-4d28-8806-6e8920846f73',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 532
                                },
                                {
                                    url: 'length',
                                    valueInteger: 23
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 635
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0337527',
                                display: 'Brothers'
                            }
                        ],
                        text: 'brother'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C1956346',
                                        display: 'Coronary Artery Disease'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/aod',
                                        code: '0000005327'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/bi',
                                        code: 'BI00010'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                        code: '0037465'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/csp',
                                        code: '1393-3397'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cst',
                                        code: 'CORONARY ART DIS'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/dxp',
                                        code: 'U000871'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                        code: 'HP:0001677'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                        code: 'I25.1'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                        code: 'MTHU019520'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc-2p',
                                        code: 'K76003'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'LP90122-0'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                        code: '10011078'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '35988'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                        code: '1276'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D003324'
                                    },
                                    {
                                        system: 'http://ncimeta.nci.nih.gov',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cellosaurus',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                        code: 'C26732'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                        code: 'CDR0000439400'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/omim',
                                        code: 'MTHU002067'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                        code: 'XE2uV'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'D3-13000'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '414024009'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/who',
                                        code: '0426'
                                    }
                                ],
                                text: 'coronary artery disease'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/bc6d1390-7f80-4b20-9872-e4820e69916d',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: 'bc6d1390-7f80-4b20-9872-e4820e69916d',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 571
                                },
                                {
                                    url: 'length',
                                    valueInteger: 5
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 514
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 6
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0015576',
                                display: 'Family'
                            }
                        ],
                        text: 'family'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C0184532',
                                        display: 'Dying Process'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccc',
                                        code: 'E10.0'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/chv',
                                        code: '0000019055'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cpm',
                                        code: '65246'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'MTHU013352'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '314356'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/psy',
                                        code: '15550'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '399069006'
                                    }
                                ],
                                text: 'dying'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/43839ce7-b730-446e-8a4d-e6f96a2dbba1',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: '43839ce7-b730-446e-8a4d-e6f96a2dbba1',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 571
                                },
                                {
                                    url: 'length',
                                    valueInteger: 5
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 563
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0337527',
                                display: 'Brothers'
                            }
                        ],
                        text: 'brother'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C0184532',
                                        display: 'Dying Process'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccc',
                                        code: 'E10.0'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/chv',
                                        code: '0000019055'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cpm',
                                        code: '65246'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'MTHU013352'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '314356'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/psy',
                                        code: '15550'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '399069006'
                                    }
                                ],
                                text: 'dying'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/f941bebb-16f0-4034-b16e-90521718fcbd',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: 'f941bebb-16f0-4034-b16e-90521718fcbd',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 571
                                },
                                {
                                    url: 'length',
                                    valueInteger: 5
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 635
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0337527',
                                display: 'Brothers'
                            }
                        ],
                        text: 'brother'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C0184532',
                                        display: 'Dying Process'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccc',
                                        code: 'E10.0'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/chv',
                                        code: '0000019055'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cpm',
                                        code: '65246'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'MTHU013352'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '314356'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/psy',
                                        code: '15550'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '399069006'
                                    }
                                ],
                                text: 'dying'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/645e7c10-263f-41c1-887d-d12c369b0793',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: '645e7c10-263f-41c1-887d-d12c369b0793',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 601
                                },
                                {
                                    url: 'length',
                                    valueInteger: 21
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 514
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 6
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0015576',
                                display: 'Family'
                            }
                        ],
                        text: 'family'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C0027051',
                                        display: 'Myocardial Infarction'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/air',
                                        code: 'MYCNF'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/aod',
                                        code: '0000005332'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/bi',
                                        code: 'BI00102'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                        code: '1018028'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/chv',
                                        code: '0000008423'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/costar',
                                        code: '505'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/csp',
                                        code: '1393-3417'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cst',
                                        code: 'INFARCT MYOCARD'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                        code: 'HP:0001658'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                        code: 'I21'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                        code: 'MTHU037952'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc-2p',
                                        code: 'K75013'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                        code: 'sh85059683'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'LP98884-7'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                        code: '10028596'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '353001'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                        code: '5'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D009203'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                        code: '410.9'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nanda-i',
                                        code: '01329'
                                    },
                                    {
                                        system: 'http://ncimeta.nci.nih.gov',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cellosaurus',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_ctcae',
                                        code: 'E10152'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                        code: '1969'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_nichd',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/omim',
                                        code: 'MTHU008101'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/psy',
                                        code: '32820'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                        code: 'X200E'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'M-54700'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'D3-15000'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '22298006'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/who',
                                        code: '0428'
                                    }
                                ],
                                text: 'myocardial infarction'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/2083f343-ad34-465a-a983-053679cc921b',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: '2083f343-ad34-465a-a983-053679cc921b',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 601
                                },
                                {
                                    url: 'length',
                                    valueInteger: 21
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 563
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0337527',
                                display: 'Brothers'
                            }
                        ],
                        text: 'brother'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C0027051',
                                        display: 'Myocardial Infarction'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/air',
                                        code: 'MYCNF'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/aod',
                                        code: '0000005332'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/bi',
                                        code: 'BI00102'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                        code: '1018028'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/chv',
                                        code: '0000008423'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/costar',
                                        code: '505'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/csp',
                                        code: '1393-3417'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cst',
                                        code: 'INFARCT MYOCARD'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                        code: 'HP:0001658'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                        code: 'I21'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                        code: 'MTHU037952'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc-2p',
                                        code: 'K75013'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                        code: 'sh85059683'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'LP98884-7'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                        code: '10028596'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '353001'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                        code: '5'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D009203'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                        code: '410.9'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nanda-i',
                                        code: '01329'
                                    },
                                    {
                                        system: 'http://ncimeta.nci.nih.gov',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cellosaurus',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_ctcae',
                                        code: 'E10152'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                        code: '1969'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_nichd',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/omim',
                                        code: 'MTHU008101'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/psy',
                                        code: '32820'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                        code: 'X200E'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'M-54700'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'D3-15000'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '22298006'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/who',
                                        code: '0428'
                                    }
                                ],
                                text: 'myocardial infarction'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/a67da884-1ec7-4995-ab87-6a8ef1c57e54',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: 'a67da884-1ec7-4995-ab87-6a8ef1c57e54',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 601
                                },
                                {
                                    url: 'length',
                                    valueInteger: 21
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 635
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0337527',
                                display: 'Brothers'
                            }
                        ],
                        text: 'brother'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C0027051',
                                        display: 'Myocardial Infarction'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/air',
                                        code: 'MYCNF'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/aod',
                                        code: '0000005332'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/bi',
                                        code: 'BI00102'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                        code: '1018028'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/chv',
                                        code: '0000008423'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/costar',
                                        code: '505'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/csp',
                                        code: '1393-3417'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/cst',
                                        code: 'INFARCT MYOCARD'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                        code: 'HP:0001658'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                        code: 'I21'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                        code: 'MTHU037952'
                                    },
                                    {
                                        system: 'http://hl7.org/fhir/sid/icpc-2p',
                                        code: 'K75013'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                        code: 'sh85059683'
                                    },
                                    {
                                        system: 'http://loinc.org',
                                        code: 'LP98884-7'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                        code: '10028596'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '353001'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                        code: '5'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D009203'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                        code: '410.9'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nanda-i',
                                        code: '01329'
                                    },
                                    {
                                        system: 'http://ncimeta.nci.nih.gov',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cellosaurus',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_ctcae',
                                        code: 'E10152'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                        code: '1969'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_gdc',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_nichd',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                        code: 'C27996'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/omim',
                                        code: 'MTHU008101'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/psy',
                                        code: '32820'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                        code: 'X200E'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'M-54700'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: 'D3-15000'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '22298006'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/who',
                                        code: '0428'
                                    }
                                ],
                                text: 'myocardial infarction'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'FamilyMemberHistory/ef54f492-fbf3-4b8f-80d2-c16781564a69',
                resource: {
                    resourceType: 'FamilyMemberHistory',
                    id: 'ef54f492-fbf3-4b8f-80d2-c16781564a69',
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 1081
                                },
                                {
                                    url: 'length',
                                    valueInteger: 17
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    patient: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    relationship: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 1054
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 6
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0015576',
                                display: 'Family'
                            }
                        ],
                        text: 'family'
                    },
                    condition: [
                        {
                            code: {
                                codig: [
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls',
                                        code: 'C1299433',
                                        display: 'Left Main Coronary Artery Disease'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                        code: '339763'
                                    },
                                    {
                                        system: 'http://www.nlm.nih.gov/research/umls/msh',
                                        code: 'D003324'
                                    },
                                    {
                                        system: 'http://snomed.info/sct',
                                        code: '371804009'
                                    }
                                ],
                                text: 'left main disease'
                            }
                        }
                    ]
                }
            },
            {
                fullUrl: 'Procedure/eb54ec36-5b40-4a2f-9187-b826bd4f5cd0',
                resource: {
                    resourceType: 'Procedure',
                    id: 'eb54ec36-5b40-4a2f-9187-b826bd4f5cd0',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-procedure']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 662
                                },
                                {
                                    url: 'length',
                                    valueInteger: 31
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0010055',
                                display: 'Coronary Artery Bypass Surgery'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000008214'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/bi',
                                code: 'BI00768'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '0000669'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccs',
                                code: '7.2'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccsr_icd10pcs',
                                code: 'CAR003'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000003366'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/costar',
                                code: '208'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '1396-8456'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-9-cm',
                                code: '36.10'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc-2p',
                                code: 'K54007'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85005874'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LA14276-2'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10011077'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '342508'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                code: '202'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D001026'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C51998'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                code: 'C51998'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000513055'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'X00tE'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'P-1436'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'P1-33840'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '232717009'
                            }
                        ],
                        text: 'coronary artery bypass grafting'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    _performedDateTime: {
                        extension: [
                            {
                                url: 'http://hl7.org/fhir/StructureDefinition/data-absent-reason',
                                valueCode: 'unknown'
                            }
                        ]
                    }
                }
            },
            {
                fullUrl: 'Procedure/90485156-d230-42d8-8c6f-8209e67390c0',
                resource: {
                    resourceType: 'Procedure',
                    id: '90485156-d230-42d8-8c6f-8209e67390c0',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-procedure']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 1149
                                },
                                {
                                    url: 'length',
                                    valueInteger: 17
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0581603',
                                display: 'Revascularization - action'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000008211'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000040599'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '0579-1046'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'Xa6ZQ'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcdae',
                                code: 'Xa6ZQ'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '297183000'
                            }
                        ],
                        text: 'revascularization'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    _performedDateTime: {
                        extension: [
                            {
                                url: 'http://hl7.org/fhir/StructureDefinition/data-absent-reason',
                                valueCode: 'unknown'
                            }
                        ]
                    },
                    bodySite: [
                        {
                            extension: [
                                {
                                    extension: [
                                        {
                                            url: 'offset',
                                            valueInteger: 1128
                                        },
                                        {
                                            url: 'length',
                                            valueInteger: 3
                                        }
                                    ],
                                    url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                                }
                            ],
                            coding: [
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls',
                                    code: 'C1261316',
                                    display: 'Right coronary artery structure'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/chv',
                                    code: '0000056439'
                                },
                                {
                                    system: 'http://www.ama-assn.org/go/cpt',
                                    code: 'RC'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/csp',
                                    code: '1398-9631'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/fma',
                                    code: '50039'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/hcpcs',
                                    code: 'RC'
                                },
                                {
                                    system: 'http://ncimeta.nci.nih.gov',
                                    code: 'C12875'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                    code: 'C12875'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: 'T-43200'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: 'T-43200'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: '13647002'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/uwda',
                                    code: '50039'
                                }
                            ],
                            text: 'RCA'
                        }
                    ]
                }
            },
            {
                fullUrl: 'Procedure/839f9496-fb82-4434-becc-dbba4c826f30',
                resource: {
                    resourceType: 'Procedure',
                    id: '839f9496-fb82-4434-becc-dbba4c826f30',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-procedure']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 1172
                                },
                                {
                                    url: 'length',
                                    valueInteger: 18
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    status: 'completed',
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0189745',
                                display: 'Open heart surgery'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000019333'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10048935'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                code: '4119'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'P1-31004'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '2598006'
                            }
                        ],
                        text: 'open heart surgery'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    _performedDateTime: {
                        extension: [
                            {
                                url: 'http://hl7.org/fhir/StructureDefinition/data-absent-reason',
                                valueCode: 'unknown'
                            }
                        ]
                    }
                }
            },
            {
                fullUrl: 'Condition/4fc81212-3f03-41ee-8e28-d7bd5c7b6f77',
                resource: {
                    resourceType: 'Condition',
                    id: '4fc81212-3f03-41ee-8e28-d7bd5c7b6f77',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 451
                                },
                                {
                                    url: 'length',
                                    valueInteger: 9
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0028778',
                                display: 'Obstruction'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000004470'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1002744'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000008870'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                code: 'MTHU053672'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch',
                                code: 'U006537'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'LP222112-7'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10061876'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mth',
                                code: 'U003467'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C3284'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                code: 'C3284'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                code: '2422'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000044954'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                code: 'C3284'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'X79q0'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'M-34000'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'M-34000'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '26036001'
                            }
                        ],
                        text: 'occlusion'
                    },
                    bodySite: [
                        {
                            extension: [
                                {
                                    extension: [
                                        {
                                            url: 'offset',
                                            valueInteger: 468
                                        },
                                        {
                                            url: 'length',
                                            valueInteger: 3
                                        }
                                    ],
                                    url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                                }
                            ],
                            coding: [
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls',
                                    code: 'C1261316',
                                    display: 'Right coronary artery structure'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/chv',
                                    code: '0000056439'
                                },
                                {
                                    system: 'http://www.ama-assn.org/go/cpt',
                                    code: 'RC'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/csp',
                                    code: '1398-9631'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/fma',
                                    code: '50039'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/hcpcs',
                                    code: 'RC'
                                },
                                {
                                    system: 'http://ncimeta.nci.nih.gov',
                                    code: 'C12875'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                    code: 'C12875'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: 'T-43200'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: 'T-43200'
                                },
                                {
                                    system: 'http://snomed.info/sct',
                                    code: '13647002'
                                },
                                {
                                    system: 'http://www.nlm.nih.gov/research/umls/uwda',
                                    code: '50039'
                                }
                            ],
                            text: 'RCA'
                        }
                    ],
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    note: [
                        {
                            extension: [
                                {
                                    extension: [
                                        {
                                            url: 'offset',
                                            valueInteger: 445
                                        },
                                        {
                                            url: 'length',
                                            valueInteger: 5
                                        }
                                    ],
                                    url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                                }
                            ],
                            text: 'total'
                        }
                    ]
                }
            },
            {
                fullUrl: 'Condition/e992fd3a-4e31-4005-b8c2-47b552e5850b',
                resource: {
                    resourceType: 'Condition',
                    id: 'e992fd3a-4e31-4005-b8c2-47b552e5850b',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 773
                                },
                                {
                                    url: 'length',
                                    valueInteger: 25
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'refuted',
                                display: 'Refuted'
                            }
                        ],
                        text: 'Refuted'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        tex: 'wall motion abnormalities'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    }
                }
            },
            {
                fullUrl: 'Condition/dd81a484-85bf-4da8-a190-6ef066a866c8',
                resource: {
                    resourceType: 'Condition',
                    id: 'dd81a484-85bf-4da8-a190-6ef066a866c8',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 839
                                },
                                {
                                    url: 'length',
                                    valueInteger: 12
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C1318474',
                                display: 'Assessment of body build'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000058128'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '62294'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: '3851.'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '165184000'
                            }
                        ],
                        text: 'body habitus'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    }
                }
            },
            {
                fullUrl: 'Condition/5280f74a-691f-4079-b4c6-e2653ba4462f',
                resource: {
                    resourceType: 'Condition',
                    id: '5280f74a-691f-4079-b4c6-e2653ba4462f',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 899
                                },
                                {
                                    url: 'length',
                                    valueInteger: 44
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    severity: {
                        extension: [
                            {
                                extension: [
                                    {
                                        url: 'offset',
                                        valueInteger: 891
                                    },
                                    {
                                        url: 'length',
                                        valueInteger: 7
                                    }
                                ],
                                url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                            }
                        ],
                        coding: [
                            {
                                system: 'http://snomed.info/sct',
                                code: '255604002',
                                display: 'Mild'
                            }
                        ],
                        text: 'minimal'
                    },
                    code: {
                        tex: 'ST depressions in the anterior lateral leads'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    onsetString: 'six minutes'
                }
            },
            {
                fullUrl: 'Condition/d939d8e8-6ad3-4da7-a058-c944cd83cd15',
                resource: {
                    resourceType: 'Condition',
                    id: 'd939d8e8-6ad3-4da7-a058-c944cd83cd15',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 961
                                },
                                {
                                    url: 'length',
                                    valueInteger: 7
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0015672',
                                display: 'Fatigue'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/air',
                                code: 'FATIG'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000001768'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/bi',
                                code: 'BI00028'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccc',
                                code: 'A01.4'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1014729'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000004914'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/costar',
                                code: '298'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/cpm',
                                code: '65221'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/csp',
                                code: '1385-2059'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/cst',
                                code: 'ASTHENIA'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/dxp',
                                code: 'U001451'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                code: 'HP:0012378'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                code: 'R53.83'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/icnp',
                                code: '10000695'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                code: 'MTHU080142'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc-2p',
                                code: 'A04004'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch',
                                code: 'U001739'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85047465'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'MTHU013358'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10016256'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '273174'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                code: '5324'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/msh',
                                code: 'D005221'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                code: '780.79'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nanda-i',
                                code: '00742'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C3036'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                code: 'C3036'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctcae',
                                code: 'E11098'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_ctrp',
                                code: 'C3036'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_fda',
                                code: '1849'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000321374'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nichd',
                                code: 'C3036'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                code: 'C3036'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/noc',
                                code: '121028'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/omim',
                                code: 'MTHU010062'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pcds',
                                code: 'PRB_00010.03'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/pdq',
                                code: 'CDR0000041390'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/psy',
                                code: '19400'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: '1682.'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'F-01610'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'F-01360'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '84229001'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/who',
                                code: '0724'
                            }
                        ],
                        text: 'fatigue'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    }
                }
            },
            {
                fullUrl: 'Condition/ce87cf28-0dfb-4a3b-ac98-206e1743923d',
                resource: {
                    resourceType: 'Condition',
                    id: 'ce87cf28-0dfb-4a3b-ac98-206e1743923d',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 973
                                },
                                {
                                    url: 'length',
                                    valueInteger: 10
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0221785',
                                display: 'Pain in wrist'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/bi',
                                code: 'BI00504'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1016217'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000021489'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/costar',
                                code: 'U000624'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/dxp',
                                code: 'U004491'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/hpo',
                                code: 'HP:0030836'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                code: 'M25.53'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                code: 'MTHU060847'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc-2p',
                                code: 'L11002'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10048692'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '939'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/omim',
                                code: 'MTHU016462'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rcd',
                                code: 'N094F'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'F-176A0'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: '56608008'
                            }
                        ],
                        text: 'wrist pain'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    }
                }
            },
            {
                fullUrl: 'Condition/5db73030-1c49-4ab2-8ad8-7613a0181013',
                resource: {
                    resourceType: 'Condition',
                    id: '5db73030-1c49-4ab2-8ad8-7613a0181013',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 990
                                },
                                {
                                    url: 'length',
                                    valueInteger: 18
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C0741034',
                                display: 'Anginal equivalent'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '1017783'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/chv',
                                code: '0000047213'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-cm',
                                code: 'I20.8'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mdr',
                                code: '10076419'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/mthicd9',
                                code: '413.9'
                            }
                        ],
                        text: 'anginal equivalent'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    }
                }
            },
            {
                fullUrl: 'Condition/62630a49-d271-4edc-aec3-f3d47f7194b6',
                resource: {
                    resourceType: 'Condition',
                    id: '62630a49-d271-4edc-aec3-f3d47f7194b6',
                    meta: {
                        profile: ['http://hl7.org/fhir/us/core/StructureDefinition/us-core-condition']
                    },
                    extension: [
                        {
                            extension: [
                                {
                                    url: 'offset',
                                    valueInteger: 1041
                                },
                                {
                                    url: 'length',
                                    valueInteger: 8
                                }
                            ],
                            url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                        }
                    ],
                    verificationStatus: {
                        coding: [
                            {
                                system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
                                code: 'confirmed',
                                display: 'Confirmed'
                            }
                        ],
                        text: 'Confirmed'
                    },
                    category: [
                        {
                            coding: [
                                {
                                    system: 'http://terminology.hl7.org/CodeSystem/condition-category',
                                    code: 'problem-list-item',
                                    display: 'Problem List Item'
                                }
                            ],
                            text: 'Problem List Item'
                        }
                    ],
                    code: {
                        codig: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls',
                                code: 'C1457887',
                                display: 'Symptoms'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/aod',
                                code: '0000004363'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/ccpss',
                                code: '0009963'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/cst',
                                code: 'GENSYMPTOMS'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icd-9-cm',
                                code: '780-789.99'
                            },
                            {
                                system: 'http://hl7.org/fhir/sid/icpc2icd10eng',
                                code: 'MTHU072482'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/lch_nw',
                                code: 'sh85131555'
                            },
                            {
                                system: 'http://loinc.org',
                                code: 'MTHU021540'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medcin',
                                code: '2952'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/medlineplus',
                                code: '31'
                            },
                            {
                                system: 'http://ncimeta.nci.nih.gov',
                                code: 'C4876'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cdisc',
                                code: 'SDTM-SCTESTCD'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_nci-gloss',
                                code: 'CDR0000045022'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/nci_cadsr',
                                code: 'C4876'
                            },
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/psy',
                                code: '51140'
                            },
                            {
                                system: 'http://snomed.info/sct',
                                code: 'F-01250'
                            }
                        ],
                        text: 'symptoms'
                    },
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    note: [
                        {
                            extension: [
                                {
                                    extension: [
                                        {
                                            url: 'offset',
                                            valueInteger: 1031
                                        },
                                        {
                                            url: 'length',
                                            valueInteger: 9
                                        }
                                    ],
                                    url: 'http://hl7.org/fhir/StructureDefinition/derivation-reference'
                                }
                            ],
                            text: 'increased'
                        }
                    ]
                }
            },
            {
                fullUrl: 'List/b0400cef-00b0-4501-a2b1-29708ec622f6',
                resource: {
                    resourceType: 'List',
                    id: 'b0400cef-00b0-4501-a2b1-29708ec622f6',
                    status: 'current',
                    mode: 'snapshot',
                    title: 'HISTORY OF PRESENT ILLNESS',
                    subject: {
                        reference: 'Patient/e268cef8-82fd-4dae-8cc1-3526ca138515',
                        type: 'Patient'
                    },
                    encounter: {
                        reference: 'Encounter/9a7dd951-2bb2-4269-8b95-3f2fdd68ae5a',
                        type: 'Encounter',
                        display: 'unknown'
                    },
                    entry: [
                        {
                            item: {
                                reference: 'Observation/84adc6a6-dc83-4833-9e95-d640d113f9d1',
                                type: 'Observation',
                                display: 'cardiac catheterization'
                            }
                        },
                        {
                            item: {
                                reference: 'Observation/29b8a849-3423-4e67-b9dc-789a398921ed',
                                type: 'Observation',
                                display: 'stress echocardiogram'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/21c78548-c31e-4d43-aa7c-cd2afff428ac',
                                type: 'Condition',
                                display: 'angina'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/2a7e5d75-8b04-49ae-b179-20a2a84c35c8',
                                type: 'Condition',
                                display: 'disease'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/84639dd6-292a-400c-b90d-f050f287bbd6',
                                type: 'FamilyMemberHistory',
                                display: 'coronary artery disease'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/07c5fd6f-b41b-4018-8c32-a20221eedc56',
                                type: 'FamilyMemberHistory',
                                display: 'coronary artery disease'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/b61107e1-6158-4d28-8806-6e8920846f73',
                                type: 'FamilyMemberHistory',
                                display: 'coronary artery disease'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/bc6d1390-7f80-4b20-9872-e4820e69916d',
                                type: 'FamilyMemberHistory',
                                display: 'dying'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/43839ce7-b730-446e-8a4d-e6f96a2dbba1',
                                type: 'FamilyMemberHistory',
                                display: 'dying'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/f941bebb-16f0-4034-b16e-90521718fcbd',
                                type: 'FamilyMemberHistory',
                                display: 'dying'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/645e7c10-263f-41c1-887d-d12c369b0793',
                                type: 'FamilyMemberHistory',
                                display: 'myocardial infarction'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/2083f343-ad34-465a-a983-053679cc921b',
                                type: 'FamilyMemberHistory',
                                display: 'myocardial infarction'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/a67da884-1ec7-4995-ab87-6a8ef1c57e54',
                                type: 'FamilyMemberHistory',
                                display: 'myocardial infarction'
                            }
                        },
                        {
                            item: {
                                reference: 'FamilyMemberHistory/ef54f492-fbf3-4b8f-80d2-c16781564a69',
                                type: 'FamilyMemberHistory',
                                display: 'left main disease'
                            }
                        },
                        {
                            item: {
                                reference: 'Procedure/eb54ec36-5b40-4a2f-9187-b826bd4f5cd0',
                                type: 'Procedure',
                                display: 'coronary artery bypass grafting'
                            }
                        },
                        {
                            item: {
                                reference: 'Procedure/90485156-d230-42d8-8c6f-8209e67390c0',
                                type: 'Procedure',
                                display: 'revascularization'
                            }
                        },
                        {
                            item: {
                                reference: 'Procedure/839f9496-fb82-4434-becc-dbba4c826f30',
                                type: 'Procedure',
                                display: 'open heart surgery'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/4fc81212-3f03-41ee-8e28-d7bd5c7b6f77',
                                type: 'Condition',
                                display: 'occlusion'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/e992fd3a-4e31-4005-b8c2-47b552e5850b',
                                type: 'Condition',
                                display: 'wall motion abnormalities'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/dd81a484-85bf-4da8-a190-6ef066a866c8',
                                type: 'Condition',
                                display: 'body habitus'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/5280f74a-691f-4079-b4c6-e2653ba4462f',
                                type: 'Condition',
                                display: 'ST depressions in the anterior lateral leads'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/d939d8e8-6ad3-4da7-a058-c944cd83cd15',
                                type: 'Condition',
                                display: 'fatigue'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/ce87cf28-0dfb-4a3b-ac98-206e1743923d',
                                type: 'Condition',
                                display: 'wrist pain'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/5db73030-1c49-4ab2-8ad8-7613a0181013',
                                type: 'Condition',
                                display: 'anginal equivalent'
                            }
                        },
                        {
                            item: {
                                reference: 'Condition/62630a49-d271-4edc-aec3-f3d47f7194b6',
                                type: 'Condition',
                                display: 'symptoms'
                            }
                        }
                    ]
                }
            }
        ]
    }
};

export const HealthcareEntitiesDemoSamplesJsonOutput: HealthcareEntitiesSampleSwaggers = {
    'Short Prescription': {
        documents: [
            {
                id: 'id__5384',
                entities: [
                    {
                        links: [],
                        offset: 22,
                        length: 6,
                        text: '100 mg',
                        isNegated: false,
                        category: 'Dosage',
                        confidenceScore: 0.99
                    },
                    {
                        offset: 32,
                        length: 9,
                        text: 'ibuprofen',
                        isNegated: false,
                        category: 'MedicationName',
                        confidenceScore: 1,
                        links: [
                            {
                                dataSource: 'UMLS',
                                id: 'C0020740'
                            },
                            {
                                dataSource: 'AOD',
                                id: '0000019879'
                            },
                            {
                                dataSource: 'ATC',
                                id: 'M01AE01'
                            },
                            {
                                dataSource: 'CCPSS',
                                id: '0046165'
                            },
                            {
                                dataSource: 'CHV',
                                id: '0000006519'
                            },
                            {
                                dataSource: 'CSP',
                                id: '2270-2077'
                            },
                            {
                                dataSource: 'DRUGBANK',
                                id: 'DB01050'
                            },
                            {
                                dataSource: 'GS',
                                id: '1611'
                            },
                            {
                                dataSource: 'LCH_NW',
                                id: 'sh97005926'
                            },
                            {
                                dataSource: 'LNC',
                                id: 'LP16165-0'
                            },
                            {
                                dataSource: 'MEDCIN',
                                id: '40458'
                            },
                            {
                                dataSource: 'MMSL',
                                id: 'd00015'
                            },
                            {
                                dataSource: 'MSH',
                                id: 'D007052'
                            },
                            {
                                dataSource: 'MTHSPL',
                                id: 'WK2XYI10QM'
                            },
                            {
                                dataSource: 'NCI',
                                id: 'C561'
                            },
                            {
                                dataSource: 'NCI_CTRP',
                                id: 'C561'
                            },
                            {
                                dataSource: 'NCI_DCP',
                                id: '00803'
                            },
                            {
                                dataSource: 'NCI_DTP',
                                id: 'NSC0256857'
                            },
                            {
                                dataSource: 'NCI_FDA',
                                id: 'WK2XYI10QM'
                            },
                            {
                                dataSource: 'NCI_NCI-GLOSS',
                                id: 'CDR0000613511'
                            },
                            {
                                dataSource: 'NDDF',
                                id: '002377'
                            },
                            {
                                dataSource: 'PDQ',
                                id: 'CDR0000040475'
                            },
                            {
                                dataSource: 'RCD',
                                id: 'x02MO'
                            },
                            {
                                dataSource: 'RXNORM',
                                id: '5640'
                            },
                            {
                                dataSource: 'SNM',
                                id: 'E-7772'
                            },
                            {
                                dataSource: 'SNMI',
                                id: 'C-603C0'
                            },
                            {
                                dataSource: 'SNOMEDCT_US',
                                id: '387207008'
                            },
                            {
                                dataSource: 'USP',
                                id: 'm39860'
                            },
                            {
                                dataSource: 'USPMG',
                                id: 'MTHU000060'
                            },
                            {
                                dataSource: 'VANDF',
                                id: '4017840'
                            }
                        ]
                    },
                    {
                        links: [],
                        offset: 47,
                        length: 4,
                        text: '3 mg',
                        isNegated: false,
                        category: 'Dosage',
                        confidenceScore: 0.99
                    },
                    {
                        offset: 55,
                        length: 9,
                        text: 'potassium',
                        isNegated: false,
                        category: 'MedicationName',
                        confidenceScore: 0.99,
                        links: [
                            {
                                dataSource: 'UMLS',
                                id: 'C0032821'
                            },
                            {
                                dataSource: 'AOD',
                                id: '0000002435'
                            },
                            {
                                dataSource: 'CCPSS',
                                id: '1006930'
                            },
                            {
                                dataSource: 'CHV',
                                id: '0000010004'
                            },
                            {
                                dataSource: 'CPM',
                                id: '32051'
                            },
                            {
                                dataSource: 'CSP',
                                id: '2390-5099'
                            },
                            {
                                dataSource: 'DRUGBANK',
                                id: 'DB14500'
                            },
                            {
                                dataSource: 'GS',
                                id: '2493'
                            },
                            {
                                dataSource: 'LCH',
                                id: 'U003782'
                            },
                            {
                                dataSource: 'LCH_NW',
                                id: 'sh85105593'
                            },
                            {
                                dataSource: 'LNC',
                                id: 'LP15098-4'
                            },
                            {
                                dataSource: 'MEDCIN',
                                id: '41250'
                            },
                            {
                                dataSource: 'MMSL',
                                id: '5321'
                            },
                            {
                                dataSource: 'MSH',
                                id: 'D011188'
                            },
                            {
                                dataSource: 'MTH',
                                id: 'U000145'
                            },
                            {
                                dataSource: 'MTHSPL',
                                id: 'RWP5GA015D'
                            },
                            {
                                dataSource: 'NCI',
                                id: 'C765'
                            },
                            {
                                dataSource: 'NCI_DCP',
                                id: '31091'
                            },
                            {
                                dataSource: 'NCI_FDA',
                                id: 'RWP5GA015D'
                            },
                            {
                                dataSource: 'NCI_NCI-GLOSS',
                                id: 'CDR0000044344'
                            },
                            {
                                dataSource: 'NDDF',
                                id: '000763'
                            },
                            {
                                dataSource: 'PSY',
                                id: '39750'
                            },
                            {
                                dataSource: 'RCD',
                                id: 'X80D4'
                            },
                            {
                                dataSource: 'RXNORM',
                                id: '8588'
                            },
                            {
                                dataSource: 'SNM',
                                id: 'F-10530'
                            },
                            {
                                dataSource: 'SNMI',
                                id: 'C-13500'
                            },
                            {
                                dataSource: 'SNOMEDCT_US',
                                id: '88480006'
                            },
                            {
                                dataSource: 'VANDF',
                                id: '4017695'
                            }
                        ]
                    },
                    {
                        links: [],
                        offset: 85,
                        length: 5,
                        text: '10 mg',
                        isNegated: false,
                        category: 'Dosage',
                        confidenceScore: 1
                    },
                    {
                        offset: 94,
                        length: 5,
                        text: 'Zocor',
                        isNegated: false,
                        category: 'MedicationName',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0678181' },
                            { dataSource: 'CHV', id: '0000042766' },
                            { dataSource: 'CSP', id: '5001-0024' },
                            { dataSource: 'MMSL', id: '1546' },
                            { dataSource: 'MSH', id: 'D019821' },
                            { dataSource: 'NCI', id: 'C29454' },
                            { dataSource: 'PDQ', id: 'CDR0000455226' },
                            { dataSource: 'RCD', id: 'x03d7' },
                            { dataSource: 'RXNORM', id: '196503' }
                        ]
                    },
                    {
                        links: [],
                        offset: 123,
                        length: 5,
                        text: '50 mg',
                        isNegated: false,
                        category: 'Dosage',
                        confidenceScore: 0.99
                    },
                    {
                        offset: 132,
                        length: 9,
                        isNegated: false,
                        text: 'ibuprofen',
                        category: 'MedicationName',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0020740' },
                            { dataSource: 'AOD', id: '0000019879' },
                            { dataSource: 'ATC', id: 'M01AE01' },
                            { dataSource: 'CCPSS', id: '0046165' },
                            { dataSource: 'CHV', id: '0000006519' },
                            { dataSource: 'CSP', id: '2270-2077' },
                            { dataSource: 'DRUGBANK', id: 'DB01050' },
                            { dataSource: 'GS', id: '1611' },
                            { dataSource: 'LCH_NW', id: 'sh97005926' },
                            { dataSource: 'LNC', id: 'LP16165-0' },
                            { dataSource: 'MEDCIN', id: '40458' },
                            { dataSource: 'MMSL', id: 'd00015' },
                            { dataSource: 'MSH', id: 'D007052' },
                            { dataSource: 'MTHSPL', id: 'WK2XYI10QM' },
                            { dataSource: 'NCI', id: 'C561' },
                            { dataSource: 'NCI_CTRP', id: 'C561' },
                            { dataSource: 'NCI_DCP', id: '00803' },
                            { dataSource: 'NCI_DTP', id: 'NSC0256857' },
                            { dataSource: 'NCI_FDA', id: 'WK2XYI10QM' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000613511' },
                            { dataSource: 'NDDF', id: '002377' },
                            { dataSource: 'PDQ', id: 'CDR0000040475' },
                            { dataSource: 'RCD', id: 'x02MO' },
                            { dataSource: 'RXNORM', id: '5640' },
                            { dataSource: 'SNM', id: 'E-7772' },
                            { dataSource: 'SNMI', id: 'C-603C0' },
                            { dataSource: 'SNOMEDCT_US', id: '387207008' },
                            { dataSource: 'USP', id: 'm39860' },
                            { dataSource: 'USPMG', id: 'MTHU000060' },
                            { dataSource: 'VANDF', id: '4017840' }
                        ]
                    },
                    {
                        links: [],
                        offset: 147,
                        length: 4,
                        text: '2 mg',
                        isNegated: false,
                        category: 'Dosage',
                        confidenceScore: 0.99
                    },
                    {
                        offset: 155,
                        length: 8,
                        isNegated: false,
                        text: 'Coumadin',
                        category: 'MedicationName',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0699129' },
                            { dataSource: 'CHV', id: '0000044372' },
                            { dataSource: 'CSP', id: '0397-0420' },
                            { dataSource: 'MMSL', id: '146' },
                            { dataSource: 'MSH', id: 'D014859' },
                            { dataSource: 'NCI', id: 'C1658' },
                            { dataSource: 'NCI_DTP', id: 'NSC0059813' },
                            { dataSource: 'PDQ', id: 'CDR0000039740' },
                            { dataSource: 'RCD', id: 'x02iF' },
                            { dataSource: 'RXNORM', id: '202421' }
                        ]
                    }
                ],
                relations: [
                    {
                        bidirectional: false,
                        relationType: 'DosageOfMedication',
                        entities: [
                            { ref: '#/results/documents/0/entities/0', role: 'Dosage' },
                            { ref: '#/results/documents/0/entities/1', role: 'Medication' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'DosageOfMedication',
                        entities: [
                            { ref: '#/results/documents/0/entities/2', role: 'Dosage' },
                            { ref: '#/results/documents/0/entities/3', role: 'Medication' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'DosageOfMedication',
                        entities: [
                            { ref: '#/results/documents/0/entities/4', role: 'Dosage' },
                            { ref: '#/results/documents/0/entities/5', role: 'Medication' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'DosageOfMedication',
                        entities: [
                            { ref: '#/results/documents/0/entities/6', role: 'Dosage' },
                            { ref: '#/results/documents/0/entities/7', role: 'Medication' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'DosageOfMedication',
                        entities: [
                            { ref: '#/results/documents/0/entities/8', role: 'Dosage' },
                            { ref: '#/results/documents/0/entities/9', role: 'Medication' }
                        ]
                    }
                ],
                warnings: []
            }
        ],
        errors: []
    },
    'Patient Report': {
        documents: [
            {
                id: 'id__5597',
                entities: [
                    { links: [], offset: 53, length: 9, isNegated: false, text: '2/14/2001', category: 'Date', confidenceScore: 1 },
                    { links: [], offset: 63, length: 11, isNegated: false, text: '12:00:00 AM', category: 'Time', confidenceScore: 1 },
                    {
                        offset: 77,
                        length: 23,
                        isNegated: false,
                        text: 'CORONARY ARTERY DISEASE',
                        category: 'Diagnosis',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C1956346' },
                            { dataSource: 'AOD', id: '0000005327' },
                            { dataSource: 'BI', id: 'BI00010' },
                            { dataSource: 'CCPSS', id: '0037465' },
                            { dataSource: 'CSP', id: '1393-3397' },
                            { dataSource: 'CST', id: 'CORONARY ART DIS' },
                            { dataSource: 'DXP', id: 'U000871' },
                            { dataSource: 'HPO', id: 'HP:0001677' },
                            { dataSource: 'ICD10CM', id: 'I25.1' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU019520' },
                            { dataSource: 'ICPC2P', id: 'K76003' },
                            { dataSource: 'LNC', id: 'LP90122-0' },
                            { dataSource: 'MDR', id: '10011078' },
                            { dataSource: 'MEDCIN', id: '35988' },
                            { dataSource: 'MEDLINEPLUS', id: '1276' },
                            { dataSource: 'MSH', id: 'D003324' },
                            { dataSource: 'NCI', id: 'C26732' },
                            { dataSource: 'NCI_CELLOSAURUS', id: 'C26732' },
                            { dataSource: 'NCI_GDC', id: 'C26732' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000439400' },
                            { dataSource: 'OMIM', id: 'MTHU002067' },
                            { dataSource: 'RCD', id: 'XE2uV' },
                            { dataSource: 'SNMI', id: 'D3-13000' },
                            { dataSource: 'SNOMEDCT_US', id: '414024009' },
                            { dataSource: 'WHO', id: '0426' }
                        ]
                    },
                    {
                        links: [],
                        offset: 118,
                        length: 9,
                        isNegated: false,
                        text: 'Admission',
                        category: 'AdministrativeEvent',
                        confidenceScore: 1
                    },
                    {
                        links: [],
                        offset: 134,
                        length: 9,
                        isNegated: false,
                        text: '5/22/2001',
                        category: 'Date',
                        confidenceScore: 1
                    },
                    {
                        links: [],
                        offset: 166,
                        length: 9,
                        isNegated: false,
                        text: 'Discharge',
                        category: 'AdministrativeEvent',
                        confidenceScore: 0.99
                    },
                    {
                        links: [],
                        offset: 182,
                        length: 9,
                        isNegated: false,
                        text: '4/24/2001',
                        category: 'Date',
                        confidenceScore: 1
                    },
                    {
                        links: [],
                        offset: 192,
                        length: 9,
                        isNegated: false,
                        text: 'ADMISSION',
                        category: 'AdministrativeEvent',
                        confidenceScore: 0.99
                    },
                    {
                        offset: 213,
                        length: 23,
                        isNegated: false,
                        text: 'CORONARY ARTERY DISEASE',
                        category: 'Diagnosis',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C1956346' },
                            { dataSource: 'AOD', id: '0000005327' },
                            { dataSource: 'BI', id: 'BI00010' },
                            { dataSource: 'CCPSS', id: '0037465' },
                            { dataSource: 'CSP', id: '1393-3397' },
                            { dataSource: 'CST', id: 'CORONARY ART DIS' },
                            { dataSource: 'DXP', id: 'U000871' },
                            { dataSource: 'HPO', id: 'HP:0001677' },
                            { dataSource: 'ICD10CM', id: 'I25.1' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU019520' },
                            { dataSource: 'ICPC2P', id: 'K76003' },
                            { dataSource: 'LNC', id: 'LP90122-0' },
                            { dataSource: 'MDR', id: '10011078' },
                            { dataSource: 'MEDCIN', id: '35988' },
                            { dataSource: 'MEDLINEPLUS', id: '1276' },
                            { dataSource: 'MSH', id: 'D003324' },
                            { dataSource: 'NCI', id: 'C26732' },
                            { dataSource: 'NCI_CELLOSAURUS', id: 'C26732' },
                            { dataSource: 'NCI_GDC', id: 'C26732' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000439400' },
                            { dataSource: 'OMIM', id: 'MTHU002067' },
                            { dataSource: 'RCD', id: 'XE2uV' },
                            { dataSource: 'SNMI', id: 'D3-13000' },
                            { dataSource: 'SNOMEDCT_US', id: '414024009' },
                            { dataSource: 'WHO', id: '0426' }
                        ]
                    },
                    {
                        links: [],
                        offset: 283,
                        length: 11,
                        isNegated: false,
                        text: '54-year-old',
                        category: 'Age',
                        confidenceScore: 1
                    },
                    {
                        offset: 295,
                        length: 9,
                        isNegated: false,
                        text: 'gentleman',
                        category: 'Gender',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0025266' },
                            { dataSource: 'AOD', id: '0000026918' },
                            { dataSource: 'CHV', id: '0000007919' },
                            { dataSource: 'LCH', id: 'U002897' },
                            { dataSource: 'LCH_NW', id: 'sh85083510' },
                            { dataSource: 'MEDLINEPLUS', id: '24' },
                            { dataSource: 'MSH', id: 'D008571' },
                            { dataSource: 'NCI', id: 'C14366' },
                            { dataSource: 'PSY', id: '30625' },
                            { dataSource: 'SNOMEDCT_US', id: '339947000' }
                        ]
                    },
                    {
                        links: [],
                        offset: 323,
                        length: 11,
                        isNegated: false,
                        text: 'progressive',
                        category: 'Course',
                        confidenceScore: 0.92
                    },
                    {
                        offset: 335,
                        length: 6,
                        text: 'angina',
                        isNegated: false,
                        category: 'SymptomOrSign',
                        confidenceScore: 0.61,
                        links: [
                            { dataSource: 'UMLS', id: 'C0002962' },
                            { dataSource: 'AOD', id: '0000005330' },
                            { dataSource: 'BI', id: 'BI00047' },
                            { dataSource: 'CCPSS', id: '1017852' },
                            { dataSource: 'CCS', id: '7.2.4.1' },
                            { dataSource: 'CHV', id: '0000001165' },
                            { dataSource: 'COSTAR', id: '054' },
                            { dataSource: 'CSP', id: '1393-3407' },
                            { dataSource: 'CST', id: 'ANGINA PECTORIS' },
                            { dataSource: 'DXP', id: 'U000113' },
                            { dataSource: 'HPO', id: 'HP:0001681' },
                            { dataSource: 'ICD10', id: 'I20.9' },
                            { dataSource: 'ICD10AM', id: 'I20.9' },
                            { dataSource: 'ICD10CM', id: 'I20.9' },
                            { dataSource: 'ICD9CM', id: '413' },
                            { dataSource: 'ICPC', id: 'K74' },
                            { dataSource: 'ICPC2EENG', id: 'K74' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU006338' },
                            { dataSource: 'ICPC2P', id: 'K74001' },
                            { dataSource: 'LCH', id: 'U000244' },
                            { dataSource: 'LCH_NW', id: 'sh85005022' },
                            { dataSource: 'LNC', id: 'LA14275-4' },
                            { dataSource: 'MDR', id: '10002383' },
                            { dataSource: 'MEDCIN', id: '33215' },
                            { dataSource: 'MEDLINEPLUS', id: '142' },
                            { dataSource: 'MSH', id: 'D000787' },
                            { dataSource: 'MTH', id: '053' },
                            { dataSource: 'MTHICD9', id: '413.9' },
                            { dataSource: 'MTHICPC2EAE', id: 'K74' },
                            { dataSource: 'NCI', id: 'C51221' },
                            { dataSource: 'NCI_CTCAE', id: 'E10110' },
                            { dataSource: 'NCI_FDA', id: '1710' },
                            { dataSource: 'NCI_NICHD', id: 'C51221' },
                            { dataSource: 'NOC', id: '040504' },
                            { dataSource: 'OMIM', id: 'MTHU009903' },
                            { dataSource: 'OMS', id: '29.13' },
                            { dataSource: 'PCDS', id: 'PRB_02040.07' },
                            { dataSource: 'PSY', id: '02530' },
                            { dataSource: 'QMR', id: 'Q0300326' },
                            { dataSource: 'RCD', id: 'G33..' },
                            { dataSource: 'RCDAE', id: 'Ua1eH' },
                            { dataSource: 'SNM', id: 'F-71500' },
                            { dataSource: 'SNMI', id: 'D3-12000' },
                            { dataSource: 'SNOMEDCT_US', id: '194828000' },
                            { dataSource: 'WHO', id: '0422' }
                        ]
                    },
                    {
                        links: [],
                        offset: 351,
                        length: 19,
                        isNegated: false,
                        text: 'past several months',
                        category: 'Time',
                        confidenceScore: 0.99
                    },
                    {
                        offset: 390,
                        length: 23,
                        isNegated: false,
                        text: 'cardiac catheterization',
                        category: 'ExaminationName',
                        confidenceScore: 0.99,
                        links: [
                            { dataSource: 'UMLS', id: 'C0018795' },
                            { dataSource: 'CCPSS', id: '1002003' },
                            { dataSource: 'CCS', id: '7.5.2' },
                            { dataSource: 'CHV', id: '0000005872' },
                            { dataSource: 'COSTAR', id: '154' },
                            { dataSource: 'CPT', id: '1013071' },
                            { dataSource: 'CSP', id: '1393-7244' },
                            { dataSource: 'ICD10AM', id: '667' },
                            { dataSource: 'ICD10AMAE', id: '667' },
                            { dataSource: 'LCH', id: 'U005615' },
                            { dataSource: 'LCH_NW', id: 'sh85020181' },
                            { dataSource: 'LNC', id: 'LP6170-7' },
                            { dataSource: 'MDR', id: '10007815' },
                            { dataSource: 'MEDCIN', id: '22704' },
                            { dataSource: 'MSH', id: 'D006328' },
                            { dataSource: 'MTH', id: 'U001971' },
                            { dataSource: 'MTHICD9', id: '37.21' },
                            { dataSource: 'NCI', id: 'C38044' },
                            { dataSource: 'NCI_CDISC', id: 'C38044' },
                            { dataSource: 'RCD', id: '7939.' },
                            { dataSource: 'RCDAE', id: '7939.' },
                            { dataSource: 'SNM', id: 'P-7200' },
                            { dataSource: 'SNMI', id: 'P1-31600' },
                            { dataSource: 'SNOMEDCT_US', id: '41976001' }
                        ]
                    },
                    {
                        links: [],
                        offset: 417,
                        length: 17,
                        isNegated: false,
                        text: 'July of this year',
                        category: 'Time',
                        confidenceScore: 0.98
                    },
                    {
                        links: [],
                        offset: 445,
                        length: 5,
                        text: 'total',
                        isNegated: false,
                        category: 'ConditionQualifier',
                        confidenceScore: 0.98
                    },
                    {
                        offset: 451,
                        length: 9,
                        isNegated: false,
                        text: 'occlusion',
                        category: 'SymptomOrSign',
                        confidenceScore: 0.99,
                        links: [
                            { dataSource: 'UMLS', id: 'C0028778' },
                            { dataSource: 'AOD', id: '0000004470' },
                            { dataSource: 'CCPSS', id: '1002744' },
                            { dataSource: 'CHV', id: '0000008870' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU053672' },
                            { dataSource: 'LCH', id: 'U006537' },
                            { dataSource: 'LNC', id: 'LP222112-7' },
                            { dataSource: 'MDR', id: '10061876' },
                            { dataSource: 'MTH', id: 'U003467' },
                            { dataSource: 'NCI', id: 'C3284' },
                            { dataSource: 'NCI_CDISC', id: 'C3284' },
                            { dataSource: 'NCI_FDA', id: '2422' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000044954' },
                            { dataSource: 'NCI_caDSR', id: 'C3284' },
                            { dataSource: 'RCD', id: 'X79q0' },
                            { dataSource: 'SNM', id: 'M-34000' },
                            { dataSource: 'SNMI', id: 'M-34000' },
                            { dataSource: 'SNOMEDCT_US', id: '26036001' }
                        ]
                    },
                    {
                        offset: 468,
                        length: 3,
                        text: 'RCA',
                        isNegated: false,
                        category: 'BodyStructure',
                        confidenceScore: 0.99,
                        links: [
                            { dataSource: 'UMLS', id: 'C1261316' },
                            { dataSource: 'CHV', id: '0000056439' },
                            { dataSource: 'CPT', id: 'RC' },
                            { dataSource: 'CSP', id: '1398-9631' },
                            { dataSource: 'FMA', id: '50039' },
                            { dataSource: 'HCPCS', id: 'RC' },
                            { dataSource: 'NCI', id: 'C12875' },
                            { dataSource: 'NCI_CDISC', id: 'C12875' },
                            { dataSource: 'SNM', id: 'T-43200' },
                            { dataSource: 'SNMI', id: 'T-43200' },
                            { dataSource: 'SNOMEDCT_US', id: '13647002' },
                            { dataSource: 'UWDA', id: '50039' }
                        ]
                    },
                    {
                        links: [],
                        offset: 476,
                        length: 2,
                        text: '50',
                        isNegated: false,
                        category: 'MeasurementValue',
                        confidenceScore: 1
                    },
                    {
                        links: [],
                        offset: 478,
                        length: 1,
                        text: '%',
                        isNegated: false,
                        category: 'MeasurementUnit',
                        confidenceScore: 1
                    },
                    {
                        offset: 480,
                        length: 9,
                        isNegated: false,
                        text: 'left main',
                        category: 'BodyStructure',
                        confidenceScore: 0.89,
                        links: [
                            { dataSource: 'UMLS', id: 'C1261082' },
                            { dataSource: 'CHV', id: '0000056387' },
                            { dataSource: 'CPT', id: 'LM' },
                            { dataSource: 'CSP', id: '1398-9631' },
                            { dataSource: 'FMA', id: '50040' },
                            { dataSource: 'HCPCS', id: 'LM' },
                            { dataSource: 'LNC', id: 'LP199529-1' },
                            { dataSource: 'NCI', id: 'C12872' },
                            { dataSource: 'NCI_CDISC', id: 'C12872' },
                            { dataSource: 'RCD', id: 'X74eC' },
                            { dataSource: 'SNM', id: 'T-43100' },
                            { dataSource: 'SNMI', id: 'T-43100' },
                            { dataSource: 'SNOMEDCT_US', id: '50018008' },
                            { dataSource: 'UWDA', id: '50040' }
                        ]
                    },
                    {
                        offset: 490,
                        length: 7,
                        text: 'disease',
                        isNegated: false,
                        category: 'Diagnosis',
                        confidenceScore: 0.79,
                        links: [
                            { dataSource: 'UMLS', id: 'C0012634' },
                            { dataSource: 'CCPSS', id: '0007490' },
                            { dataSource: 'CHV', id: '0000004014' },
                            { dataSource: 'CSP', id: '0944-4756' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU000256' },
                            { dataSource: 'ICPC2P', id: 'A99001' },
                            { dataSource: 'LCH', id: 'U001423' },
                            { dataSource: 'LCH_NW', id: 'sh85038411' },
                            { dataSource: 'LNC', id: 'LP21006-9' },
                            { dataSource: 'MEDCIN', id: '39448' },
                            { dataSource: 'MSH', id: 'D004194' },
                            { dataSource: 'NCI', id: 'C2991' },
                            { dataSource: 'NCI_CDISC-GLOSS', id: 'C2991' },
                            { dataSource: 'NCI_CTDC', id: 'C2991' },
                            { dataSource: 'NCI_CTRP', id: 'C2991' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000651193' },
                            { dataSource: 'NCI_NICHD', id: 'C2991' },
                            { dataSource: 'NCI_caDSR', id: 'C2991' },
                            { dataSource: 'PSY', id: '14520' },
                            { dataSource: 'RCD', id: 'X0003' },
                            { dataSource: 'SNM', id: 'D-Y000' },
                            { dataSource: 'SNMI', id: 'DF-00000' },
                            { dataSource: 'SNOMEDCT_US', id: '64572001' }
                        ]
                    },
                    {
                        offset: 514,
                        length: 6,
                        text: 'family',
                        isNegated: false,
                        category: 'FamilyRelation',
                        confidenceScore: 0.98,
                        links: [
                            { dataSource: 'UMLS', id: 'C0015576' },
                            { dataSource: 'AOD', id: '0000006914' },
                            { dataSource: 'CCPSS', id: '0030810' },
                            { dataSource: 'CHV', id: '0000004879' },
                            { dataSource: 'CSP', id: '1123-4254' },
                            { dataSource: 'LCH', id: 'U001730' },
                            { dataSource: 'LCH_NW', id: 'sh85047009' },
                            { dataSource: 'LNC', id: 'LP76012-1' },
                            { dataSource: 'MSH', id: 'D005190' },
                            { dataSource: 'NCI', id: 'C25173' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000460148' },
                            { dataSource: 'NCI_caDSR', id: 'C25173' },
                            { dataSource: 'OMS', id: 'MTHU000002' },
                            { dataSource: 'PSY', id: '19300' },
                            { dataSource: 'SNMI', id: 'S-10000' },
                            { dataSource: 'SNOMEDCT_US', id: '35359004' }
                        ]
                    },
                    {
                        offset: 532,
                        length: 23,
                        isNegated: false,
                        text: 'coronary artery disease',
                        category: 'Diagnosis',
                        confidenceScore: 1,
                        assertion: { association: 'other' },
                        links: [
                            { dataSource: 'UMLS', id: 'C1956346' },
                            { dataSource: 'AOD', id: '0000005327' },
                            { dataSource: 'BI', id: 'BI00010' },
                            { dataSource: 'CCPSS', id: '0037465' },
                            { dataSource: 'CSP', id: '1393-3397' },
                            { dataSource: 'CST', id: 'CORONARY ART DIS' },
                            { dataSource: 'DXP', id: 'U000871' },
                            { dataSource: 'HPO', id: 'HP:0001677' },
                            { dataSource: 'ICD10CM', id: 'I25.1' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU019520' },
                            { dataSource: 'ICPC2P', id: 'K76003' },
                            { dataSource: 'LNC', id: 'LP90122-0' },
                            { dataSource: 'MDR', id: '10011078' },
                            { dataSource: 'MEDCIN', id: '35988' },
                            { dataSource: 'MEDLINEPLUS', id: '1276' },
                            { dataSource: 'MSH', id: 'D003324' },
                            { dataSource: 'NCI', id: 'C26732' },
                            { dataSource: 'NCI_CELLOSAURUS', id: 'C26732' },
                            { dataSource: 'NCI_GDC', id: 'C26732' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000439400' },
                            { dataSource: 'OMIM', id: 'MTHU002067' },
                            { dataSource: 'RCD', id: 'XE2uV' },
                            { dataSource: 'SNMI', id: 'D3-13000' },
                            { dataSource: 'SNOMEDCT_US', id: '414024009' },
                            { dataSource: 'WHO', id: '0426' }
                        ]
                    },
                    {
                        offset: 563,
                        length: 7,
                        text: 'brother',
                        isNegated: false,
                        category: 'FamilyRelation',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0337527' },
                            { dataSource: 'CHV', id: '0000030335' },
                            { dataSource: 'CSP', id: '1124-5700' },
                            { dataSource: 'HL7V3.0', id: 'BRO' },
                            { dataSource: 'LNC', id: 'LP29863-5' },
                            { dataSource: 'MSH', id: 'D035781' },
                            { dataSource: 'NCI', id: 'C25289' },
                            { dataSource: 'NCI_GDC', id: 'C25289' },
                            { dataSource: 'NCI_caDSR', id: 'C25289' },
                            { dataSource: 'PSY', id: '07020' },
                            { dataSource: 'SNMI', id: 'S-10160' },
                            { dataSource: 'SNOMEDCT_US', id: '70924004' }
                        ]
                    },
                    {
                        offset: 571,
                        length: 5,
                        text: 'dying',
                        isNegated: false,
                        category: 'Diagnosis',
                        assertion: { association: 'other' },
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0184532' },
                            { dataSource: 'CCC', id: 'E10.0' },
                            { dataSource: 'CHV', id: '0000019055' },
                            { dataSource: 'CPM', id: '65246' },
                            { dataSource: 'LNC', id: 'MTHU013352' },
                            { dataSource: 'MEDCIN', id: '314356' },
                            { dataSource: 'PSY', id: '15550' },
                            { dataSource: 'SNOMEDCT_US', id: '399069006' }
                        ]
                    },
                    {
                        links: [],
                        offset: 591,
                        length: 2,
                        text: '52',
                        isNegated: false,
                        category: 'Age',
                        confidenceScore: 1
                    },
                    {
                        offset: 601,
                        length: 21,
                        isNegated: false,
                        text: 'myocardial infarction',
                        category: 'Diagnosis',
                        assertion: { association: 'other' },
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0027051' },
                            { dataSource: 'AIR', id: 'MYCNF' },
                            { dataSource: 'AOD', id: '0000005332' },
                            { dataSource: 'BI', id: 'BI00102' },
                            { dataSource: 'CCPSS', id: '1018028' },
                            { dataSource: 'CHV', id: '0000008423' },
                            { dataSource: 'COSTAR', id: '505' },
                            { dataSource: 'CSP', id: '1393-3417' },
                            { dataSource: 'CST', id: 'INFARCT MYOCARD' },
                            { dataSource: 'HPO', id: 'HP:0001658' },
                            { dataSource: 'ICD10CM', id: 'I21' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU037952' },
                            { dataSource: 'ICPC2P', id: 'K75013' },
                            { dataSource: 'LCH_NW', id: 'sh85059683' },
                            { dataSource: 'LNC', id: 'LP98884-7' },
                            { dataSource: 'MDR', id: '10028596' },
                            { dataSource: 'MEDCIN', id: '353001' },
                            { dataSource: 'MEDLINEPLUS', id: '5' },
                            { dataSource: 'MSH', id: 'D009203' },
                            { dataSource: 'MTHICD9', id: '410.9' },
                            { dataSource: 'NANDA-I', id: '01329' },
                            { dataSource: 'NCI', id: 'C27996' },
                            { dataSource: 'NCI_CELLOSAURUS', id: 'C27996' },
                            { dataSource: 'NCI_CTCAE', id: 'E10152' },
                            { dataSource: 'NCI_FDA', id: '1969' },
                            { dataSource: 'NCI_GDC', id: 'C27996' },
                            { dataSource: 'NCI_NICHD', id: 'C27996' },
                            { dataSource: 'NCI_caDSR', id: 'C27996' },
                            { dataSource: 'OMIM', id: 'MTHU008101' },
                            { dataSource: 'PSY', id: '32820' },
                            { dataSource: 'RCD', id: 'X200E' },
                            { dataSource: 'SNM', id: 'M-54700' },
                            { dataSource: 'SNMI', id: 'D3-15000' },
                            { dataSource: 'SNOMEDCT_US', id: '22298006' },
                            { dataSource: 'WHO', id: '0428' }
                        ]
                    },
                    {
                        offset: 635,
                        length: 7,
                        text: 'brother',
                        isNegated: false,
                        category: 'FamilyRelation',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0337527' },
                            { dataSource: 'CHV', id: '0000030335' },
                            { dataSource: 'CSP', id: '1124-5700' },
                            { dataSource: 'HL7V3.0', id: 'BRO' },
                            { dataSource: 'LNC', id: 'LP29863-5' },
                            { dataSource: 'MSH', id: 'D035781' },
                            { dataSource: 'NCI', id: 'C25289' },
                            { dataSource: 'NCI_GDC', id: 'C25289' },
                            { dataSource: 'NCI_caDSR', id: 'C25289' },
                            { dataSource: 'PSY', id: '07020' },
                            { dataSource: 'SNMI', id: 'S-10160' },
                            { dataSource: 'SNOMEDCT_US', id: '70924004' }
                        ]
                    },
                    {
                        offset: 662,
                        length: 31,
                        isNegated: false,
                        text: 'coronary artery bypass grafting',
                        category: 'TreatmentName',
                        confidenceScore: 0.99,
                        links: [
                            { dataSource: 'UMLS', id: 'C0010055' },
                            { dataSource: 'AOD', id: '0000008214' },
                            { dataSource: 'BI', id: 'BI00768' },
                            { dataSource: 'CCPSS', id: '0000669' },
                            { dataSource: 'CCS', id: '7.2' },
                            { dataSource: 'CCSR_ICD10PCS', id: 'CAR003' },
                            { dataSource: 'CCS_10', id: '44' },
                            { dataSource: 'CHV', id: '0000003366' },
                            { dataSource: 'COSTAR', id: '208' },
                            { dataSource: 'CSP', id: '1396-8456' },
                            { dataSource: 'ICD9CM', id: '36.10' },
                            { dataSource: 'ICPC2P', id: 'K54007' },
                            { dataSource: 'LCH_NW', id: 'sh85005874' },
                            { dataSource: 'LNC', id: 'LA14276-2' },
                            { dataSource: 'MDR', id: '10011077' },
                            { dataSource: 'MEDCIN', id: '342508' },
                            { dataSource: 'MEDLINEPLUS', id: '202' },
                            { dataSource: 'MSH', id: 'D001026' },
                            { dataSource: 'NCI', id: 'C51998' },
                            { dataSource: 'NCI_CDISC', id: 'C51998' },
                            { dataSource: 'NCI_CPTAC', id: 'C51998' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000513055' },
                            { dataSource: 'RCD', id: 'X00tE' },
                            { dataSource: 'SNM', id: 'P-1436' },
                            { dataSource: 'SNMI', id: 'P1-33840' },
                            { dataSource: 'SNOMEDCT_US', id: '232717009' }
                        ]
                    },
                    {
                        offset: 713,
                        length: 21,
                        isNegated: false,
                        text: 'stress echocardiogram',
                        category: 'ExaminationName',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0920208' },
                            { dataSource: 'CHV', id: '0000052531' },
                            { dataSource: 'LCH_NW', id: 'sh91004821' },
                            { dataSource: 'LNC', id: 'LA28649-4' },
                            { dataSource: 'MDR', id: '10050241' },
                            { dataSource: 'MSH', id: 'D025401' },
                            { dataSource: 'NCI', id: 'C80407' },
                            { dataSource: 'NCI_CDISC', id: 'C80407' },
                            { dataSource: 'SNOMEDCT_US', id: '816996009' }
                        ]
                    },
                    {
                        links: [],
                        offset: 743,
                        length: 11,
                        isNegated: false,
                        text: 'July , 2001',
                        category: 'Time',
                        confidenceScore: 0.99
                    },
                    {
                        links: [],
                        offset: 773,
                        length: 25,
                        isNegated: false,
                        assertion: { certainty: 'negative' },
                        text: 'wall motion abnormalities',
                        category: 'SymptomOrSign',
                        confidenceScore: 1
                    },
                    {
                        offset: 839,
                        length: 4,
                        text: 'body',
                        isNegated: false,
                        category: 'SymptomOrSign',
                        confidenceScore: 0.59,
                        links: [
                            { dataSource: 'UMLS', id: 'C0152338' },
                            { dataSource: 'FMA', id: '61853' },
                            { dataSource: 'NEU', id: '228' },
                            { dataSource: 'SNM', id: 'T-X3221' },
                            { dataSource: 'SNMI', id: 'T-A3221' },
                            { dataSource: 'SNOMEDCT_US', id: '31476009' }
                        ]
                    },
                    {
                        links: [],
                        offset: 874,
                        length: 11,
                        isNegated: false,
                        text: 'six minutes',
                        category: 'Time',
                        confidenceScore: 0.94
                    },
                    {
                        links: [],
                        offset: 891,
                        length: 7,
                        text: 'minimal',
                        isNegated: false,
                        category: 'ConditionQualifier',
                        confidenceScore: 0.99
                    },
                    {
                        links: [],
                        offset: 899,
                        length: 44,
                        isNegated: false,
                        text: 'ST depressions in the anterior lateral leads',
                        category: 'SymptomOrSign',
                        confidenceScore: 0.97
                    },
                    {
                        offset: 961,
                        length: 7,
                        text: 'fatigue',
                        isNegated: false,
                        category: 'SymptomOrSign',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0015672' },
                            { dataSource: 'AIR', id: 'FATIG' },
                            { dataSource: 'AOD', id: '0000001768' },
                            { dataSource: 'BI', id: 'BI00028' },
                            { dataSource: 'CCC', id: 'A01.4' },
                            { dataSource: 'CCPSS', id: '1014729' },
                            { dataSource: 'CHV', id: '0000004914' },
                            { dataSource: 'COSTAR', id: '298' },
                            { dataSource: 'CPM', id: '65221' },
                            { dataSource: 'CSP', id: '1385-2059' },
                            { dataSource: 'CST', id: 'ASTHENIA' },
                            { dataSource: 'DXP', id: 'U001451' },
                            { dataSource: 'HPO', id: 'HP:0012378' },
                            { dataSource: 'ICD10CM', id: 'R53.83' },
                            { dataSource: 'ICNP', id: '10000695' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU080142' },
                            { dataSource: 'ICPC2P', id: 'A04004' },
                            { dataSource: 'LCH', id: 'U001739' },
                            { dataSource: 'LCH_NW', id: 'sh85047465' },
                            { dataSource: 'LNC', id: 'MTHU013358' },
                            { dataSource: 'MDR', id: '10016256' },
                            { dataSource: 'MEDCIN', id: '273174' },
                            { dataSource: 'MEDLINEPLUS', id: '5324' },
                            { dataSource: 'MSH', id: 'D005221' },
                            { dataSource: 'MTHICD9', id: '780.79' },
                            { dataSource: 'NANDA-I', id: '00742' },
                            { dataSource: 'NCI', id: 'C3036' },
                            { dataSource: 'NCI_CDISC', id: 'C3036' },
                            { dataSource: 'NCI_CTCAE', id: 'E11098' },
                            { dataSource: 'NCI_CTRP', id: 'C3036' },
                            { dataSource: 'NCI_FDA', id: '1849' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000321374' },
                            { dataSource: 'NCI_NICHD', id: 'C3036' },
                            { dataSource: 'NCI_caDSR', id: 'C3036' },
                            { dataSource: 'NOC', id: '121028' },
                            { dataSource: 'OMIM', id: 'MTHU010062' },
                            { dataSource: 'PCDS', id: 'PRB_00010.03' },
                            { dataSource: 'PDQ', id: 'CDR0000041390' },
                            { dataSource: 'PSY', id: '19400' },
                            { dataSource: 'RCD', id: '1682.' },
                            { dataSource: 'SNM', id: 'F-01610' },
                            { dataSource: 'SNMI', id: 'F-01360' },
                            { dataSource: 'SNOMEDCT_US', id: '84229001' },
                            { dataSource: 'WHO', id: '0724' }
                        ]
                    },
                    {
                        offset: 973,
                        length: 10,
                        isNegated: false,
                        text: 'wrist pain',
                        category: 'SymptomOrSign',
                        confidenceScore: 0.98,
                        links: [
                            { dataSource: 'UMLS', id: 'C0221785' },
                            { dataSource: 'BI', id: 'BI00504' },
                            { dataSource: 'CCPSS', id: '1016217' },
                            { dataSource: 'CHV', id: '0000021489' },
                            { dataSource: 'COSTAR', id: 'U000624' },
                            { dataSource: 'DXP', id: 'U004491' },
                            { dataSource: 'HPO', id: 'HP:0030836' },
                            { dataSource: 'ICD10CM', id: 'M25.53' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU060847' },
                            { dataSource: 'ICPC2P', id: 'L11002' },
                            { dataSource: 'MDR', id: '10048692' },
                            { dataSource: 'MEDCIN', id: '939' },
                            { dataSource: 'OMIM', id: 'MTHU016462' },
                            { dataSource: 'RCD', id: 'N094F' },
                            { dataSource: 'SNMI', id: 'F-176A0' },
                            { dataSource: 'SNOMEDCT_US', id: '56608008' }
                        ]
                    },
                    {
                        offset: 990,
                        length: 18,
                        isNegated: false,
                        text: 'anginal equivalent',
                        category: 'SymptomOrSign',
                        confidenceScore: 0.98,
                        links: [
                            { dataSource: 'UMLS', id: 'C0741034' },
                            { dataSource: 'CCPSS', id: '1017783' },
                            { dataSource: 'CHV', id: '0000047213' },
                            { dataSource: 'ICD10CM', id: 'I20.8' },
                            { dataSource: 'MDR', id: '10076419' },
                            { dataSource: 'MTHICD9', id: '413.9' }
                        ]
                    },
                    {
                        links: [],
                        offset: 1031,
                        length: 9,
                        isNegated: false,
                        text: 'increased',
                        category: 'Course',
                        confidenceScore: 0.97
                    },
                    {
                        offset: 1041,
                        length: 8,
                        isNegated: false,
                        text: 'symptoms',
                        category: 'SymptomOrSign',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C1457887' },
                            { dataSource: 'AOD', id: '0000004363' },
                            { dataSource: 'CCPSS', id: '0009963' },
                            { dataSource: 'CST', id: 'GENSYMPTOMS' },
                            { dataSource: 'ICD9CM', id: '780-789.99' },
                            { dataSource: 'ICPC2ICD10ENG', id: 'MTHU072482' },
                            { dataSource: 'LCH_NW', id: 'sh85131555' },
                            { dataSource: 'LNC', id: 'MTHU021540' },
                            { dataSource: 'MEDCIN', id: '2952' },
                            { dataSource: 'MEDLINEPLUS', id: '31' },
                            { dataSource: 'NCI', id: 'C4876' },
                            { dataSource: 'NCI_CDISC', id: 'SDTM-SCTESTCD' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000045022' },
                            { dataSource: 'NCI_caDSR', id: 'C4876' },
                            { dataSource: 'PSY', id: '51140' },
                            { dataSource: 'SNMI', id: 'F-01250' }
                        ]
                    },
                    {
                        offset: 1054,
                        length: 6,
                        text: 'family',
                        isNegated: false,
                        category: 'FamilyRelation',
                        confidenceScore: 0.97,
                        links: [
                            { dataSource: 'UMLS', id: 'C0015576' },
                            { dataSource: 'AOD', id: '0000006914' },
                            { dataSource: 'CCPSS', id: '0030810' },
                            { dataSource: 'CHV', id: '0000004879' },
                            { dataSource: 'CSP', id: '1123-4254' },
                            { dataSource: 'LCH', id: 'U001730' },
                            { dataSource: 'LCH_NW', id: 'sh85047009' },
                            { dataSource: 'LNC', id: 'LP76012-1' },
                            { dataSource: 'MSH', id: 'D005190' },
                            { dataSource: 'NCI', id: 'C25173' },
                            { dataSource: 'NCI_NCI-GLOSS', id: 'CDR0000460148' },
                            { dataSource: 'NCI_caDSR', id: 'C25173' },
                            { dataSource: 'OMS', id: 'MTHU000002' },
                            { dataSource: 'PSY', id: '19300' },
                            { dataSource: 'SNMI', id: 'S-10000' },
                            { dataSource: 'SNOMEDCT_US', id: '35359004' }
                        ]
                    },
                    {
                        offset: 1081,
                        length: 17,
                        isNegated: false,
                        assertion: { association: 'other' },
                        text: 'left main disease',
                        category: 'Diagnosis',
                        confidenceScore: 0.98,
                        links: [
                            { dataSource: 'UMLS', id: 'C1299433' },
                            { dataSource: 'MEDCIN', id: '339763' },
                            { dataSource: 'MSH', id: 'D003324' },
                            { dataSource: 'SNOMEDCT_US', id: '371804009' }
                        ]
                    },
                    {
                        links: [],
                        offset: 1110,
                        length: 10,
                        isNegated: false,
                        text: 'occasional',
                        category: 'Course',
                        confidenceScore: 0.9
                    },
                    {
                        offset: 1128,
                        length: 3,
                        text: 'RCA',
                        isNegated: false,
                        category: 'BodyStructure',
                        confidenceScore: 0.98,
                        links: [
                            { dataSource: 'UMLS', id: 'C1261316' },
                            { dataSource: 'CHV', id: '0000056439' },
                            { dataSource: 'CPT', id: 'RC' },
                            { dataSource: 'CSP', id: '1398-9631' },
                            { dataSource: 'FMA', id: '50039' },
                            { dataSource: 'HCPCS', id: 'RC' },
                            { dataSource: 'NCI', id: 'C12875' },
                            { dataSource: 'NCI_CDISC', id: 'C12875' },
                            { dataSource: 'SNM', id: 'T-43200' },
                            { dataSource: 'SNMI', id: 'T-43200' },
                            { dataSource: 'SNOMEDCT_US', id: '13647002' },
                            { dataSource: 'UWDA', id: '50039' }
                        ]
                    },
                    {
                        offset: 1149,
                        length: 17,
                        isNegated: false,
                        text: 'revascularization',
                        category: 'TreatmentName',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0581603' },
                            { dataSource: 'AOD', id: '0000008211' },
                            { dataSource: 'CHV', id: '0000040599' },
                            { dataSource: 'CSP', id: '0579-1046' },
                            { dataSource: 'RCD', id: 'Xa6ZQ' },
                            { dataSource: 'RCDAE', id: 'Xa6ZQ' },
                            { dataSource: 'SNOMEDCT_US', id: '297183000' }
                        ]
                    },
                    {
                        offset: 1172,
                        length: 18,
                        isNegated: false,
                        text: 'open heart surgery',
                        category: 'TreatmentName',
                        confidenceScore: 1,
                        links: [
                            { dataSource: 'UMLS', id: 'C0189745' },
                            { dataSource: 'CHV', id: '0000019333' },
                            { dataSource: 'MDR', id: '10048935' },
                            { dataSource: 'MEDLINEPLUS', id: '4119' },
                            { dataSource: 'SNMI', id: 'P1-31004' },
                            { dataSource: 'SNOMEDCT_US', id: '2598006' }
                        ]
                    }
                ],
                relations: [
                    {
                        bidirectional: false,
                        relationType: 'TimeOfEvent',
                        entities: [
                            { ref: '#/results/documents/0/entities/3', role: 'Event' },
                            { ref: '#/results/documents/0/entities/4', role: 'Time' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'CourseOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/11', role: 'Course' },
                            { ref: '#/results/documents/0/entities/12', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'TimeOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/12', role: 'Condition' },
                            { ref: '#/results/documents/0/entities/13', role: 'Time' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'TimeOfExamination',
                        entities: [
                            { ref: '#/results/documents/0/entities/14', role: 'Examination' },
                            { ref: '#/results/documents/0/entities/15', role: 'Time' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'ExaminationFindsCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/14', role: 'Examination' },
                            { ref: '#/results/documents/0/entities/17', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'ExaminationFindsCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/14', role: 'Examination' },
                            { ref: '#/results/documents/0/entities/22', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'QualifierOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/16', role: 'Qualifier' },
                            { ref: '#/results/documents/0/entities/17', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'BodySiteOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/18', role: 'BodyStructure' },
                            { ref: '#/results/documents/0/entities/22', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'ValueOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/19', role: 'Value' },
                            { ref: '#/results/documents/0/entities/22', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'UnitOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/20', role: 'Unit' },
                            { ref: '#/results/documents/0/entities/22', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'BodySiteOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/21', role: 'BodyStructure' },
                            { ref: '#/results/documents/0/entities/22', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'TimeOfExamination',
                        entities: [
                            { ref: '#/results/documents/0/entities/31', role: 'Examination' },
                            { ref: '#/results/documents/0/entities/32', role: 'Time' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'ExaminationFindsCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/31', role: 'Examination' },
                            { ref: '#/results/documents/0/entities/33', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'TimeOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/35', role: 'Time' },
                            { ref: '#/results/documents/0/entities/37', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'QualifierOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/36', role: 'Qualifier' },
                            { ref: '#/results/documents/0/entities/37', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'CourseOfCondition',
                        entities: [
                            { ref: '#/results/documents/0/entities/41', role: 'Course' },
                            { ref: '#/results/documents/0/entities/42', role: 'Condition' }
                        ]
                    },
                    {
                        bidirectional: false,
                        relationType: 'BodySiteOfTreatment',
                        entities: [
                            { ref: '#/results/documents/0/entities/46', role: 'BodyStructure' },
                            { ref: '#/results/documents/0/entities/47', role: 'Treatment' }
                        ]
                    }
                ],
                warnings: []
            }
        ],
        errors: []
    }
};

export const AnalyzeSentimentsDemoSamplesJsonOutput: AnalyzeSentimentsSampleSwaggers = {
    'Product Review (short)': {
        OpinionOn: {
            documents: [
                {
                    id: 'id__1497',
                    sentiment: 'mixed',
                    confidenceScores: { positive: 0.74, neutral: 0.01, negative: 0.25 },
                    sentences: [
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.95, neutral: 0.04, negative: 0.01 },
                            offset: 0,
                            length: 40,
                            text: 'I bought a size S and it fit perfectly. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0, neutral: 0, negative: 0.99 },
                            offset: 40,
                            length: 84,
                            text: 'I found the zipper a little bit difficult to get up & down due to the side rushing. ',
                            targets: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0, negative: 1 },
                                    offset: 52,
                                    length: 6,
                                    text: 'zipper',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/1/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0, negative: 1 },
                                    offset: 72,
                                    length: 9,
                                    text: 'difficult',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0, negative: 0 },
                            offset: 124,
                            length: 48,
                            text: 'The color and material are beautiful in person. ',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 128,
                                    length: 5,
                                    text: 'color',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/0' }]
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 138,
                                    length: 8,
                                    text: 'material',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 151,
                                    length: 9,
                                    text: 'beautiful',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0, negative: 0 },
                            offset: 172,
                            length: 22,
                            text: 'Amazingly comfortable!',
                            targets: [],
                            assessments: []
                        }
                    ]
                }
            ],
            errors: []
        },
        OpinionOff: {
            documents: [
                {
                    id: 'id__475',
                    sentiment: 'mixed',
                    confidenceScores: { positive: 0.74, neutral: 0.01, negative: 0.25 },
                    sentences: [
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.95, neutral: 0.04, negative: 0.01 },
                            offset: 0,
                            length: 40,
                            text: 'I bought a size S and it fit perfectly. '
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0, neutral: 0, negative: 0.99 },
                            offset: 40,
                            length: 84,
                            text: 'I found the zipper a little bit difficult to get up & down due to the side rushing. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0, negative: 0 },
                            offset: 124,
                            length: 48,
                            text: 'The color and material are beautiful in person. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0, negative: 0 },
                            offset: 172,
                            length: 22,
                            text: 'Amazingly comfortable!'
                        }
                    ]
                }
            ],
            errors: []
        }
    },
    'Service Review (long)': {
        OpinionOff: {
            documents: [
                {
                    id: 'id__732',
                    sentiment: 'mixed',
                    confidenceScores: { positive: 0.75, neutral: 0.17, negative: 0.08 },
                    sentences: [
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.2, neutral: 0.25, negative: 0.55 },
                            offset: 0,
                            length: 13,
                            text: 'Long waits...'
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.97, neutral: 0.01, negative: 0.02 },
                            offset: 13,
                            length: 21,
                            text: 'BUT FOR GOOD REASON. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 1, neutral: 0, negative: 0 },
                            offset: 34,
                            length: 43,
                            text: 'Some awesome Italian food and great vibes. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.61, neutral: 0.38, negative: 0.02 },
                            offset: 77,
                            length: 81,
                            text: 'Contoso Bistro always has live music or events going on to keep you entertained. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0, negative: 0.01 },
                            offset: 158,
                            length: 55,
                            text: 'The food is good enough to keep me entertained though!\n'
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.56, neutral: 0.43, negative: 0.01 },
                            offset: 213,
                            length: 49,
                            text: '        The Contoso Bistro lasagna is a classic! '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.7, neutral: 0.29, negative: 0.01 },
                            offset: 262,
                            length: 65,
                            text: 'The outdoor back patio is such a vibe, especially in the summer. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 1, neutral: 0, negative: 0 },
                            offset: 327,
                            length: 67,
                            text: 'Great service as well :) Love this place and will be back for more.'
                        }
                    ]
                }
            ],
            errors: []
        },
        OpinionOn: {
            documents: [
                {
                    id: 'id__885',
                    sentiment: 'mixed',
                    confidenceScores: { positive: 0.75, neutral: 0.17, negative: 0.08 },
                    sentences: [
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.2, neutral: 0.25, negative: 0.55 },
                            offset: 0,
                            length: 13,
                            text: 'Long waits...',
                            targets: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0.04, negative: 0.96 },
                                    offset: 5,
                                    length: 5,
                                    text: 'waits',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/0/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0.04, negative: 0.96 },
                                    offset: 0,
                                    length: 4,
                                    text: 'Long',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.97, neutral: 0.01, negative: 0.02 },
                            offset: 13,
                            length: 21,
                            text: 'BUT FOR GOOD REASON. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 1, neutral: 0, negative: 0 },
                            offset: 34,
                            length: 43,
                            text: 'Some awesome Italian food and great vibes. ',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 47,
                                    length: 12,
                                    text: 'Italian food',
                                    relations: [
                                        { relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/0' },
                                        { relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/1' }
                                    ]
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 70,
                                    length: 5,
                                    text: 'vibes',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/1' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 39,
                                    length: 7,
                                    text: 'awesome',
                                    isNegated: false
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 64,
                                    length: 5,
                                    text: 'great',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.61, neutral: 0.38, negative: 0.02 },
                            offset: 77,
                            length: 81,
                            text: 'Contoso Bistro always has live music or events going on to keep you entertained. ',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 77,
                                    length: 14,
                                    text: 'Contoso Bistro',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/3/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 145,
                                    length: 11,
                                    text: 'entertained',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0, negative: 0.01 },
                            offset: 158,
                            length: 55,
                            text: 'The food is good enough to keep me entertained though!\n',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 162,
                                    length: 4,
                                    text: 'food',
                                    relations: [
                                        { relationType: 'assessment', ref: '#/documents/0/sentences/4/assessments/0' },
                                        { relationType: 'assessment', ref: '#/documents/0/sentences/4/assessments/1' }
                                    ]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 170,
                                    length: 4,
                                    text: 'good',
                                    isNegated: false
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 193,
                                    length: 11,
                                    text: 'entertained',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.56, neutral: 0.43, negative: 0.01 },
                            offset: 213,
                            length: 49,
                            text: '        The Contoso Bistro lasagna is a classic! ',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 226,
                                    length: 22,
                                    text: 'Contoso Bistro lasagna',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/5/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 254,
                                    length: 7,
                                    text: 'classic',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.7, neutral: 0.29, negative: 0.01 },
                            offset: 262,
                            length: 65,
                            text: 'The outdoor back patio is such a vibe, especially in the summer. ',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 0.99, negative: 0.01 },
                                    offset: 267,
                                    length: 18,
                                    text: 'outdoor back patio',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/6/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 0.99, negative: 0.01 },
                                    offset: 296,
                                    length: 4,
                                    text: 'vibe',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 1, neutral: 0, negative: 0 },
                            offset: 327,
                            length: 67,
                            text: 'Great service as well :) Love this place and will be back for more.',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 334,
                                    length: 7,
                                    text: 'service',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/7/assessments/0' }]
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 363,
                                    length: 5,
                                    text: 'place',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/7/assessments/1' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 328,
                                    length: 5,
                                    text: 'Great',
                                    isNegated: false
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 353,
                                    length: 4,
                                    text: 'Love',
                                    isNegated: false
                                }
                            ]
                        }
                    ]
                }
            ],
            errors: []
        }
    },
    'Customer Complaint Email': {
        OpinionOff: {
            documents: [
                {
                    id: 'id__1221',
                    sentiment: 'mixed',
                    confidenceScores: { positive: 0.5, neutral: 0.01, negative: 0.49 },
                    sentences: [
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.29, neutral: 0.66, negative: 0.05 },
                            offset: 0,
                            length: 7,
                            text: 'Hello,\n'
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.15, neutral: 0.82, negative: 0.03 },
                            offset: 7,
                            length: 114,
                            text:
                                '        My name is Mateo Gomez and I visited Contoso Restaurant with my spouse for our anniversary last Thursday. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0.01, negative: 0 },
                            offset: 121,
                            length: 146,
                            text:
                                'I had heard wonderful things about your food and service from my neighbors as I lived right down the street from you at 1234 Hollywood Boulevard. '
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.98, neutral: 0.01, negative: 0.01 },
                            offset: 267,
                            length: 91,
                            text: 'After a lovely stroll along the Santa Monica Pier, we decided to go for dinner at Contoso. '
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.01, neutral: 0.74, negative: 0.25 },
                            offset: 358,
                            length: 98,
                            text: 'But when we got to the restaurant, we had to wait for 15 minutes just to get on the waiting list. '
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.07, neutral: 0.72, negative: 0.21 },
                            offset: 456,
                            length: 79,
                            text: 'After an hour of waiting to get seated, we ordered two Surf and turf platters. '
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.01, neutral: 0.01, negative: 0.98 },
                            offset: 535,
                            length: 58,
                            text: 'To our absolute surprise, the food was very cold and dry. '
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.01, neutral: 0, negative: 0.99 },
                            offset: 593,
                            length: 101,
                            text: 'The whole experience was just awful, and I expect a refund for our meal and an apology for that day. '
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.07, neutral: 0.86, negative: 0.07 },
                            offset: 694,
                            length: 95,
                            text: 'Please issue me a refund at the earliest and call me on 123-456-7890 for any further questions.'
                        }
                    ]
                }
            ],
            errors: []
        },
        OpinionOn: {
            documents: [
                {
                    id: 'id__1046',
                    sentiment: 'mixed',
                    confidenceScores: { positive: 0.5, neutral: 0.01, negative: 0.49 },
                    sentences: [
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.29, neutral: 0.66, negative: 0.05 },
                            offset: 0,
                            length: 7,
                            text: 'Hello,\n',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.15, neutral: 0.82, negative: 0.03 },
                            offset: 7,
                            length: 114,
                            text:
                                '        My name is Mateo Gomez and I visited Contoso Restaurant with my spouse for our anniversary last Thursday. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.99, neutral: 0.01, negative: 0 },
                            offset: 121,
                            length: 146,
                            text:
                                'I had heard wonderful things about your food and service from my neighbors as I lived right down the street from you at 1234 Hollywood Boulevard. ',
                            targets: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 162,
                                    length: 4,
                                    text: 'food',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/0' }]
                                },
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 171,
                                    length: 7,
                                    text: 'service',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/2/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'positive',
                                    confidenceScores: { positive: 1, negative: 0 },
                                    offset: 134,
                                    length: 9,
                                    text: 'wonderful',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.98, neutral: 0.01, negative: 0.01 },
                            offset: 267,
                            length: 91,
                            text: 'After a lovely stroll along the Santa Monica Pier, we decided to go for dinner at Contoso. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.01, neutral: 0.74, negative: 0.25 },
                            offset: 358,
                            length: 98,
                            text: 'But when we got to the restaurant, we had to wait for 15 minutes just to get on the waiting list. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.07, neutral: 0.72, negative: 0.21 },
                            offset: 456,
                            length: 79,
                            text: 'After an hour of waiting to get seated, we ordered two Surf and turf platters. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.01, neutral: 0.01, negative: 0.98 },
                            offset: 535,
                            length: 58,
                            text: 'To our absolute surprise, the food was very cold and dry. ',
                            targets: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0.01, negative: 0.99 },
                                    offset: 566,
                                    length: 4,
                                    text: 'food',
                                    relations: [
                                        { relationType: 'assessment', ref: '#/documents/0/sentences/6/assessments/0' },
                                        { relationType: 'assessment', ref: '#/documents/0/sentences/6/assessments/1' }
                                    ]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0.01, negative: 0.99 },
                                    offset: 580,
                                    length: 4,
                                    text: 'cold',
                                    isNegated: false
                                },
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0.01, negative: 0.99 },
                                    offset: 589,
                                    length: 3,
                                    text: 'dry',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.01, neutral: 0, negative: 0.99 },
                            offset: 593,
                            length: 101,
                            text: 'The whole experience was just awful, and I expect a refund for our meal and an apology for that day. ',
                            targets: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0, negative: 1 },
                                    offset: 604,
                                    length: 10,
                                    text: 'experience',
                                    relations: [{ relationType: 'assessment', ref: '#/documents/0/sentences/7/assessments/0' }]
                                }
                            ],
                            assessments: [
                                {
                                    sentiment: 'negative',
                                    confidenceScores: { positive: 0, negative: 1 },
                                    offset: 624,
                                    length: 5,
                                    text: 'awful',
                                    isNegated: false
                                }
                            ]
                        },
                        {
                            sentiment: 'neutral',
                            confidenceScores: { positive: 0.07, neutral: 0.86, negative: 0.07 },
                            offset: 694,
                            length: 95,
                            text: 'Please issue me a refund at the earliest and call me on 123-456-7890 for any further questions.',
                            targets: [],
                            assessments: []
                        }
                    ]
                }
            ],
            errors: []
        }
    },
    'Social Media Post': {
        OpinionOff: {
            documents: [
                {
                    id: 'id__1382',
                    sentiment: 'positive',
                    confidenceScores: { positive: 0.96, neutral: 0.03, negative: 0.01 },
                    sentences: [
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.96, neutral: 0.03, negative: 0.01 },
                            offset: 0,
                            length: 92,
                            text: 'I can describe my experience of this game in two words: "TECHNOLOGY RECHARGED!" #bestdayever'
                        }
                    ]
                }
            ],
            errors: []
        },
        OpinionOn: {
            documents: [
                {
                    id: 'id__1535',
                    sentiment: 'positive',
                    confidenceScores: { positive: 0.96, neutral: 0.03, negative: 0.01 },
                    sentences: [
                        {
                            sentiment: 'positive',
                            confidenceScores: { positive: 0.96, neutral: 0.03, negative: 0.01 },
                            offset: 0,
                            length: 92,
                            text: 'I can describe my experience of this game in two words: "TECHNOLOGY RECHARGED!" #bestdayever',
                            targets: [],
                            assessments: []
                        }
                    ]
                }
            ],
            errors: []
        }
    },
    'Employee survey feedback': {
        OpinionOff: {
            documents: [
                {
                    id: 'id__1857',
                    sentiment: 'negative',
                    confidenceScores: { positive: 0.01, neutral: 0.05, negative: 0.94 },
                    sentences: [
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0, neutral: 0.02, negative: 0.98 },
                            offset: 0,
                            length: 48,
                            text: 'The cafeteria food is getting worse by the day. '
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.01, neutral: 0.09, negative: 0.9 },
                            offset: 48,
                            length: 61,
                            text: '$15 for a plate of burger and fries does not seem subsidized.'
                        }
                    ]
                }
            ],
            errors: []
        },
        OpinionOn: {
            documents: [
                {
                    id: 'id__1696',
                    sentiment: 'negative',
                    confidenceScores: { positive: 0.01, neutral: 0.05, negative: 0.94 },
                    sentences: [
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0, neutral: 0.02, negative: 0.98 },
                            offset: 0,
                            length: 48,
                            text: 'The cafeteria food is getting worse by the day. ',
                            targets: [],
                            assessments: []
                        },
                        {
                            sentiment: 'negative',
                            confidenceScores: { positive: 0.01, neutral: 0.09, negative: 0.9 },
                            offset: 48,
                            length: 61,
                            text: '$15 for a plate of burger and fries does not seem subsidized.',
                            targets: [],
                            assessments: []
                        }
                    ]
                }
            ],
            errors: []
        }
    }
};

export const DetectLanguageDemoSamplesJsonOutput: DetectLanguageSampleSwaggers = {
    English: {
        documents: [{ id: 'id__10748', detectedLanguage: { name: 'English', iso6391Name: 'en', confidenceScore: 0.99 }, warnings: [] }],
        errors: []
    },
    'Mixed Languages Content': {
        documents: [{ id: 'id__10851', detectedLanguage: { name: 'Spanish', iso6391Name: 'es', confidenceScore: 0.88 }, warnings: [] }],
        errors: []
    },
    French: {
        documents: [{ id: 'id__10954', detectedLanguage: { name: 'French', iso6391Name: 'fr', confidenceScore: 1 }, warnings: [] }],
        errors: []
    },
    Chinese: {
        documents: [
            { id: 'id__11057', detectedLanguage: { name: 'Chinese_Simplified', iso6391Name: 'zh-chs', confidenceScore: 1 }, warnings: [] }
        ],
        errors: []
    }
};

export const AnswerQuestionsDemoSamplesJsonOutput: AnswerQuestionsSampleSwaggers = {
    'Sample 1': {
        answers: [
            {
                answer:
                    'Surface Laptop 4 is, first and foremost, optimized for Microsoft experiences. It retains the iconic design, details and materials that our customers love. With our signature 3:2 PixelSense touchscreen displays in 13.5” or 15” models, customers can choose from Alcantara or metal finishes in a variety of bold colors you can’t get anywhere else, including a new Ice Blue finish.',
                confidenceScore: 0.7646595239639282,
                id: 'id__11859',
                answerSpan: { text: '13.5” or 15”', confidenceScore: 0.8432674, offset: 212, length: 13 },
                offset: 0,
                length: 377
            },
            {
                answer:
                    'With our signature 3:2 PixelSense touchscreen displays in 13.5” or 15” models, customers can choose from Alcantara or metal finishes in a variety of bold colors you can’t get anywhere else, including a new Ice Blue finish. Surface Laptop 4 offers a built-in HD front-facing camera with incredible low-light capability and a studio microphone array, ensuring you’ll come through loud and clear as you connect with loved ones or participate in a crucial virtual work meeting. With the 201 PPI, high-contrast touchscreen display, and Dolby® Atmos™ Omnisonic speakers, you’ll get a cinematic experience that immerses you in your favorite movies and shows from the comfort of anywhere.',
                confidenceScore: 0.5681770443916321,
                id: 'id__11859',
                answerSpan: { text: '13.5” or 15”', confidenceScore: 0.88385504, offset: 57, length: 13 },
                offset: 155,
                length: 680
            },
            {
                answer:
                    'Surface Laptop 4 offers a built-in HD front-facing camera with incredible low-light capability and a studio microphone array, ensuring you’ll come through loud and clear as you connect with loved ones or participate in a crucial virtual work meeting. With the 201 PPI, high-contrast touchscreen display, and Dolby® Atmos™ Omnisonic speakers, you’ll get a cinematic experience that immerses you in your favorite movies and shows from the comfort of anywhere. Whether through the vibrant touchscreen display, large trackpad with gesture support, or its industry-leading typing experience, Surface Laptop can adjust to your preferred workflow.',
                confidenceScore: 0.03973156213760376,
                id: 'id__11859',
                answerSpan: { text: 'large', confidenceScore: 0.38910967, offset: 506, length: 6 },
                offset: 378,
                length: 640
            }
        ]
    },
    'Sample 2': {
        answers: [
            {
                answer:
                    'The Sustainable Development Goals (SDGs), also known as the Global Goals, were adopted by all United Nations Member States in 2015 as a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity by 2030. The 17 SDGs are integrated—that is, they recognize that action in one area will affect outcomes in others, and that development must balance social, economic and environmental sustainability.\n\n\n        Through the pledge to Leave No One Behind, countries have committed to fast-track progress for those furthest behind first.',
                confidenceScore: 0.9790226221084595,
                id: 'id__11984',
                answerSpan: {
                    text:
                        'a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity by 2030',
                    confidenceScore: 0.3690939,
                    offset: 133,
                    length: 124
                },
                offset: 0,
                length: 584
            },
            {
                answer:
                    'Through the pledge to Leave No One Behind, countries have committed to fast-track progress for those furthest behind first. That is why the SDGs are designed to bring the world to several life-changing ‘zeros’, including zero poverty, hunger, AIDS and discrimination against women and girls. Everyone is needed to reach these ambitious targets.',
                confidenceScore: 0.6991565227508545,
                id: 'id__11984',
                answerSpan: {
                    text: 'zero poverty, hunger, AIDS and discrimination against women and girls',
                    confidenceScore: 0.7786891,
                    offset: 220,
                    length: 70
                },
                offset: 461,
                length: 344
            },
            {
                answer:
                    'The 17 SDGs are integrated—that is, they recognize that action in one area will affect outcomes in others, and that development must balance social, economic and environmental sustainability.\n\n\n        Through the pledge to Leave No One Behind, countries have committed to fast-track progress for those furthest behind first. That is why the SDGs are designed to bring the world to several life-changing ‘zeros’, including zero poverty, hunger, AIDS and discrimination against women and girls.',
                confidenceScore: 0.6880364418029785,
                id: 'id__11984',
                answerSpan: {
                    text: 'zero poverty, hunger, AIDS and discrimination against women and girls',
                    confidenceScore: 0.4953152,
                    offset: 422,
                    length: 70
                },
                offset: 259,
                length: 493
            }
        ]
    },
    'Sample 3': {
        answers: [
            {
                answer:
                    'The Oculus, a grand wood, steel, and glass staircase connects the upper-level to The Loupe, the world’s first, and only, rotating glass floor below. The new glass floor experience opened up a never-before-seen downward view of the structure and the surrounding area, putting Seattle, literally, at your feet. Visit the renovation page to learn more about how the Space Needle is further enhancing its visitor experience.',
                confidenceScore: 0.9820879101753235,
                id: 'id__12109',
                answerSpan: {
                    text: 'a grand wood, steel, and glass staircase',
                    confidenceScore: 0.5661074,
                    offset: 11,
                    length: 41
                },
                offset: 1218,
                length: 420
            },
            {
                answer:
                    'The first phase of the renovation, completed in late summer 2018, includes breathtaking, multi-level, floor-to-ceiling glass viewing experiences including an upper level outdoor observation deck with open-air glass walls and Skyriser glass benches. The Oculus, a grand wood, steel, and glass staircase connects the upper-level to The Loupe, the world’s first, and only, rotating glass floor below. The new glass floor experience opened up a never-before-seen downward view of the structure and the surrounding area, putting Seattle, literally, at your feet.',
                confidenceScore: 0.9484376907348633,
                id: 'id__12109',
                answerSpan: {
                    text: 'a grand wood, steel, and glass staircase',
                    confidenceScore: 0.6114064,
                    offset: 260,
                    length: 41
                },
                offset: 969,
                length: 557
            },
            {
                answer:
                    'The Space Needle is one of the most recognizable landmarks in the world and is a treasured Seattle icon. Built for the 1962 World’s Fair—the Century 21 Exposition whose theme was “The Age of Space”—the tower’s futuristic design was inspired by the idea that the fair needed a structure to symbolize humanity’s Space Age aspirations. Since its grand opening on April 21, 1962, the landmark continues to symbolize the innovative and forward-thinking spirit of Seattle.',
                confidenceScore: 0.10796824842691422,
                id: 'id__12109',
                answerSpan: {
                    text: 'Space Needle is one of the most recognizable landmarks in the world and is a treasured Seattle icon',
                    confidenceScore: 0.17642552,
                    offset: 3,
                    length: 100
                },
                offset: 0,
                length: 466
            }
        ]
    },
    'Sample 4': {
        answers: [
            {
                answer:
                    'Equities are stocks, which are ownership shares in a company. Debt securities, such as bonds, are interest-bearing IOUs.These markets are divided into two different categories: primary markets—where new equity stock and bond issues are sold to investors—and secondary markets, which trade existing securities. Capital markets are a crucial part of a functioning modern economy because they move money from the people who have it to those who need it for productive use.',
                confidenceScore: 0.9789930582046509,
                id: 'id__12234',
                answerSpan: {
                    text: 'stocks, which are ownership shares in a company',
                    confidenceScore: 0.50987065,
                    offset: 12,
                    length: 48
                },
                offset: 864,
                length: 469
            },
            {
                answer:
                    'Capital markets are used to sell financial products such as equities and debt securities. Equities are stocks, which are ownership shares in a company. Debt securities, such as bonds, are interest-bearing IOUs.These markets are divided into two different categories: primary markets—where new equity stock and bond issues are sold to investors—and secondary markets, which trade existing securities.',
                confidenceScore: 0.927407443523407,
                id: 'id__12234',
                answerSpan: {
                    text: 'stocks, which are ownership shares in a company',
                    confidenceScore: 0.44747454,
                    offset: 102,
                    length: 48
                },
                offset: 774,
                length: 399
            },
            {
                answer:
                    'Users of funds include home and motor vehicle purchasers, non-financial companies, and governments financing infrastructure investment and operating expenses.\n\n        Capital markets are used to sell financial products such as equities and debt securities. Equities are stocks, which are ownership shares in a company.',
                confidenceScore: 0.8694531321525574,
                id: 'id__12234',
                answerSpan: {
                    text: 'stocks, which are ownership shares in a company',
                    confidenceScore: 0.43813756,
                    offset: 270,
                    length: 48
                },
                offset: 606,
                length: 319
            }
        ]
    }
};

export const GenerateQuestionsURLDemoSamplesJsonOutput: any = {
    'Surface Book 2': {
        value: [
            {
                question: 'How many times more powerful is the Surface Book 2?',
                answer: 'four times',
                confidenceScore: 0.8057365417480469,
                confidenceBucket: 'High',
                documentId: 'id__2608'
            },
            {
                question: 'How much power does a Surface Book 2 have?',
                answer: 'four times the processing power',
                confidenceScore: 0.7971000909805297,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much more power does the Surface Book 2 have?',
                answer: 'four times',
                confidenceScore: 0.7867117404937745,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much power does the Surface Book 2 have?',
                answer: 'four times the processing power',
                confidenceScore: 0.7864523887634277,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much more power does a Surface Book 2 have?',
                answer: 'four times',
                confidenceScore: 0.7810788869857789,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How many levels of pressure does the Surface Book 2 offer?',
                answer: '4096',
                confidenceScore: 0.7634555578231812,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How many levels of pressure does the Surface Book 2 have?',
                answer: '4096',
                confidenceScore: 0.7615667104721069,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much more power does the Surface Book 2 offer?',
                answer: 'four times',
                confidenceScore: 0.7444772243499757,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much more power does the Surface Book 2 provide?',
                answer: 'four times',
                confidenceScore: 0.7436749696731567,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much more powerful is the Surface Book 2?',
                answer: 'four times',
                confidenceScore: 0.7255715608596802,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'What is the Surface Book 2?',
                answer: 'what you need to create the amazing',
                confidenceScore: 0.723150372505188,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'What is the Surface Book 2?',
                answer: 'most powerful Surface ever',
                confidenceScore: 0.7149879336357117,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'What is the surface book 2?',
                answer: 'what you need to create the amazing',
                confidenceScore: 0.7133889198303223,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much is the Surface Book 2?',
                answer: '$1,499.99 USD',
                confidenceScore: 0.7054534673690795,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            },
            {
                question: 'How much does the Surface Book 2 cost?',
                answer: '$1,499.99 USD',
                confidenceScore: 0.6966996431350707,
                confidenceBucket: 'Medium',
                documentId: 'id__2608'
            }
        ],
        errors: []
    },
    Jupiter: {
        value: [
            {
                question: 'What is the largest planet in the solar system?',
                answer: 'Jupiter',
                confidenceScore: 0.9922826647758484,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What is the largest planet in our solar system?',
                answer: 'Jupiter',
                confidenceScore: 0.9920472383499146,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What are the four largest moons of jupiter?',
                answer: 'Io , Europa , Ganymede , and Callisto',
                confidenceScore: 0.990441620349884,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What are the four largest moons on jupiter?',
                answer: 'Io , Europa , Ganymede , and Callisto',
                confidenceScore: 0.9901473999023438,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'When did the first spacecraft go into orbit around Jupiter?',
                answer: '1995',
                confidenceScore: 0.9862329959869385,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'When was the first spacecraft sent into orbit around Jupiter?',
                answer: '1995',
                confidenceScore: 0.9836446046829224,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'When did the first spacecraft orbit around jupiter?',
                answer: '1995',
                confidenceScore: 0.9830609560012817,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'When did the first spacecraft orbit around Jupiter?',
                answer: '1995',
                confidenceScore: 0.9829911589622498,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What are the largest moons on jupiter?',
                answer: 'Io , Europa , Ganymede , and Callisto',
                confidenceScore: 0.9827019929885865,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What are the largest moons in jupiter?',
                answer: 'Io , Europa , Ganymede , and Callisto',
                confidenceScore: 0.9822038650512696,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What is the name of the spacecraft NASA sent to jupiter?',
                answer: 'Juno',
                confidenceScore: 0.9813689231872559,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What is the name of the spacecraft NASA sent to Jupiter?',
                answer: 'Juno',
                confidenceScore: 0.9778578758239747,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What is the name of the spacecraft that has been sent to Jupiter?',
                answer: 'Juno',
                confidenceScore: 0.9768481731414794,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'What is the name of the spacecraft that NASA sent to Jupiter?',
                answer: 'Juno',
                confidenceScore: 0.9761201620101929,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            },
            {
                question: 'When was the first spacecraft sent to jupiter?',
                answer: '1995',
                confidenceScore: 0.9748418450355529,
                confidenceBucket: 'High',
                documentId: 'id__2687'
            }
        ]
    }
};

export const GenerateQuestionsTextDemoSamplesJsonOutput: any = {
    'Global Goals': {
        value: [
            {
                question: 'When were the SDGs adopted?',
                answer: '2015',
                confidenceScore: 0.9778017282485962,
                confidenceBucket: 'High',
                documentId: 'id__1285'
            },
            {
                question: 'What does the SDGs stand for?',
                answer: 'Sustainable Development Goals',
                confidenceScore: 0.9616917133331299,
                confidenceBucket: 'High',
                documentId: 'id__1285'
            },
            {
                question: 'What does the SDG stand for?',
                answer: 'Sustainable Development Goals',
                confidenceScore: 0.9594964504241943,
                confidenceBucket: 'High',
                documentId: 'id__1285'
            },
            {
                question: 'What does the SDGs mean?',
                answer: 'Sustainable Development Goals',
                confidenceScore: 0.9287176370620728,
                confidenceBucket: 'High',
                documentId: 'id__1285'
            },
            {
                question: 'What do the SDGs mean?',
                answer: 'Sustainable Development Goals',
                confidenceScore: 0.8971589326858521,
                confidenceBucket: 'High',
                documentId: 'id__1285'
            },
            {
                question: 'What is the SDGs?',
                answer:
                    'a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity by 2030',
                confidenceScore: 0.7892756819725038,
                confidenceBucket: 'Medium',
                documentId: 'id__1285'
            },
            {
                question: 'How are the SDGs implemented?',
                answer: 'integrated',
                confidenceScore: 0.6542425632476807,
                confidenceBucket: 'Medium',
                documentId: 'id__1285'
            },
            {
                question: 'What are the SDGs?',
                answer:
                    'a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity by 2030',
                confidenceScore: 0.4185909628868103,
                confidenceBucket: 'Low',
                documentId: 'id__1285'
            },
            {
                question: 'What are the Sustainable Development Goals?',
                answer:
                    'a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity by 2030',
                confidenceScore: 0.3850863575935364,
                confidenceBucket: 'Low',
                documentId: 'id__1285'
            },
            {
                question: 'The Sustainable Development Goals?',
                answer:
                    'a universal call to action to end poverty, protect the planet and ensure that all people enjoy peace and prosperity by 2030',
                confidenceScore: 0.36633944511413574,
                confidenceBucket: 'Low',
                documentId: 'id__1285'
            }
        ],
        errors: []
    },
    'Surface Laptop 4': {
        value: [
            {
                question: 'What is the Surface Laptop 4 optimized for?',
                answer: 'Microsoft experiences',
                confidenceScore: 0.9611839532852173,
                confidenceBucket: 'High',
                documentId: 'id__1693'
            },
            {
                question: 'What is the purpose of the Surface Laptop 4?',
                answer: 'optimized for Microsoft experiences',
                confidenceScore: 0.8004069328308105,
                confidenceBucket: 'High',
                documentId: 'id__1693'
            },
            {
                question: 'What exactly is the Surface Laptop 4?',
                answer: 'optimized for Microsoft experiences',
                confidenceScore: 0.7407138586044312,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'Why is Surface Laptop 4 optimized for Microsoft experiences?',
                answer: 'It retains the iconic design, details and materials that our customers love',
                confidenceScore: 0.7137231469154358,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'Why is Surface Laptop 4 optimized?',
                answer: 'Microsoft experiences',
                confidenceScore: 0.7125490665435791,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'Why is the Surface Laptop 4 optimized?',
                answer: 'Microsoft experiences',
                confidenceScore: 0.7121144294738769,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'Why is Surface Laptop 4 optimized for Microsoft?',
                answer: 'It retains the iconic design, details and materials that our customers love',
                confidenceScore: 0.7117706537246704,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'Why is the Surface Laptop 4 optimized for Microsoft?',
                answer: 'It retains the iconic design, details and materials that our customers love',
                confidenceScore: 0.709669542312622,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'How does the Surface Laptop 4 work?',
                answer: 'built-in HD front-facing camera with incredible low-light capability and a studio microphone array',
                confidenceScore: 0.5346294403076172,
                confidenceBucket: 'Medium',
                documentId: 'id__1693'
            },
            {
                question: 'How does a Surface Laptop compare to an office or coffee shop?',
                answer: 'nothing comes close to this product’s look and feel',
                confidenceScore: 0.47881241440773015,
                confidenceBucket: 'Low',
                documentId: 'id__1693'
            },
            {
                question: 'How does the Surface Laptop 4 work?',
                answer:
                    'touchscreen display, large trackpad with gesture support, or its industry-leading typing experience, Surface Laptop can adjust to your preferred workflow. Surface Laptop 4 offers a choice between either the 11th Gen Intel® CoreTM processors, or AMD RyzenTM Mobile Processors with RadeonTM Graphics Microsoft Surface® Edition (8 cores);',
                confidenceScore: 0.46834225654602046,
                confidenceBucket: 'Low',
                documentId: 'id__1693'
            },
            {
                question: 'How does Surface Laptop 4 work?',
                answer:
                    'touchscreen display, large trackpad with gesture support, or its industry-leading typing experience, Surface Laptop can adjust to your preferred workflow. Surface Laptop 4 offers a choice between either the 11th Gen Intel® CoreTM processors, or AMD RyzenTM Mobile Processors with RadeonTM Graphics Microsoft Surface® Edition (8 cores);',
                confidenceScore: 0.44525349140167236,
                confidenceBucket: 'Low',
                documentId: 'id__1693'
            },
            {
                question: 'What does the Surface Laptop 4 offer?',
                answer: 'a built-in HD front-facing camera with incredible low-light capability and a studio microphone array',
                confidenceScore: 0.43694639205932617,
                confidenceBucket: 'Low',
                documentId: 'id__1693'
            },
            {
                question: 'How does the Surface Laptop work?',
                answer:
                    'touchscreen display, large trackpad with gesture support, or its industry-leading typing experience, Surface Laptop can adjust to your preferred workflow',
                confidenceScore: 0.4027811586856842,
                confidenceBucket: 'Low',
                documentId: 'id__1693'
            },
            {
                question: 'How does a Surface Laptop work?',
                answer:
                    'touchscreen display, large trackpad with gesture support, or its industry-leading typing experience, Surface Laptop can adjust to your preferred workflow',
                confidenceScore: 0.39078502655029296,
                confidenceBucket: 'Low',
                documentId: 'id__1693'
            }
        ],
        errors: []
    },
    'Neil Armstrong': {
        value: [
            {
                question: 'What year did Armstrong become an astronaut?',
                answer: '1962',
                confidenceScore: 0.992082667350769,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'When did Armstrong become an astronaut?',
                answer: '1962',
                confidenceScore: 0.9913968563079834,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'When did Armstrong first become an astronaut?',
                answer: '1962',
                confidenceScore: 0.9910852789878845,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'When was neil armstrong born?',
                answer: 'Aug. 5, 1930',
                confidenceScore: 0.9897918462753297,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'When was Neil Armstrong born?',
                answer: 'Aug. 5, 1930',
                confidenceScore: 0.9888667345046998,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'Who was the first person to land on the moon?',
                answer: 'Armstrong and Aldrin',
                confidenceScore: 0.9738761901855468,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'Where did Neil Armstrong go to college?',
                answer: 'Purdue University',
                confidenceScore: 0.9667124629020691,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'Who was the first astronaut to land on the moon?',
                answer: 'Armstrong and Aldrin',
                confidenceScore: 0.9536031484603882,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'What year was Neil Armstrong born?',
                answer: '1930',
                confidenceScore: 0.9333286046981811,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: "What was Neil Armstrong's career?",
                answer: 'astronaut',
                confidenceScore: 0.9173069953918457,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'Where did Neil Armstrong go to college in 1930?',
                answer: 'Purdue University',
                confidenceScore: 0.9026371955871582,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'When did Neil Armstrong fly in the air?',
                answer: 'when he was 6',
                confidenceScore: 0.8397535920143128,
                confidenceBucket: 'High',
                documentId: 'id__1820'
            },
            {
                question: 'How long did Armstrong and Aldrin spend on the moon?',
                answer: 'more than two hours',
                confidenceScore: 0.7406934499740601,
                confidenceBucket: 'Medium',
                documentId: 'id__1820'
            },
            {
                question: 'When did Armstrong land on the moon?',
                answer: '1966',
                confidenceScore: 0.6788772821426392,
                confidenceBucket: 'Medium',
                documentId: 'id__1820'
            },
            {
                question: 'How many hours did Armstrong and Aldrin spend on the moon?',
                answer: 'more than two hours',
                confidenceScore: 0.6303119540214539,
                confidenceBucket: 'Medium',
                documentId: 'id__1820'
            }
        ],
        errors: []
    }
};

export const TextSummarizationDemoSamplesJsonOutput: SummarizationSampleSwaggers = {
    'Applied AI': [
        {
            kind: 'AbstractiveSummarization',
            taskName: '',
            lastUpdateDateTime: '2022-10-11T10:31:37.7703164Z',
            status: 'succeeded',
            results: {
                documents: [
                    {
                        summaries: [
                            {
                                text:
                                    "Microsoft's new Applied AI Services accelerate the development of AI solutions. Microsoft' Microsoft highlighted the services at Build, its annual conference for developers.",
                                contexts: [{ offset: 0, length: 5072 }]
                            }
                        ],
                        id: 'id__2989',
                        warnings: []
                    }
                ],
                errors: [],
                modelVersion: 'latest'
            }
        },
        {
            kind: 'ExtractiveSummarization',
            taskName: '',
            lastUpdateDateTime: '2022-10-11T10:31:17.5348963Z',
            status: 'succeeded',
            results: {
                documents: [
                    {
                        id: 'id__2989',
                        sentences: [
                            {
                                text:
                                    'At any given moment, turnaround coordinators for German airline Lufthansa CityLine have their eyes glued to monitors displaying more than half a dozen video feeds of airplanes parked at gates around the airport.',
                                rankScore: 1,
                                offset: 0,
                                length: 211
                            },
                            {
                                text:
                                    'Azure Video Analyzer is among a handful of Azure Applied AI Services that Microsoft highlighted on Tuesday during Build, the company’s annual conference for developers.',
                                rankScore: 0.49,
                                offset: 2957,
                                length: 168
                            },
                            {
                                text:
                                    'Azure Applied AI Services are built on top of AI models at the core of Azure AI products and services.',
                                rankScore: 0.64,
                                offset: 3357,
                                length: 102
                            }
                        ],
                        warnings: []
                    }
                ],
                errors: [],
                modelVersion: 'latest'
            }
        }
    ],
    'Sample 2': [
        {
            kind: 'AbstractiveSummarization',
            taskName: '',
            lastUpdateDateTime: '2022-10-11T11:12:14.2478281Z',
            status: 'succeeded',
            results: {
                documents: [
                    {
                        summaries: [
                            {
                                text:
                                    'Microsoft Philanthropies is shifting its grant and discount program to focus on the capabilities of the Microsoft Cloud. The program will provide grants for the full portfolio of Microsoft cloud solutions. Microsoft is also expanding its training programs that help nonprofits get the most out of the tools and technologies we provide.',
                                contexts: [{ offset: 0, length: 4880 }]
                            }
                        ],
                        id: 'id__3197',
                        warnings: []
                    }
                ],
                errors: [],
                modelVersion: 'latest'
            }
        },
        {
            kind: 'ExtractiveSummarization',
            taskName: '',
            lastUpdateDateTime: '2022-10-11T11:11:37.3824244Z',
            status: 'succeeded',
            results: {
                documents: [
                    {
                        id: 'id__3197',
                        sentences: [
                            {
                                text:
                                    'In fiscal year 2021, Microsoft provided $2.5 billion in technology grants and discounts to some 295,000 nonprofits – 45,000 more than last year.',
                                rankScore: 0.75,
                                offset: 906,
                                length: 144
                            },
                            {
                                text:
                                    'This is why, beginning in April 2022, we are shifting to a cloud-first grant program to ensure that nonprofits of every size in every part of the globe have access to the world-class cloud technology they need to accelerate the work they are doing to accomplish their missions.',
                                rankScore: 1,
                                offset: 1643,
                                length: 277
                            },
                            {
                                text:
                                    'To help protect nonprofits against the growing threat of cyberattacks, we are announcing the AccountGuard for Nonprofits program, which will be made available to eligible organizations at no additional cost.',
                                rankScore: 0.64,
                                offset: 2490,
                                length: 207
                            }
                        ],
                        warnings: []
                    }
                ],
                errors: [],
                modelVersion: 'latest'
            }
        }
    ],
    'Sample 3': [
        {
            kind: 'AbstractiveSummarization',
            taskName: '',
            lastUpdateDateTime: '2022-10-11T11:13:21.301871Z',
            status: 'succeeded',
            results: {
                documents: [
                    {
                        summaries: [
                            {
                                text:
                                    'Microsoft will acquire Activision Blizzard for $95.00 per share, in an all-cash transaction valued at $68.7 billion. When the transaction closes, Microsoft will become the world’s third-largest gaming company by revenue. The acquisition also bolsters Microsoft’s Game Pass portfolio with plans to launch Activision Blizzard games into Game Pass.',
                                contexts: [{ offset: 0, length: 4134 }]
                            }
                        ],
                        id: 'id__3336',
                        warnings: []
                    }
                ],
                errors: [],
                modelVersion: 'latest'
            }
        },
        {
            kind: 'ExtractiveSummarization',
            taskName: '',
            lastUpdateDateTime: '2022-10-11T11:12:43.5235045Z',
            status: 'succeeded',
            results: {
                documents: [
                    {
                        id: 'id__3336',
                        sentences: [
                            {
                                text:
                                    'Today, Microsoft Corp. (Nasdaq: MSFT) announced plans to acquire Activision Blizzard Inc. (Nasdaq: ATVI), a leader in game development and interactive entertainment content publisher.',
                                rankScore: 0.82,
                                offset: 264,
                                length: 183
                            },
                            {
                                text:
                                    'This acquisition will accelerate the growth in Microsoft’s gaming business across mobile, PC, console and cloud and will provide building blocks for the metaverse.',
                                rankScore: 0.7,
                                offset: 448,
                                length: 163
                            },
                            {
                                text:
                                    'Microsoft will acquire Activision Blizzard for $95.00 per share, in an all-cash transaction valued at $68.7 billion, inclusive of Activision Blizzard’s net cash.',
                                rankScore: 1,
                                offset: 621,
                                length: 161
                            }
                        ],
                        warnings: []
                    }
                ],
                errors: [],
                modelVersion: 'latest'
            }
        }
    ]
};

export const ConversationSummarizationDemoSamplesJsonOutput: ConversationSummarizationSampleSwaggers = {
    'Setting up WiFi Connection': {
        id: 'id__3649',
        summaries: [
            {
                aspect: 'recap',
                text: 'The customer contacted the service agent, Rene, regarding an issue with setting up a wifi connection for their Smart Brew 300 espresso machine. The agent guided the customer through several steps, including pushing the wifi connection button and checking if the power light was blinking. However, the customer reported that no prompts were received in the Contoso Coffee app to connect with the machine. The agent then decided to look for another solution.',
                contexts: [
                    { conversationItemId: 'id__2219_2220', offset: 0, length: 53 },
                    { conversationItemId: 'id__2219_2221', offset: 0, length: 94 },
                    { conversationItemId: 'id__2219_2222', offset: 0, length: 266 },
                    { conversationItemId: 'id__2219_2223', offset: 0, length: 85 },
                    { conversationItemId: 'id__2219_2224', offset: 0, length: 118 },
                    { conversationItemId: 'id__2219_2225', offset: 0, length: 21 },
                    { conversationItemId: 'id__2219_2226', offset: 0, length: 109 }
                ]
            },
            { aspect: 'issue', text: "Customer wants to connect their Smart Brew 300 to their Wi-Fi. | The Wi-Fi connection didn't work." },
            { aspect: 'resolution', text: 'Recommended customer to check the wifi connection. | Recommended customer to check the contoso coffee app. | Recommended customer to hold on for a minute.' },
            {
                aspect: 'chapterTitle',
                text: 'Setting up WiFi Connection for Smart Brew 300 Espresso Machine',
                contexts: [
                    { conversationItemId: 'id__3649_3650', offset: 0, length: 53 },
                    { conversationItemId: 'id__3649_3651', offset: 0, length: 94 },
                    { conversationItemId: 'id__3649_3652', offset: 0, length: 266 },
                    { conversationItemId: 'id__3649_3653', offset: 0, length: 85 },
                    { conversationItemId: 'id__3649_3654', offset: 0, length: 118 },
                    { conversationItemId: 'id__3649_3655', offset: 0, length: 21 },
                    { conversationItemId: 'id__3649_3656', offset: 0, length: 109 }
                ]
            },
            {
                aspect: 'narrative',
                text: 'Agent helps a customer to set up wifi connection for Smart Brew 300 espresso machine.',
                contexts: [
                    { conversationItemId: 'id__3649_3650', offset: 0, length: 53 },
                    { conversationItemId: 'id__3649_3651', offset: 0, length: 94 },
                    { conversationItemId: 'id__3649_3652', offset: 0, length: 266 },
                    { conversationItemId: 'id__3649_3653', offset: 0, length: 85 },
                    { conversationItemId: 'id__3649_3654', offset: 0, length: 118 },
                    { conversationItemId: 'id__3649_3655', offset: 0, length: 21 },
                    { conversationItemId: 'id__3649_3656', offset: 0, length: 109 }
                ]
            }
        ]
    },
    'Customer complaint': {
        id: 'id__4146',
        summaries: [
            {
                aspect: 'recap',
                text:
                    "The customer, Mr. Smith, contacted the customer service regarding a product he purchased from the company's website. He expressed dissatisfaction with the product, stating that it did not match the picture on the website. The agent explained that the discrepancy was due to the angle of photography and the product's size. The customer also expressed confusion about the product's use. The agent apologized for the shipping representative's late delivery and promised to take action. The agent also offered Mr. Smith a 50% discount on any future products and free shipping.",
                contexts: [
                    { conversationItemId: 'id__4922_4923', offset: 0, length: 5 },
                    { conversationItemId: 'id__4922_4924', offset: 0, length: 38 },
                    { conversationItemId: 'id__4922_4925', offset: 0, length: 18 },
                    { conversationItemId: 'id__4922_4926', offset: 0, length: 107 },
                    { conversationItemId: 'id__4922_4927', offset: 0, length: 71 },
                    { conversationItemId: 'id__4922_4928', offset: 0, length: 57 },
                    { conversationItemId: 'id__4922_4929', offset: 0, length: 2 },
                    { conversationItemId: 'id__4922_4930', offset: 0, length: 62 },
                    { conversationItemId: 'id__4922_4931', offset: 0, length: 3 },
                    { conversationItemId: 'id__4922_4932', offset: 0, length: 64 },
                    { conversationItemId: 'id__4922_4933', offset: 0, length: 104 },
                    { conversationItemId: 'id__4922_4934', offset: 0, length: 191 },
                    { conversationItemId: 'id__4922_4935', offset: 0, length: 57 },
                    { conversationItemId: 'id__4922_4936', offset: 0, length: 183 },
                    { conversationItemId: 'id__4922_4937', offset: 0, length: 70 },
                    { conversationItemId: 'id__4922_4938', offset: 0, length: 172 },
                    { conversationItemId: 'id__4922_4939', offset: 0, length: 2 },
                    { conversationItemId: 'id__4922_4940', offset: 0, length: 25 },
                    { conversationItemId: 'id__4922_4941', offset: 0, length: 106 },
                    { conversationItemId: 'id__4922_4942', offset: 0, length: 437 },
                    { conversationItemId: 'id__4922_4943', offset: 0, length: 3 },
                    { conversationItemId: 'id__4922_4944', offset: 0, length: 56 },
                    { conversationItemId: 'id__4922_4945', offset: 0, length: 81 },
                    { conversationItemId: 'id__4922_4946', offset: 0, length: 228 },
                    { conversationItemId: 'id__4922_4947', offset: 0, length: 12 },
                    { conversationItemId: 'id__4922_4948', offset: 0, length: 44 },
                    { conversationItemId: 'id__4922_4949', offset: 0, length: 75 },
                    { conversationItemId: 'id__4922_4950', offset: 0, length: 94 },
                    { conversationItemId: 'id__4922_4951', offset: 0, length: 23 },
                    { conversationItemId: 'id__4922_4952', offset: 0, length: 45 },
                    { conversationItemId: 'id__4922_4953', offset: 0, length: 2 },
                    { conversationItemId: 'id__4922_4954', offset: 0, length: 33 },
                    { conversationItemId: 'id__4922_4955', offset: 0, length: 22 },
                    { conversationItemId: 'id__4922_4956', offset: 0, length: 99 },
                    { conversationItemId: 'id__4922_4957', offset: 0, length: 2 },
                    { conversationItemId: 'id__4922_4958', offset: 0, length: 54 },
                    { conversationItemId: 'id__4922_4959', offset: 0, length: 10 },
                    { conversationItemId: 'id__4922_4960', offset: 0, length: 2 },
                    { conversationItemId: 'id__4922_4961', offset: 0, length: 20 },
                    { conversationItemId: 'id__4922_4962', offset: 0, length: 64 },
                    { conversationItemId: 'id__4922_4963', offset: 0, length: 114 },
                    { conversationItemId: 'id__4922_4964', offset: 0, length: 75 },
                    { conversationItemId: 'id__4922_4965', offset: 0, length: 32 },
                    { conversationItemId: 'id__4922_4966', offset: 0, length: 67 },
                    { conversationItemId: 'id__4922_4967', offset: 0, length: 144 },
                    { conversationItemId: 'id__4922_4968', offset: 0, length: 290 },
                    { conversationItemId: 'id__4922_4969', offset: 0, length: 19 },
                    { conversationItemId: 'id__4922_4970', offset: 0, length: 85 },
                    { conversationItemId: 'id__4922_4971', offset: 0, length: 2 },
                    { conversationItemId: 'id__4922_4972', offset: 0, length: 179 },
                    { conversationItemId: 'id__4922_4973', offset: 0, length: 12 },
                    { conversationItemId: 'id__4922_4974', offset: 0, length: 87 }
                ]
            },
            { aspect: 'issue', text: 'Customer wants to use the product. | Customer received the product with a different size.' },
            {
                aspect: 'resolution',
                text:
                    'Asked customer if there are any other complaints. | Explained to the customer that the shipping operation was delayed. | Apologized to the customer. | Offered the customer a discount on any product.'
            },
            {
                aspect: 'chapterTitle',
                text: 'Customer Service Number 538879',
                contexts: [
                    { conversationItemId: 'id__4146_4147', offset: 0, length: 5 },
                    { conversationItemId: 'id__4146_4148', offset: 0, length: 38 },
                    { conversationItemId: 'id__4146_4149', offset: 0, length: 18 },
                    { conversationItemId: 'id__4146_4150', offset: 0, length: 107 },
                    { conversationItemId: 'id__4146_4151', offset: 0, length: 71 },
                    { conversationItemId: 'id__4146_4152', offset: 0, length: 57 },
                    { conversationItemId: 'id__4146_4153', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4154', offset: 0, length: 62 },
                    { conversationItemId: 'id__4146_4155', offset: 0, length: 3 },
                    { conversationItemId: 'id__4146_4156', offset: 0, length: 64 },
                    { conversationItemId: 'id__4146_4157', offset: 0, length: 104 },
                    { conversationItemId: 'id__4146_4158', offset: 0, length: 191 },
                    { conversationItemId: 'id__4146_4159', offset: 0, length: 57 },
                    { conversationItemId: 'id__4146_4160', offset: 0, length: 183 },
                    { conversationItemId: 'id__4146_4161', offset: 0, length: 70 },
                    { conversationItemId: 'id__4146_4162', offset: 0, length: 172 },
                    { conversationItemId: 'id__4146_4163', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4164', offset: 0, length: 25 },
                    { conversationItemId: 'id__4146_4165', offset: 0, length: 106 },
                    { conversationItemId: 'id__4146_4166', offset: 0, length: 437 },
                    { conversationItemId: 'id__4146_4167', offset: 0, length: 3 },
                    { conversationItemId: 'id__4146_4168', offset: 0, length: 56 },
                    { conversationItemId: 'id__4146_4169', offset: 0, length: 81 },
                    { conversationItemId: 'id__4146_4170', offset: 0, length: 228 },
                    { conversationItemId: 'id__4146_4171', offset: 0, length: 12 },
                    { conversationItemId: 'id__4146_4172', offset: 0, length: 44 },
                    { conversationItemId: 'id__4146_4173', offset: 0, length: 75 },
                    { conversationItemId: 'id__4146_4174', offset: 0, length: 94 },
                    { conversationItemId: 'id__4146_4175', offset: 0, length: 23 },
                    { conversationItemId: 'id__4146_4176', offset: 0, length: 45 },
                    { conversationItemId: 'id__4146_4177', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4178', offset: 0, length: 33 },
                    { conversationItemId: 'id__4146_4179', offset: 0, length: 22 },
                    { conversationItemId: 'id__4146_4180', offset: 0, length: 99 },
                    { conversationItemId: 'id__4146_4181', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4182', offset: 0, length: 54 },
                    { conversationItemId: 'id__4146_4183', offset: 0, length: 10 },
                    { conversationItemId: 'id__4146_4184', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4185', offset: 0, length: 20 },
                    { conversationItemId: 'id__4146_4186', offset: 0, length: 64 },
                    { conversationItemId: 'id__4146_4187', offset: 0, length: 114 },
                    { conversationItemId: 'id__4146_4188', offset: 0, length: 75 },
                    { conversationItemId: 'id__4146_4189', offset: 0, length: 32 },
                    { conversationItemId: 'id__4146_4190', offset: 0, length: 67 },
                    { conversationItemId: 'id__4146_4191', offset: 0, length: 144 },
                    { conversationItemId: 'id__4146_4192', offset: 0, length: 290 },
                    { conversationItemId: 'id__4146_4193', offset: 0, length: 19 },
                    { conversationItemId: 'id__4146_4194', offset: 0, length: 85 },
                    { conversationItemId: 'id__4146_4195', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4196', offset: 0, length: 179 },
                    { conversationItemId: 'id__4146_4197', offset: 0, length: 12 },
                    { conversationItemId: 'id__4146_4198', offset: 0, length: 87 }
                ]
            },
            {
                aspect: 'narrative',
                text:
                    'The customer complains about the product on the website. The agent explains that the product is different from the picture. The customer is not happy with the shipping agent.',
                contexts: [
                    { conversationItemId: 'id__4146_4147', offset: 0, length: 5 },
                    { conversationItemId: 'id__4146_4148', offset: 0, length: 38 },
                    { conversationItemId: 'id__4146_4149', offset: 0, length: 18 },
                    { conversationItemId: 'id__4146_4150', offset: 0, length: 107 },
                    { conversationItemId: 'id__4146_4151', offset: 0, length: 71 },
                    { conversationItemId: 'id__4146_4152', offset: 0, length: 57 },
                    { conversationItemId: 'id__4146_4153', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4154', offset: 0, length: 62 },
                    { conversationItemId: 'id__4146_4155', offset: 0, length: 3 },
                    { conversationItemId: 'id__4146_4156', offset: 0, length: 64 },
                    { conversationItemId: 'id__4146_4157', offset: 0, length: 104 },
                    { conversationItemId: 'id__4146_4158', offset: 0, length: 191 },
                    { conversationItemId: 'id__4146_4159', offset: 0, length: 57 },
                    { conversationItemId: 'id__4146_4160', offset: 0, length: 183 },
                    { conversationItemId: 'id__4146_4161', offset: 0, length: 70 },
                    { conversationItemId: 'id__4146_4162', offset: 0, length: 172 },
                    { conversationItemId: 'id__4146_4163', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4164', offset: 0, length: 25 },
                    { conversationItemId: 'id__4146_4165', offset: 0, length: 106 },
                    { conversationItemId: 'id__4146_4166', offset: 0, length: 437 },
                    { conversationItemId: 'id__4146_4167', offset: 0, length: 3 },
                    { conversationItemId: 'id__4146_4168', offset: 0, length: 56 },
                    { conversationItemId: 'id__4146_4169', offset: 0, length: 81 },
                    { conversationItemId: 'id__4146_4170', offset: 0, length: 228 },
                    { conversationItemId: 'id__4146_4171', offset: 0, length: 12 },
                    { conversationItemId: 'id__4146_4172', offset: 0, length: 44 },
                    { conversationItemId: 'id__4146_4173', offset: 0, length: 75 },
                    { conversationItemId: 'id__4146_4174', offset: 0, length: 94 },
                    { conversationItemId: 'id__4146_4175', offset: 0, length: 23 },
                    { conversationItemId: 'id__4146_4176', offset: 0, length: 45 },
                    { conversationItemId: 'id__4146_4177', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4178', offset: 0, length: 33 },
                    { conversationItemId: 'id__4146_4179', offset: 0, length: 22 },
                    { conversationItemId: 'id__4146_4180', offset: 0, length: 99 },
                    { conversationItemId: 'id__4146_4181', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4182', offset: 0, length: 54 },
                    { conversationItemId: 'id__4146_4183', offset: 0, length: 10 },
                    { conversationItemId: 'id__4146_4184', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4185', offset: 0, length: 20 },
                    { conversationItemId: 'id__4146_4186', offset: 0, length: 64 },
                    { conversationItemId: 'id__4146_4187', offset: 0, length: 114 },
                    { conversationItemId: 'id__4146_4188', offset: 0, length: 75 },
                    { conversationItemId: 'id__4146_4189', offset: 0, length: 32 },
                    { conversationItemId: 'id__4146_4190', offset: 0, length: 67 },
                    { conversationItemId: 'id__4146_4191', offset: 0, length: 144 },
                    { conversationItemId: 'id__4146_4192', offset: 0, length: 290 },
                    { conversationItemId: 'id__4146_4193', offset: 0, length: 19 },
                    { conversationItemId: 'id__4146_4194', offset: 0, length: 85 },
                    { conversationItemId: 'id__4146_4195', offset: 0, length: 2 },
                    { conversationItemId: 'id__4146_4196', offset: 0, length: 179 },
                    { conversationItemId: 'id__4146_4197', offset: 0, length: 12 },
                    { conversationItemId: 'id__4146_4198', offset: 0, length: 87 }
                ]
            }
        ]
    }
};
